// English catalogue (source of AppTranslations).

export const en = {
  amenities: {
    categories: {
      culture: 'Culture and Entertainment',
      dining: 'Dining and Drinking',
      education: 'Education',
      grocery: 'Grocery',
      healthcare: 'Healthcare',
      services: 'Basic Amenities',
      shopping: 'Shopping',
      transport: 'Transport',
      wellness: 'Wellness',
    },
    categoryCard: {
      clearFilters: 'Clear filters',
      moreSubcategories: '+{{count}} more',
      noAmenities: 'No amenities found in this category',
      noMatchingFilters: 'No amenities match the current filters',
      showAll: 'Show all {{count}} more',
      showingItems: 'Showing {{count}} of {{total}} items',
      showMore: 'Show 10 more ({{count}} remaining)',
    },
    error: {
      retry: 'Retry',
      title: 'Unable to load amenities data',
    },
    livabilityScore: 'Livability Score',
    loading: {
      description: 'Analyzing nearby points of interest and calculating livability score',
      title: 'Loading amenities data...',
    },
    noData: 'No amenities data available',
    pointsOfInterest: 'Points of interest',
    poiTypes: {
      adult_gaming_centre: 'Adult Gaming Centre',
      alcohol: 'Alcohol Shop',
      amusement_arcade: 'Amusement Arcade',
      anime: 'Anime Shop',
      antiques: 'Antiques',
      appliance: 'Appliance Store',
      aquarium: 'Aquarium',
      art: 'Art Shop',
      art_culture: 'Art and Culture',
      art_music_hobbies: 'Art, Music and Hobbies',
      arts_centre: 'Arts Centre',
      atm: 'ATM',
      atv: 'ATV Shop',
      baby_goods: 'Baby Goods',
      bag: 'Bag Shop',
      bakery: 'Bakery',
      bandstand: 'Bandstand',
      bank: 'Bank',
      bar: 'Bar',
      bathroom_furnishing: 'Bathroom Furnishing',
      beauty: 'Beauty Salon',
      bed: 'Bed Shop',
      beverages: 'Beverages',
      bicycle: 'Bicycle Shop',
      biergarten: 'Beer Garden',
      boat: 'Boat Shop',
      boat_stop: 'Boat Stop',
      bookmaker: 'Bookmaker',
      books: 'Bookshop',
      books_gifts: 'Books and Gifts',
      boutique: 'Boutique',
      bowling_alley: 'Bowling Alley',
      brewing_supplies: 'Brewing Supplies',
      bus_stop: 'Bus Stop',
      butcher: 'Butcher',
      cable_car_stop: 'Cable Car Stop',
      cafe: 'Cafe',
      camera: 'Camera Shop',
      candles: 'Candle Shop',
      cannabis: 'Cannabis Shop',
      car: 'Car Dealer',
      car_parts: 'Car Parts',
      car_repair: 'Car Repair',
      carpet: 'Carpet Shop',
      casino: 'Casino',
      cheese: 'Cheese Shop',
      chemist: 'Chemist',
      chocolate: 'Chocolate Shop',
      cinema: 'Cinema',
      climbing: 'Climbing',
      clinic: 'Clinic',
      clothes: 'Clothing Store',
      clothing: 'Clothing',
      coffee: 'Coffee Shop',
      collector: 'Collector Shop',
      college: 'College',
      community_centre: 'Community Centre',
      computer: 'Computer Shop',
      confectionery: 'Confectionery',
      convenience: 'Convenience Store',
      copyshop: 'Copy Shop',
      cosmetics: 'Cosmetics',
      craft: 'Craft Shop',
      curtain: 'Curtain Shop',
      dairy: 'Dairy',
      dance: 'Dance',
      deli: 'Delicatessen',
      dentist: 'Dentist',
      department_store: 'Department Store',
      doctor: 'Doctor',
      doityourself: 'DIY Store',
      doors: 'Door Shop',
      dry_cleaning: 'Dry Cleaning',
      'e-cigarette': 'E-Cigarette Shop',
      electrical: 'Electrical Shop',
      electronics: 'Electronics',
      energy: 'Energy Shop',
      escape_game: 'Escape Game',
      fabric: 'Fabric Shop',
      farm: 'Farm Shop',
      fashion: 'Fashion',
      fast_food: 'Fast Food',
      financial: 'Financial Services',
      fireplace: 'Fireplace Shop',
      fishing: 'Fishing Shop',
      fitness_centre: 'Fitness Centre',
      flooring: 'Flooring Shop',
      florist: 'Florist',
      food_court: 'Food Court',
      frame: 'Frame Shop',
      free_flying: 'Free Flying',
      frozen_food: 'Frozen Food',
      fuel: 'Fuel Station',
      fuel_station: 'Fuel Station',
      funeral_directors: 'Funeral Directors',
      furniture: 'Furniture Store',
      gallery: 'Gallery',
      games: 'Games Shop',
      garden_centre: 'Garden Centre',
      garden_furniture: 'Garden Furniture',
      general: 'General Store',
      gift: 'Gift Shop',
      golf_course: 'Golf Course',
      greengrocer: 'Greengrocer',
      hairdresser: 'Hairdresser',
      hairdresser_supply: 'Hairdresser Supply',
      hardware: 'Hardware Store',
      health_beauty_store: 'Health and Beauty Store',
      health_food: 'Health Food',
      hearing_aids: 'Hearing Aids',
      herbalist: 'Herbalist',
      hifi: 'Hi-Fi Shop',
      horse_riding: 'Horse Riding',
      hospital: 'Hospital',
      hospital_clinic: 'Hospital and Clinic',
      houseware: 'Houseware',
      hunting: 'Hunting Shop',
      ice_cream: 'Ice Cream',
      ice_rink: 'Ice Rink',
      interior_decoration: 'Interior Decoration',
      jetski: 'Jetski Shop',
      jewelry: 'Jewelry Shop',
      kindergarten: 'Kindergarten',
      kiosk: 'Kiosk',
      kitchen: 'Kitchen Shop',
      lamps: 'Lamp Shop',
      laundry: 'Laundry',
      leather: 'Leather Goods',
      leisure_tourism: 'Leisure and Tourism',
      library: 'Library',
      locksmith: 'Locksmith',
      lottery: 'Lottery',
      mall: 'Shopping Mall',
      massage: 'Massage',
      medical_supply: 'Medical Supply',
      metro_station: 'Metro Station',
      miniature_golf: 'Miniature Golf',
      mobile_phone: 'Mobile Phone Shop',
      model: 'Model Shop',
      money_lender: 'Money Lender',
      motorcycle: 'Motorcycle Shop',
      museum: 'Museum',
      music: 'Music Shop',
      music_school: 'Music School',
      musical_instrument: 'Musical Instruments',
      newsagent: 'Newsagent',
      nightclub: 'Nightclub',
      nutrition_supplements: 'Nutrition Supplements',
      optician: 'Optician',
      organic: 'Organic Shop',
      other_sport: 'Other Sport',
      outdoor: 'Outdoor Shop',
      outdoors_sport_vehicles: 'Outdoor, Sports and Vehicles',
      paint: 'Paint Shop',
      park: 'Park',
      park_forest: 'Park and Forest',
      party: 'Party Shop',
      pasta: 'Pasta Shop',
      pastry: 'Pastry Shop',
      perfumery: 'Perfumery',
      pet: 'Pet Shop',
      pharmacy: 'Pharmacy',
      photo: 'Photo Shop',
      picnic_site: 'Picnic Site',
      pitch: 'Sports Pitch',
      planetarium: 'Planetarium',
      plant_flower: 'Plants and Flowers',
      playground: 'Playground',
      post_box: 'Post Box',
      post_office: 'Post Office',
      pub: 'Pub',
      pyrotechnics: 'Pyrotechnics',
      radiotechnics: 'Radio Electronics',
      recycling: 'Recycling Point',
      religion: 'Religious Shop',
      restaurant: 'Restaurant',
      robot: 'Robot Shop',
      running: 'Running Track',
      sailing: 'Sailing',
      school: 'School',
      scuba_diving: 'Scuba Diving',
      seafood: 'Seafood Shop',
      second_hand: 'Second Hand',
      security: 'Security Shop',
      sewing: 'Sewing Shop',
      shoes: 'Shoe Shop',
      shooting: 'Shooting Range',
      shopping_others: 'Other Shops',
      skateboard: 'Skateboard',
      ski: 'Ski Shop',
      snowmobile: 'Snowmobile',
      social_centre: 'Social Centre',
      specialty_food: 'Specialty Food Store',
      spices: 'Spice Shop',
      sport_centre: 'Sports Centre',
      sports: 'Sports Shop',
      sports_centre: 'Sports Centre',
      stadium: 'Stadium',
      station: 'Train Station',
      stationery: 'Stationery',
      subway_entrance: 'Subway Entrance',
      supermarket: 'Supermarket',
      swimming: 'Swimming',
      swimming_area: 'Swimming Area',
      swimming_pool: 'Swimming Pool',
      tailor: 'Tailor',
      tattoo: 'Tattoo Shop',
      tea: 'Tea Shop',
      theatre: 'Theatre',
      theme_park: 'Theme Park',
      ticket: 'Ticket Shop',
      tobacco: 'Tobacco Shop',
      toys: 'Toy Shop',
      trade: 'Trade Shop',
      train_station: 'Train Station',
      tram_stop: 'Tram Stop',
      travel_agency: 'Travel Agency',
      trophy: 'Trophy Shop',
      tyres: 'Tyre Shop',
      university: 'University',
      vacant: 'Vacant',
      vacuum_cleaner: 'Vacuum Cleaner Shop',
      variety_store: 'Variety Store',
      video: 'Video Shop',
      video_games: 'Video Games',
      watches: 'Watch Shop',
      water: 'Water Shop',
      weapons: 'Weapons Shop',
      wholesale: 'Wholesale',
      wine: 'Wine Shop',
      wood: 'Wood Shop',
      zoo: 'Zoo',
    },
    radius: 'Radius',
    sources: {
      googlePlaces: 'Google Places',
      label: 'Sources:',
      openStreetMap: 'OpenStreetMap',
      swissFederalStatisticalOffice: 'Swiss Federal Statistical Office',
    },
    subcategories: {
      'Art & Culture': 'Art & Culture',
      'Art, music, hobbies': 'Art, music, hobbies',
      Bar: 'Bar',
      'Bus & Subway': 'Bus & Subway',
      Cafe: 'Cafe',
      'Clothing, shoes, accessories': 'Clothing, shoes, accessories',
      Convenience: 'Convenience',
      Dentist: 'Dentist',
      Doctor: 'Doctor',
      Electronics: 'Electronics',
      Financial: 'Financial',
      'Fuel Station': 'Fuel Station',
      'Furniture and interior': 'Furniture and interior',
      'Health and beauty': 'Health and beauty',
      'Hospital & Clinic': 'Hospital & Clinic',
      Kindergarten: 'Kindergarten',
      'Leisure & Tourism': 'Leisure & Tourism',
      Mall: 'Mall',
      'Other Sport': 'Other Sport',
      Others: 'Others',
      'Outdoor activity': 'Outdoor activity',
      'Outdoors and sport, vehicles': 'Outdoors and sport, vehicles',
      'Park and Forest': 'Park and Forest',
      Pharmacy: 'Pharmacy',
      Pitch: 'Pitch',
      'Plant and flower': 'Plant and flower',
      Playground: 'Playground',
      'Public Utility': 'Public Utility',
      'Railway Station': 'Railway Station',
      Restaurant: 'Restaurant',
      School: 'School',
      'Specialty food store': 'Specialty food store',
      'Sport Centre': 'Sport Centre',
      'Stationery, gifts, books, newspapers': 'Stationery, gifts, books, newspapers',
      Supermarket: 'Supermarket',
      Swimming: 'Swimming',
      University: 'University',
    },
    subtitle: 'Local amenities and points of interest analysis',
    title: 'Amenities',
    transitModes: {
      BOAT: 'Boat',
      BUS: 'Bus',
      CABLE_CAR: 'Cable car',
      CABLE_RAILWAY: 'Funicular',
      CHAIRLIFT: 'Chairlift',
      METRO: 'Metro',
      RACK_RAILWAY: 'Rack railway',
      TRAIN: 'Train',
      TRAM: 'Tram',
    },
    walkTime: 'Walk time',
  },
  buildingAnalysis: {
    amenities: {
      loading: 'Loading amenities...',
      other_category: 'Other',
      unknown_amenity: 'Unknown',
    },
    building_title: 'Building {{egid}}',
    built_year: 'Built {{year}}',
    enums: {
      buildingCategory: {
        "Bâtiment d'habitation avec usage annexe": 'Residential building with ancillary use',
        "Bâtiment exclusivement à usage d'habitation": 'Building exclusively for residential use',
        "Bâtiment partiellement à usage d'habitation": 'Building partially for residential use',
        "Bâtiment sans usage d'habitation": 'Building without residential use',
        'Construction particulière': 'Special construction',
        'Habitation provisoire': 'Temporary housing',
      },
      buildingClass: {
        'Autre bâtiment non classé ailleurs': 'Other unclassified building',
        "Autres bâtiments d'exploitation agricole": 'Other agricultural buildings',
        "Autres bâtiments d'hébergement de tourisme": 'Other tourism accommodation',
        "Autres bâtiments pour l'hébergement collectif": 'Other collective housing',
        "Bâtiment d'exploitation agricole": 'Agricultural building',
        'Bâtiment industriel': 'Industrial building',
        'Bâtiments commerciaux': 'Commercial building',
        "Bâtiments pour la garde d'animaux": 'Animal shelter buildings',
        'Bâtiments pour les cultures végétales': 'Plant cultivation buildings',
        Garage: 'Garage',
        'Gares, aérogares, centraux téléphoniques': 'Stations, terminals, telephone exchanges',
        'Habitat communautaire': 'Community housing',
        'Hôpital et établissement de santé': 'Hospital and healthcare facility',
        'Immeuble à trois logements et plus': 'Building with 3+ units',
        'Maison à deux logements': 'Two-unit dwelling',
        'Maison individuelle': 'Single-family house',
        'Monument historique ou classé': 'Historic or protected monument',
        'Réservoir, silo et entrepôt': 'Tank, silo and warehouse',
        'Salle de sport': 'Sports facility',
        'Salles de tir': 'Shooting range',
      },
      buildingStatus: {
        autorisé: 'Approved',
        démoli: 'Demolished',
        'en construction': 'Under construction',
        existant: 'Existing',
        inutilisable: 'Unusable',
        'non réalisé': 'Not realized',
        projeté: 'Planned',
      },
    },
    environment: {
      loading: 'Loading environment data...',
      noise_levels: {
        moderate: 'Moderate',
        noisy: 'Noisy',
        quiet: 'Quiet',
        very_noisy: 'Very Noisy',
        very_quiet: 'Very Quiet',
      },
      sunlight_ratings: {
        excellent: 'Excellent',
        fair: 'Fair',
        good: 'Good',
        poor: 'Poor',
      },
    },
    error_loading_data: 'Error loading data',
    feasibility: {
      considerations: {
        excellent_transport: 'Excellent public transport access ({{quality}}) enhances property value',
        high_energy: 'High energy consumption may deter environmentally conscious buyers',
        minergie: 'Minergie certification indicates lower operating costs',
        moderate_age: 'Moderate building age ({{age}} years) may require gradual upgrades',
        multiple_owners: 'Multiple owners ({{count}}) may complicate decision-making',
        old_building: 'Building age ({{age}} years) may require significant renovation investment',
        protected_status: 'Protected status may restrict renovation options but preserve value',
        recent_activity: 'Recent transaction activity indicates healthy market demand',
        solar_potential: 'Significant solar potential ({{area}}m²) can offset energy costs',
        title: 'Key Considerations',
      },
      financial: {
        appreciation: {
          description: 'Long-term value growth potential based on location and market factors',
          label: 'Value Appreciation Potential',
        },
        capital: {
          description: 'Expected renovation and upgrade costs based on building condition',
          label: 'Capital Requirements',
        },
        complexity: {
          description: 'Transaction and decision-making complexity based on ownership structure',
          label: 'Investment Complexity',
        },
        operating: {
          description: 'Ongoing energy and maintenance costs based on efficiency standards',
          label: 'Operating Costs',
        },
        title: 'Financial Feasibility Indicators',
      },
      metrics: {
        building_age: {
          built_in: 'Built in {{year}}',
          title: 'Building Age',
          tooltip: {
            calculation: 'Current year minus construction year',
            description: 'Age of the building since original construction',
            importance: 'Affects renovation needs, structural concerns, and investment timeline',
            limitations: 'Does not reflect major reconstructions or upgrades',
            source: 'Swiss Building Registry (GWR)',
            title: 'Building Age Assessment',
          },
          value: '{{years}} years',
        },
        market_activity: {
          last_transaction: 'Last transaction: {{year}}',
          title: 'Market Activity',
          tooltip: {
            calculation: 'Count of recent transactions and active listings',
            description: 'Recent transactions and listing activity',
            importance: 'Indicates market liquidity and investment interest',
            limitations: 'Historical data, not predictive of future activity',
            source: 'Transaction and listing databases',
            title: 'Recent Market Activity',
          },
          value: '{{count}} listings',
        },
        ownership: {
          breakdown: '{{private}} private, {{public}} public',
          title: 'Ownership Structure',
          tooltip: {
            calculation: 'Count of registered land owners',
            description: 'Number and type of property owners',
            importance: 'Affects decision-making complexity and transaction processes',
            limitations: 'Based on land registry, may not reflect all stakeholders',
            source: 'Swiss Land Registry',
            title: 'Ownership Complexity',
          },
          value: '{{count}} owner',
          value_plural: '{{count}} owners',
        },
        renovation: {
          no_renovation: 'No renovation',
          renovated_in: 'Renovated in {{year}}',
          title: 'Renovation Status',
          tooltip: {
            calculation: 'Years since last recorded renovation',
            description: 'Time since last major renovation',
            importance: 'Indicates maintenance needs and potential investment requirements',
            limitations: 'Based on official records, may not include minor upgrades',
            source: 'Swiss Building Registry (GWR)',
            title: 'Renovation Timeline',
          },
          value: '{{years}} years ago',
        },
      },
      no_data: 'No feasibility study data is available for this building.',
      risk_assessment: {
        energy: {
          description: 'Risk of non-compliance with energy standards. May require upgrades to meet current regulations.',
          title: 'Energy Compliance Risk',
        },
        market: {
          description: 'Market liquidity and demand indicators. Lower risk suggests better exit opportunities.',
          title: 'Market Risk',
        },
        renovation: {
          description: 'Assessment of renovation needs based on age and maintenance history. Higher risk indicates greater capital requirements.',
          title: 'Renovation Risk',
        },
        structural: {
          description: 'Based on building age and structural indicators. Older buildings may require more extensive structural assessments.',
          title: 'Structural Risk',
        },
        title: 'Risk Assessment',
      },
      risk_levels: {
        high: 'High Risk',
        low: 'Low Risk',
        medium: 'Moderate Risk',
      },
      subtitle: 'Investment viability and risk assessment',
      title: 'Feasibility Study',
      values: {
        high: 'High',
        low: 'Low',
        moderate: 'Moderate',
        variable: 'Variable',
      },
    },
    history: {
      empty_state: {
        no_data: {
          description: 'No historical events or timeline data is available for this building. This could be due to limited records or recent construction.',
          title: 'No Historical Data Available',
        },
        no_matches: {
          description: 'Try adjusting your filters to see more historical events.',
          title: 'No Events Match Your Filters',
        },
      },
      events: {
        building_permit: 'Building Permit',
        for_rent: '{{propertyType}} for Rent',
        for_sale: '{{propertyType}} for Sale',
        property_transaction: 'Property Transaction',
        rental_listing: 'Rental Listing',
        sale_listing: 'Sale Listing',
      },
      filters: {
        building_permits: 'Building Permits',
        rentals: 'Rentals',
        sales: 'Sales',
        transactions: 'Transactions',
      },
      labels: {
        online_days: 'Online {{count}} days',
        owner: 'Owner: {{name}}',
        participants: '{{count}} participants',
        permit_number: 'Permit #{{number}}',
        properties_one: '{{count}} property',
        properties_other: '{{count}} properties',
        status_active: 'Active',
        status_inactive: 'Inactive',
      },
    },
    listings: {
      filters: {
        any: 'Any',
      },
      loading: 'Loading listings...',
    },
    loading: 'Loading building analysis...',
    loading_failed: 'Failed to load building analysis data',
    market: {
      available: 'Available',
      loading: 'Loading market data...',
      no_listings: 'No Listings',
      properties: 'Properties',
      purchase: 'Purchase',
      rental: 'Rental',
      rentals: 'Rentals',
    },
    overview: {
      building_overview: 'Building Overview',
      elevator: 'Elevator',
      property_features: 'Property Features',
    },
    section_not_shared: {
      description: 'The {{sectionName}} section was not included in this shared analysis.',
      title: 'Section Not Shared',
    },
    sidebar: {
      items: {
        amenities: 'Amenities',
        buildingCharacteristics: 'Building Characteristics',
        buildingPermits: 'Building Permits',
        demographics: 'Demographics',
        electricity: 'Electricity',
        employment: 'Employment',
        energy: 'Energy',
        history: 'History',
        noiseAnalysis: 'Noise Analysis',
        purchaseListings: 'Purchase Listings',
        purchaseMarket: 'Purchase Market',
        rentalListings: 'Rental Listings',
        rentalMarket: 'Rental Market',
        summary: 'Summary',
        sunlightStudy: 'Sunlight Study',
        taxes: 'Taxes',
        transactions: 'Transactions',
        transportAccess: 'Transport & Access',
        unitDetails: 'Unit Details',
      },
      sections: {
        development: 'Development',
        environment: 'Environment',
        market: 'Market',
        overview: 'Overview',
        socialEconomic: 'Social & Economic',
      },
    },
    summaryTab: {
      activity: {
        buildingPermits: 'Building Permits',
        listingDetail_one: '{{count}} listing, last in {{year}}',
        listingDetail_other: '{{count}} listings, last in {{year}}',
        noData: 'No data available',
        permitDetail_one: '{{count}} permit, last in {{year}}',
        permitDetail_other: '{{count}} permits, last in {{year}}',
        recentTransactions: 'Recent Transactions',
        rentalListings: 'Rental Listings',
        saleListings: 'Sale Listings',
        transactionDetail_one: '{{count}} transaction, last in {{year}}',
        transactionDetail_other: '{{count}} transactions, last in {{year}}',
      },
      error: 'Error loading summary:',
      labels: {
        address: 'Address',
        buildingCategory: 'Building Category',
        buildingType: 'Building Type',
        district: 'District',
        egid: 'Building ID (EGID)',
        institutionalOwners: 'Institutional Owners',
        municipality: 'Municipality',
        numberOfOwners: 'Number of Owners',
        privateOwners: 'Private Owners',
        publicOwners: 'Public Owners',
        status: 'Status',
        unknown: 'Unknown',
      },
      loading: 'Loading building summary...',
      metrics: {
        buildingVolume: {
          subtext: 'm3',
          title: 'Building Volume',
          tooltip: {
            calculation: 'Calculated from building footprint and height measurements',
            importance: 'Used for insurance calculations and building regulations',
            shortDescription: 'Total cubic volume of the building structure',
            source: 'Federal Building Registry (GWR)',
            title: 'Building Volume',
          },
        },
        dwellingArea: {
          subtext: 'Median unit: {{value}}m2',
          title: 'Dwelling Area',
          tooltip: {
            calculation: 'Sum of dwelling areas from all registered units',
            importance: 'Key indicator for rental value and living capacity',
            shortDescription: 'Sum of all living areas in the building',
            source: 'Federal Building Registry (GWR)',
            title: 'Total Dwelling Area',
          },
        },
        floors: {
          subtext: 'Height: {{value}}m',
          title: 'Floors',
          tooltip: {
            calculation: 'Includes ground floor and all upper levels',
            importance: 'Important for elevator requirements and accessibility regulations',
            shortDescription: 'Total number of above-ground floors',
            source: 'Federal Building Registry (GWR)',
            title: 'Number of Floors',
          },
        },
        totalArea: {
          subtext: 'Median unit: {{value}}m2',
          title: 'Total Area',
          tooltip: {
            calculation: 'Sum of all floor areas from the Federal Building Registry (GWR)',
            importance: 'Key metric for understanding building capacity and potential rental/sale value',
            limitations: 'Does not include common areas, parking, or storage spaces',
            shortDescription: 'The combined floor area of all units in the building',
            source: 'Federal Building Registry (GWR)',
            title: 'Total Building Area',
          },
        },
        units: {
          subtext: 'Median: {{value}} rooms',
          title: 'Units',
          tooltip: {
            calculation: 'Count of registered dwelling units from federal registry',
            importance: 'Essential for understanding building density and investment potential',
            shortDescription: 'Total count of dwelling units in the building',
            source: 'Federal Building Registry (GWR)',
            title: 'Number of Units',
          },
        },
        yearBuilt: {
          subtext: 'Renovated: {{value}}',
          title: 'Year Built',
          tooltip: {
            importance: 'Affects building regulations, renovation needs, and property value',
            shortDescription: 'The year when the building was originally constructed',
            source: 'Federal Building Registry (GWR)',
            title: 'Construction Year',
          },
        },
      },
      noData: 'No building data available',
      sections: {
        buildingInfo: 'Building Information',
        ownership: 'Ownership',
        recentActivity: 'Recent Activity',
      },
      subtitle: 'Overview of {{address}}, {{municipality}}',
      title: 'Building Summary',
    },
    tabs: {
      amenities: 'Amenities',
      history: 'History',
      noise: 'Noise',
      overview: 'Overview',
      purchase_market: 'Purchase Market',
      rental_market: 'Rental Market',
      sunlight: 'Sunlight',
      transactions: 'Transactions',
      units: 'Units',
    },
    title: 'Building Analysis',
    transactions: {
      loading: 'Loading transaction data...',
      types: {
        all_types: 'All Types',
        auction: 'Auction',
        rental: 'Rental',
        sale: 'Sale',
      },
    },
    units: {
      balcony: 'Balcony',
      floor: 'Floor',
      unknown_floor: 'Unknown Floor',
    },
  },
  buildings: {
    characteristics: {
      common: {
        na: 'N/A',
        no: 'No',
        source: 'Data from Federal Register of Buildings and Dwellings (RBD)',
        sourceCalculated: 'Calculated from available building data',
        years: 'years',
        yes: 'Yes',
      },
      header: {
        subtitle: 'Comprehensive physical, historical, and comparative analysis of the building',
        title: 'Building Characteristics',
      },
      neighborhood: {
        ageRanges: {
          '1919_1945': '1919-45',
          '1946_1960': '1946-60',
          '1961_1970': '1961-70',
          '1971_1980': '1971-80',
          '1981_1990': '1981-90',
          '1991_2000': '1991-00',
          '2001_2010': '2001-10',
          '2011_2020': '2011-20',
          post2020: 'Post-2020',
          pre1919: 'Pre-1919',
        },
        badges: {
          buildingOutlier: '⚠️ Building Outlier',
        },
        cards: {
          ageDistribution: {
            title: 'Building Age Distribution',
          },
          areaComparison: {
            title: 'Footprint Area Comparison',
            tooltip: {
              calculation: "Compares this building's ground floor area with the average and maximum areas of neighboring buildings",
              description: "How this building's footprint compares to surrounding buildings",
              importance: 'Building footprint relative to neighbors indicates land use intensity, development density, and whether the building is typical for the area.',
              limitations: "Footprint alone doesn't reflect total building size. Check floor count and gross floor area for complete size assessment.",
              title: 'Area Comparison with Neighbors',
            },
          },
          cohesionBreakdown: {
            title: 'Cohesion Breakdown',
          },
          comparativeAnalysis: {
            title: 'Comparative Analysis',
          },
          conformityBreakdown: {
            title: 'Building Conformity Breakdown',
            tooltip: {
              calculation: "Compares this building's characteristics against the typical quartier profile",
              description: 'Shows how well this specific building matches the quartier pattern',
              importance: 'Low conformity in a cohesive quartier indicates an outlier building, which may affect valuation, development restrictions, or architectural harmony.',
              title: 'Building Conformity Breakdown',
            },
          },
          heightComparison: {
            title: 'Height Comparison',
            tooltip: {
              calculation: "Compares this building's total height with the average and maximum heights of neighboring buildings within a defined radius (typically 100-200m)",
              description: "How this building's height compares to surrounding buildings",
              importance: 'Building height relative to neighbors affects views, sunlight exposure, privacy, architectural harmony, and compliance with local zoning regulations.',
              limitations: 'Comparison based on buildings within the search radius. Local topography and terrain elevation differences are not reflected in this metric.',
              title: 'Height Comparison with Neighbors',
            },
          },
          neighborhoodAnalysis: {
            title: 'Neighborhood & Building Analysis',
            tooltip: {
              calculation: 'Neighborhood Cohesion measures how similar surrounding buildings are. Building Conformity measures how well THIS building matches the neighborhood pattern.',
              description: 'Analyzes both neighborhood cohesion and how well this building fits into the detected quartier',
              importance: 'High cohesion with low conformity indicates an outlier building in a cohesive neighborhood, which may affect valuation and development potential.',
              title: 'Neighborhood & Building Analysis',
            },
          },
          quartierProfile: {
            title: 'Quartier Profile',
          },
          volumeComparison: {
            title: 'Volume Comparison',
            tooltip: {
              calculation: "Compares this building's total enclosed volume with the average and maximum volumes of neighboring buildings",
              description: "How this building's total volume compares to surrounding buildings",
              importance: 'Building volume is a key indicator of total building mass and development intensity. Used for energy modeling and HVAC capacity planning.',
              limitations: 'Volume calculations may use simplified geometric assumptions. Actual internal volume may vary due to roof geometry and interior layouts.',
              title: 'Volume Comparison with Neighbors',
            },
          },
        },
        chart: {
          areaAxis: 'Area (m²)',
          buildingsAxis: 'Buildings',
          heightAxis: 'Height (m)',
          neighborhoodAvg: 'Neighborhood Avg',
          neighborhoodMax: 'Neighborhood Max',
          thisBuilding: 'This Building',
          volumeAxis: 'Volume (m³)',
        },
        cohesion: {
          density: {
            label: 'Density Cohesion (10%)',
            tooltip: {
              calculation: 'Based on the number of buildings per square kilometer. Higher density suggests urban quartier.',
              description: 'Measures development density',
              title: 'Density Cohesion',
            },
          },
          physical: {
            label: 'Physical Cohesion (30%)',
            tooltip: {
              calculation: 'Based on similarity in height, area, and floor count. Higher scores indicate uniform building characteristics.',
              description: 'Measures architectural similarity',
              title: 'Physical Cohesion',
            },
          },
          temporal: {
            label: 'Temporal Cohesion (40%)',
            tooltip: {
              calculation: 'Based on similarity of construction years. Higher scores indicate buildings from the same era.',
              description: 'Measures if buildings were constructed in the same period',
              title: 'Temporal Cohesion',
            },
          },
          typological: {
            label: 'Typological Cohesion (20%)',
            tooltip: {
              calculation: 'Based on the prevalence of similar building categories (e.g., single-family, multi-family, etc.)',
              description: 'Measures building type similarity',
              title: 'Typological Cohesion',
            },
          },
        },
        comparison: {
          aboveAverage: '{{percent}}% above average',
          belowAverage: '{{percent}}% below average',
          similar: 'Similar to average',
        },
        conformity: {
          fitsWell: 'Fits well',
          outlier: 'Outlier',
          partialFit: 'Partial fit',
          physicalMatch: {
            label: 'Physical Match (40%)',
            tooltip: {
              calculation: 'Average of height, area, and floor count similarity. ±20-30% = high match',
              description: "How well this building's size and height match the typical quartier",
              title: 'Physical Match',
            },
          },
          temporalMatch: {
            label: 'Temporal Match (40%)',
            tooltip: {
              calculation: 'Compares building year against typical year. ±5 years = 100%, ±10 years = 75%, ±20 years = 50%',
              description: "How well this building's construction year matches the typical quartier period",
              title: 'Temporal Match',
            },
          },
          typologicalMatch: {
            label: 'Typological Match (20%)',
            tooltip: {
              calculation: '100 if same category as typical, 0 if different',
              description: "Whether this building's type matches the dominant quartier category",
              title: 'Typological Match',
            },
          },
        },
        errors: {
          loadFailed: 'Failed to load neighborhood analysis',
        },
        loading: 'Loading neighborhood analysis...',
        metrics: {
          areaVsAverage: {
            label: 'Area vs Average',
            tooltip: {
              calculation: 'Percentage difference from mean area of buildings within search radius',
              description: "How this building's footprint compares to nearby buildings",
              importance: 'Indicates if building is typical or unusually large/small for the area. Affects FAR and development potential.',
              title: 'Area vs Neighborhood Average',
            },
          },
          avgNeighborAge: {
            label: 'Avg Neighbor Age',
            tooltip: {
              calculation: 'Average of ages of all buildings within search radius',
              description: 'Mean age of surrounding buildings',
              importance: 'Indicates if the neighborhood is predominantly old (>50 years), established (20-50 years), or new (<20 years).',
              title: 'Average Neighbor Age',
            },
            value: '{{years}} years',
          },
          buildingConformity: 'Building Conformity',
          buildingDensity: {
            label: 'Building Density',
            tooltip: {
              calculation: 'Count of buildings within a defined radius divided by the area of that radius',
              description: 'Number of buildings per unit area in the surrounding area',
              importance: 'Indicates whether the area is urban, suburban, or rural. High density suggests urban environment with closer buildings.',
              title: 'Building Density',
            },
            value: '{{density}} buildings/km²',
          },
          buildingsAnalyzed: 'Buildings Analyzed',
          confidence: 'Confidence',
          heightVsAverage: {
            label: 'Height vs Average',
            tooltip: {
              calculation: 'Percentage difference from mean height of buildings within search radius',
              description: "How this building's height compares to nearby buildings",
              importance: 'Buildings significantly taller or shorter than neighbors may face zoning restrictions or stand out visually.',
              title: 'Height vs Neighborhood Average',
            },
          },
          neighborhoodCohesion: 'Neighborhood Cohesion',
          neighboringBuildings: {
            label: 'Neighboring Buildings',
            tooltip: {
              calculation: 'Number of buildings found within the selected search radius',
              description: 'Count of buildings within the analysis radius',
              importance: 'More neighbors provide better statistical comparison. Fewer than 10 neighbors may indicate rural area or limited data reliability.',
              title: 'Neighboring Buildings',
            },
          },
          volumeVsAverage: {
            label: 'Volume vs Average',
            tooltip: {
              calculation: 'Percentage difference from mean volume of buildings within search radius',
              description: "How this building's volume compares to nearby buildings",
              importance: 'Larger volumes indicate more substantial structures. Affects heating costs and development density.',
              title: 'Volume vs Neighborhood Average',
            },
          },
        },
        neighboringBuildings: '{{count}} neighboring buildings',
        noData: 'No neighborhood comparison data available for this building',
        notes: {
          differsByPattern: 'This building significantly differs from the neighborhood pattern.',
          physicalMismatch: 'Size/height differs significantly.',
          temporalMismatch: 'Construction period mismatch.',
          title: 'Note:',
          typologicalMismatch: 'Building type differs from dominant category.',
        },
        profile: {
          description: {
            label: 'Description',
            tooltip: {
              calculation: 'Generated from typical building year and dominant category',
              description: 'Summary characterization of the neighborhood',
              importance: "Provides quick overview of neighborhood character (e.g., '1960s residential' or '1980s mixed-use').",
              title: 'Quartier Description',
            },
          },
          developmentPattern: {
            categories: {
              mixed: {
                description: 'Moderate cohesion, varied development (score 55-74)',
                label: 'Mixed',
              },
              organic: {
                description: 'Low cohesion, diverse development (score <55)',
                label: 'Organic',
              },
              planned: {
                description: 'High cohesion, uniform development (score ≥75)',
                label: 'Planned',
              },
            },
            label: 'Development Pattern',
            tooltip: {
              description: 'Classification of neighborhood development style',
              importance: 'Planned areas have stricter zoning. Organic areas offer more renovation flexibility.',
              title: 'Development Pattern',
            },
          },
          typicalArea: {
            label: 'Typical Area',
            tooltip: {
              calculation: 'Mean footprint area of buildings in the neighborhood',
              description: 'Representative building footprint for the quartier',
              importance: 'Indicates typical lot coverage and building scale in the area.',
              title: 'Typical Area',
            },
          },
          typicalCategory: {
            label: 'Typical Category',
            tooltip: {
              calculation: 'Most common building category among neighborhood buildings',
              description: 'Dominant building type in the quartier',
              importance: 'Defines neighborhood character: residential, commercial, industrial, or mixed-use.',
              title: 'Typical Category',
            },
          },
          typicalHeight: {
            label: 'Typical Height',
            tooltip: {
              calculation: 'Mean height of buildings in the neighborhood',
              description: 'Representative building height for the quartier',
              importance: 'Indicates if area is predominantly low-rise (<10m), mid-rise (10-25m), or high-rise (>25m).',
              title: 'Typical Height',
            },
          },
          typicalYear: {
            label: 'Typical Building Year',
            tooltip: {
              calculation: 'Mean construction year of buildings in the neighborhood',
              description: 'Most representative construction year for the quartier',
              importance: 'Defines the architectural era and likely building standards for the area.',
              title: 'Typical Building Year',
            },
          },
        },
        radius: {
          label: 'Radius',
          value: '{{radius}}m radius',
        },
        statistics: {
          area: {
            mean: {
              tooltip: {
                calculation: 'Arithmetic mean of all building areas',
                description: 'Average building footprint in the neighborhood',
                importance: 'Indicates typical lot size. Influenced by outliers.',
                title: 'Mean Area',
              },
            },
            median: {
              tooltip: {
                calculation: '50th percentile of building areas',
                description: 'Middle value of neighborhood building areas',
                importance: 'More representative than mean when outliers exist.',
                title: 'Median Area',
              },
            },
            range: {
              tooltip: {
                calculation: 'Smallest and largest building footprints in neighborhood',
                description: 'Minimum and maximum building areas',
                importance: 'Shows size diversity. Wide range indicates mixed building scales.',
                title: 'Area Range',
              },
            },
            title: 'Area Statistics',
          },
          floor: {
            floorsRange: '{{min}} - {{max}} floors',
            floorsValue: '{{floors}} floors',
            mean: {
              tooltip: {
                calculation: 'Arithmetic mean of all building floor counts',
                description: 'Average number of floors in the neighborhood',
                importance: 'Indicates typical building scale. Influenced by outliers.',
                title: 'Mean Floor Count',
              },
            },
            median: {
              tooltip: {
                calculation: '50th percentile of floor counts',
                description: 'Middle value of neighborhood floor counts',
                importance: 'More representative than mean when outliers exist.',
                title: 'Median Floor Count',
              },
            },
            range: {
              tooltip: {
                calculation: 'Lowest and highest floor counts in neighborhood',
                description: 'Minimum and maximum floor counts',
                importance: 'Shows vertical diversity. Wide range indicates mixed rise levels.',
                title: 'Floor Count Range',
              },
            },
            title: 'Floor Statistics',
          },
          height: {
            mean: {
              tooltip: {
                calculation: 'Arithmetic mean of all building heights',
                description: 'Average building height in the neighborhood',
                importance: 'Indicates typical building scale. Influenced by outliers.',
                title: 'Mean Height',
              },
            },
            median: {
              tooltip: {
                calculation: '50th percentile of building heights',
                description: 'Middle value of neighborhood building heights',
                importance: 'More representative than mean when outliers exist.',
                title: 'Median Height',
              },
            },
            range: {
              tooltip: {
                calculation: 'Lowest and highest building heights in neighborhood',
                description: 'Minimum and maximum building heights',
                importance: 'Shows height diversity. Wide range indicates mixed development.',
                title: 'Height Range',
              },
            },
            title: 'Height Statistics',
          },
          mean: 'Mean',
          median: 'Median',
          range: 'Range',
        },
        title: 'Neighborhood Context',
        tooltips: {
          source: 'Swiss Building Registry (GWR)',
          sourceCalculated: 'Calculated from Swiss Building Registry data',
        },
        warnings: {
          outlierDescription: 'This building does not fit the cohesive neighborhood pattern. It may be an outlier in terms of age, size, or type compared to surrounding buildings.',
          outlierTitle: '⚠️ Warning:',
        },
      },
      overview: {
        ageCategories: {
          contemporary: {
            description: 'Built with relatively recent construction methods and materials',
            label: 'Contemporary',
            range: '10-30 years',
          },
          historic: {
            description: 'Historic building potentially with heritage value and character features',
            label: 'Historic',
            range: '>50 years',
          },
          mature: {
            description: 'Established building that may benefit from renovation or modernization',
            label: 'Mature',
            range: '30-50 years',
          },
          new: {
            description: 'Recently constructed with modern building standards and energy efficiency',
            label: 'New',
            range: '<10 years',
          },
        },
        cards: {
          dimensions: {
            buildingVolume: 'Building Volume',
            footprintArea: 'Footprint Area',
            grossFloorArea: 'Gross Floor Area',
            groundElevation: 'Ground Elevation',
            title: 'Physical Dimensions',
            tooltips: {
              elevation: {
                calculation: 'Measured from digital terrain models using the average elevation at the building footprint',
                description: 'Height of the ground level at the building location above sea level',
                importance: 'Important for flood risk assessment, drainage planning, and understanding local topography',
                title: 'Ground Elevation',
              },
              footprintImportance: 'Determines land coverage and is crucial for calculating development potential and compliance with zoning regulations',
              grossFloorArea: {
                calculation: 'Sum of all floor areas including walls, stairways, and common areas. Calculated from building registry or footprint area × floor count',
                description: 'Total floor area of all floors, measured to the outer face of external walls',
                importance: 'Key metric for property valuation, rental calculations, and comparing building sizes',
                limitations: 'May include non-habitable areas like corridors and technical rooms. Net usable area is typically 10-25% smaller',
                title: 'Gross Floor Area',
              },
              heightCalculation: 'Height measured from ground level to roof ridge using LiDAR data and official building surveys',
              heightImportance: 'Critical for zoning compliance, neighbor relations, and determining building classification',
              volume: {
                calculation: 'Typically calculated as footprint area × average height, or from detailed 3D building models',
                description: 'Total enclosed volume of the building from foundation to roof',
                importance: 'Used for energy modeling, HVAC sizing, and development density calculations',
                title: 'Building Volume',
              },
            },
          },
          occupancy: {
            avgFloorArea: 'Average Floor Area',
            avgFloorHeight: 'Average Floor Height',
            buildingCategory: 'Building Category',
            numberOfDwellings: 'Number of Dwellings',
            primaryUse: 'Primary Use',
            title: 'Occupancy & Type',
            tooltips: {
              avgFloorArea: {
                calculation: 'Calculated by dividing gross floor area by the number of floors',
                description: 'The average area of each floor in the building',
                importance: 'Useful for understanding floor plate efficiency and comparing similar buildings',
                title: 'Average Floor Area',
              },
              avgFloorHeight: {
                calculation: 'Calculated by dividing total building height by the number of floors',
                description: 'The average vertical distance between floors in the building',
                importance: 'Indicates building quality and era. Higher ceilings often suggest older or premium construction',
                title: 'Average Floor Height',
              },
              category: {
                calculation: 'Assigned by cantonal authorities based on building use, structure, and purpose',
                description: 'Official classification of the building according to Swiss federal building categories',
                importance: 'Determines applicable building regulations, tax assessments, and permissible uses',
                title: 'Building Category',
              },
              dwellings: {
                calculation: 'Counted from official building registry records, including apartments, studios, and houses',
                description: 'Total count of individual residential units in the building',
                importance: 'Key factor for building management, infrastructure planning, and density assessment',
                title: 'Number of Dwellings',
              },
              primaryUse: {
                calculation: "Determined from building registry based on the dominant use of the building's floor area",
                description: 'The main functional purpose for which the building is used',
                importance: 'Affects zoning compliance, insurance requirements, and potential development options',
                title: 'Primary Use',
              },
            },
          },
          occupancyType: {
            title: 'Occupancy & Type',
          },
          physicalDimensions: {
            title: 'Physical Dimensions',
          },
          status: {
            constructionYear: 'Construction Year',
            currentStatus: 'Current Status',
            lastRenovation: 'Last Renovation',
            minergieCertified: 'Minergie Certified',
            protectedStatus: 'Protected Status',
            title: 'Status & Condition',
            tooltips: {
              constructionYear: {
                calculation: 'Recorded in official building registry at time of construction permit completion',
                description: 'The year when the building was originally completed',
                importance: 'Essential for age calculations, historical context, and understanding construction standards used',
                limitations: 'For older buildings, may be estimated from construction period range. Major reconstructions may not update this date',
                title: 'Construction Year',
              },
              minergie: {
                calculation: 'Awarded by Minergie association based on meeting strict energy efficiency standards',
                description: 'Swiss energy efficiency certification for buildings',
                importance: 'Indicates superior energy efficiency, higher comfort, and typically lower operating costs',
                source: 'Minergie association certification database',
                title: 'Minergie Certification',
              },
              protected: {
                calculation: 'Assessed by cantonal heritage authorities based on historical, architectural, or cultural significance',
                description: 'Heritage protection level assigned to the building by cantonal authorities',
                importance: 'Affects renovation possibilities, development potential, and may provide tax benefits',
                source: 'Cantonal heritage office and building registry',
                title: 'Protected Status',
              },
              renovation: {
                calculation: 'Recorded from building permit records for major renovation or transformation projects',
                description: 'The most recent year when significant renovation work was completed',
                importance: 'Indicates recent improvements and likely better condition than construction year alone would suggest',
                limitations: 'Minor renovations may not be recorded. Interior renovations without permits are not captured',
                title: 'Last Renovation',
              },
              status: {
                calculation: 'Recorded in building registry and updated based on construction or demolition permits',
                description: 'The current operational status of the building',
                importance: 'Confirms if the building exists, is under construction, or has been demolished',
                title: 'Current Building Status',
              },
            },
          },
          statusCondition: {
            title: 'Status & Condition',
          },
        },
        heightTypes: {
          highRise: 'High-rise',
          lowRise: 'Low-rise',
          midRise: 'Mid-rise',
        },
        labels: {
          asl: 'ASL',
          estimated: 'estimated',
          period: 'period',
        },
        metrics: {
          buildingAge: {
            label: 'Building Age',
            tooltip: {
              calculation: 'Calculated as current year minus the construction year from official building registry',
              calculationEstimated: 'Estimated based on construction period {{period}}. The midpoint of the period range is used for calculation',
              description: 'The number of years since the building was originally constructed',
              importance: 'Key factor for assessing maintenance needs, renovation potential, energy efficiency, and property valuation',
              limitations: 'Does not account for major renovations or reconstructions that may have significantly updated the building',
              limitationsEstimated: 'Age is estimated from construction period and may not be exact. Actual construction year may vary within the period range',
              title: 'Building Age',
            },
          },
          buildingArea: {
            label: 'Building Area',
            tooltip: {
              calculation: 'Measured from official cadastral data or building registry as the horizontal projection of the building envelope',
              description: "The ground-level area covered by the building's outer walls",
              importance: 'Essential for understanding land use efficiency, calculating floor area ratios, and assessing development potential',
              limitations: 'Does not include external structures like terraces, balconies, or underground areas. May differ from total floor area',
              title: 'Building Footprint Area',
            },
          },
          buildingHeight: {
            label: 'Building Height',
            tooltip: {
              calculation: 'Measured from LiDAR data or official building surveys, from ground level to roof ridge or highest structural element',
              description: 'The vertical measurement from ground level to the highest point of the building',
              importance: 'Critical for zoning compliance, shadow analysis, view assessments, and determining building classification',
              limitations: 'May vary based on measurement method. Antennas, chimneys, and temporary structures may or may not be included',
              title: 'Total Building Height',
            },
          },
          floorCount: {
            label: 'Number of Floors',
            tooltip: {
              calculation: 'Counted from official building registry data, including ground floor and all upper floors',
              description: 'The total number of above-ground floors in the building',
              importance: 'Key indicator for building classification, zoning compliance, and estimating gross floor area',
              limitations: 'May not include basement levels, mezzanines, or technical floors. Underground floors are counted separately',
              title: 'Total Floor Count',
            },
          },
          numberOfFloors: {
            label: 'Number of Floors',
          },
        },
        sizeIndicators: {
          compact: 'Compact',
          large: 'Large',
          medium: 'Medium',
        },
        values: {
          asl: 'ASL',
          estimated: '(est.)',
          estimatedFrom: 'estimated from {{period}}',
          na: 'N/A',
          no: 'No',
          period: '(period)',
          years: 'years',
          yearsAgo: 'years ago',
          yearsCount: '{{count}} years',
          yes: 'Yes',
        },
      },
      states: {
        error: 'Error loading building characteristics',
        loading: 'Loading building characteristics...',
        noData: 'No building data available',
      },
      tabs: {
        neighborhood: 'Neighborhood Context',
        overview: 'Overview',
        timeline: 'Construction Timeline',
      },
      timeline: {
        ageComparison: {
          newerThanAverage: 'Newer than average',
          significantlyOlder: 'Significantly older',
          similarAge: 'Similar age',
          yearsOld: 'years old',
        },
        badges: {
          estimatedData: 'Estimated Data',
          historicalData: 'Historical Data',
        },
        cards: {
          ageAnalysis: {
            title: 'Age Analysis',
          },
          ageComparison: {
            title: 'Age Comparison with Neighborhood',
          },
          constructionPhases: {
            title: 'Construction Phases',
          },
          constructionTimeline: {
            title: 'Construction Timeline',
          },
          renovationHistory: {
            title: 'Renovation History',
          },
          timeline: {
            title: 'Construction Timeline',
            tooltip: {
              calculation: 'Based on official construction dates, renovation records, and building registry data',
              description: "Visual representation of the building's construction history and major events",
              importance: "Helps understand the building's evolution over time and plan for future maintenance",
              limitations: 'Some dates may be estimated from building periods when exact years are not available',
              title: 'Construction Timeline',
            },
          },
        },
        events: {
          constructionPhase: 'Construction Phase',
          dwellingAdded: 'Dwelling Added',
          majorRenovation: 'Major Renovation',
          originalConstruction: 'Original Construction',
          originalConstructionEst: 'Original Construction (est.)',
          present: 'Present',
        },
        labels: {
          ageCategory: 'Age Category',
          buildingAge: 'Building Age',
          buildingPeriod: 'Building Period',
          comparison: 'Comparison',
          constructionDates: 'Construction Dates',
          constructionYear: 'Construction Year',
          lastRenovation: 'Last Renovation',
          neighborhoodAverage: 'Neighborhood Average',
          noRecord: 'No record',
          numberOfPhases: 'Number of Phases',
          phases: 'Phases',
          renovationPeriod: 'Renovation Period',
          renovationStatus: 'Renovation Status',
          singlePhaseConstruction: 'Single phase construction',
          thisBuilding: 'This Building',
          yearsSinceRenovation: 'Years Since Renovation',
        },
        noDataMessage: 'No construction timeline data available',
        phaseLabels: {
          noRecord: 'No record',
          singlePhase: 'Single phase construction',
        },
        renovationStatuses: {
          considerUpdates: 'Consider updates',
          goodCondition: 'Good condition',
          noRenovation: 'No renovation',
          recentlyRenovated: 'Recently renovated',
          renovationNeeded: 'Renovation needed',
        },
      },
    },
    filters: {
      buildingDetails: {
        buildingVolume: 'Building volume above ground (m³)',
        grossFloorArea: 'Gross useful floor area (m²)',
        groundingArea: 'Grounding Area (m²)',
        height: 'Height',
        numberOfFloors: 'Number of floors',
        numberOfUnits: 'Number of units',
        title: 'Building Details',
      },
      buildingHistory: {
        buildingPeriod: 'Building Period',
        renovationPeriod: 'Renovation Period',
        title: 'Building History',
        yearOfConstruction: 'Year of Construction',
        yearOfRenovation: 'Year of Renovation',
      },
      buildingType: {
        buildingCategory: 'Building Category (GWR)',
        buildingClass: 'Building Class (GWR)',
        classifications: {
          garage: 'Garage',
          industrial: 'Industrial',
          mixed1: 'Mixed 1',
          mixed2: 'Mixed 2',
          notClassified: 'Not classified',
          offices: 'Offices',
          other: 'Other',
          public: 'Public',
          residential: 'Residential',
          retail: 'Retail',
        },
        constructionType: 'Construction Type',
        constructionTypes: {
          normal: 'Normal',
          projected: 'Projected',
          underground: 'Underground',
        },
        hasCivilProtectionShelter: 'Has civil protection shelter',
        popetyClassification: 'Popety.io Classification',
        protectedRank: 'Protected Rank',
        title: 'Building Type',
      },
      energy: {
        idc: 'IDC - MJ/m²/an',
        mainHeaterGenerator: 'Main Heater Generator',
        mainHeatingEnergySource: 'Main Heating Energy source',
        mainHotWaterEnergySource: 'Main Hot Water energy source',
        mainHotWaterGenerator: 'Main Hot Water Generator',
        minergieLabel: 'Minergie Label',
        title: 'Energy, Heating & Hot water',
      },
      environmental: {
        distanceToPowerlines: 'Distance to High-voltage Powerlines',
        lakeView: 'Lake View',
        lakeViewArea: {
          large: 'More than 100 ha',
          none: '0 ha',
          small: '0 to 100 ha',
        },
        mountainView: 'Mountain View',
        mountainViewQuality: {
          few: '0 to 4 peaks',
          many: 'More than 13 peaks',
          some: '5 to 13 peaks',
        },
        noiseExposure: 'Noise Exposure',
        noiseExposureLevels: {
          high: 'More than 52 dB',
          low: 'Up to 45 dB',
          medium: '45 to 52 dB',
        },
        powerlineDistance: {
          close: '0 to 100m',
          far: 'Over 100m',
        },
        publicTransportQuality: 'Public Transport Quality',
        slope: 'Slope',
        slopeLevels: {
          flat: '0 to 4 degrees',
          moderate: '4 to 9 degrees',
          steep: 'More than 9 degrees',
        },
        taxBurden: 'Tax Burden',
        taxBurdenLevels: {
          high: 'High (over 7.1%)',
          medium: 'Medium (5.1% to 7.1%)',
          small: 'Small (0 to 5.1%)',
        },
        title: 'Environmental Features',
        transportQuality: {
          badly: 'Badly served',
          medium: 'Medium served',
          veryBadly: 'Very badly served',
          veryWell: 'Very well served',
          well: 'Well served',
        },
        travelTime: {
          long: 'Long',
          medium: 'Medium',
          short: 'Short',
        },
        travelTimeToCenters: 'Travel Time to Centers',
      },
      history: {
        buildingPermitNumber: 'Building permit number',
        buildingPermitsClassification: 'Building permits classification',
        buildingPermitsDate: 'Building permits date',
        listingRentNumber: 'Listing rent number',
        listingSaleNumber: 'Listing sale number',
        listingsListingDate: 'Listings listing date',
        listingsPrice: 'Listings price',
        listingsPricePerSquareMeter: 'Listings price per square meter',
        listingsRentDate: 'Listings rent date',
        listingsRentDateTooltip: 'Date range when properties were listed for rent. Find recently listed rental properties.',
        listingsSaleDate: 'Listings sale date',
        listingsSaleDateTooltip: 'Date range when properties were listed for sale. Find recently listed properties for sale.',
        permitClassifications: {
          development: 'Development',
          other: 'Other',
        },
        title: 'History',
        transactionsDate: 'Transactions date',
        transactionsNumber: 'Transactions number',
        transactionsPrice: 'Transactions price',
      },
      solar: {
        averageSolarRadiation: 'Average Solar Radiation (kWh/m²/year)',
        electricPotential: 'Electric Potential (kWh/year)',
        heatPotential: 'Heat Potential (kWh/year)',
        installationDate: 'Installation date',
        installedPower: 'Installed power (kW)',
        roofArea: 'Roof area (m²)',
        roofPitch: 'Roof pitch (°)',
        title: 'Solar Energy',
        totalSolarRadiation: 'Total Solar Radiation (kWh/year)',
      },
      user: {
        loadingTags: 'Loading tags...',
        myTags: 'My Tags',
        noTagsAvailable: 'No tags available. Create tags from the building details panel.',
        title: 'User Filters',
      },
    },
    sidebar: {
      items: {
        amenities: 'Amenities',
        buildingPermits: 'Building Permits',
        characteristics: 'Building Characteristics',
        demographics: 'Demographics',
        employment: 'Employment',
        energy: 'Energy',
        feasibilityStudy: 'Feasibility Study',
        history: 'History',
        land: 'Land',
        noiseAnalysis: 'Noise Analysis',
        potential: 'Upper Elevation Potential',
        purchaseListings: 'Purchase Listings',
        purchaseMarket: 'Purchase Market',
        rentalListings: 'Rental Listings',
        rentalMarket: 'Rental Market',
        summary: 'Summary',
        sunlightStudy: 'Sunlight Study',
        transactions: 'Transactions',
        transportAccess: 'Transport & Access',
        units: 'Unit Details',
      },
      sections: {
        elevation: 'Elevation',
        environment: 'Environment',
        market: 'Market',
        overview: 'Overview',
        socialEconomic: 'Social & Economic',
      },
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Additional Filters',
        advancedFilters: 'Advanced filters',
        allLocations: 'All locations',
        clearAll: 'Clear all',
        hideFilters: 'Hide filters',
        landArea: 'Land Area (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Other',
        legalTypePPE: 'PPE',
        numberOfBuyers: 'Number of Buyers',
        numberOfSellers: 'Number of Sellers',
        others: 'Others',
        participantAssociation: 'Association',
        participantCompany: 'Company',
        participantCooperative: 'Cooperative',
        participantFoundation: 'Foundation',
        participantIndividual: 'Individual',
        participantOther: 'Other',
        participantPublicEntity: 'Public entity',
        participants: 'Participants',
        participantType: 'Participant Type',
        propertyLegalType: 'Property Legal Type',
        radius: 'Radius',
        showFilters: 'Show filters',
        stepTransactionPrice: 'Step Transaction Price (CHF)',
        transactionDate: 'Transaction Date',
        transactionType: 'Transaction Type',
        typeAreaPrice: 'Type, Area & Price',
        unitApartment: 'Apartment',
        unitCommercial: 'Commercial',
        unitHouse: 'House',
        unitLand: 'Land',
        unitOther: 'Other',
        unitParking: 'Parking',
        unitType: 'Unit Type',
      },
      subtitle: 'Explore transaction history around the building and save the ones you are interested in for this analysis.',
      tabs: {
        aroundBuilding: 'Transactions around the building',
        saved: 'Saved Transactions',
      },
      title: 'Transactions',
    },
    unitDetails: {
      actions: {
        addFirstUnit: 'Add First Unit',
        addUnit: 'Add Unit',
        cancel: 'Cancel',
        edit: 'Edit',
        save: 'Save',
        saving: 'Saving...',
      },
      common: {
        chf: 'CHF',
        minMax: 'min-max',
        na: 'N/A',
        squareMeters: 'm²',
      },
      entrance: {
        egid: 'EGID:',
        floorsCount: '{{count}} floors',
        floorsCountOne: '{{count}} floor',
        mainEntrance: 'Main Entrance',
        unitsCount: '{{count}} units',
        unitsCountOne: '{{count}} unit',
      },
      floor: {
        basement: 'Basement {{level}}',
        floorNumber: 'Floor {{number}}',
        groundFloor: 'Ground Floor',
      },
      metrics: {
        dwellingArea: 'Dwelling Area',
        floors: 'Floors',
        footprint: 'Footprint',
        units: 'Units',
      },
      multipleFloor: {
        no: 'No',
        yes: 'Yes',
      },
      states: {
        error: 'Error loading unit details:',
        loading: 'Loading unit details...',
        loadingConfigurations: 'Loading dwelling configurations...',
        noBuilding: 'No building data available',
        noUnits: 'No unit details available for this building',
        noUnitsOnFloor: 'No units on this floor',
      },
      subtitle: 'Comprehensive breakdown of all units by entrance and floor',
      table: {
        headers: {
          adminNo: 'ADMIN N°',
          area: 'AREA',
          bathrooms: 'BATHR.',
          cYear: 'C. YEAR',
          edid: 'EDID',
          fid: 'F.ID',
          multiFloor: 'MULT. FL.',
          rentalValue: 'MONTHLY RENTAL VALUE',
          rooms: 'ROOMS',
          type: 'TYPE',
        },
      },
      title: 'Unit Details',
      unitTypes: {
        residential: 'Residential',
        roomCount: '{{count}} Room',
        roomPlural: 'Rooms',
        roomsCount: '{{count}} Rooms',
        roomSingular: 'Room',
      },
      validation: {
        areaPositive: 'Area must be positive',
        bathroomsPositive: 'Bathrooms must be positive',
        constructionDateFuture: 'Construction date cannot be in the future',
        roomNumberRange: 'Room number must be between 1 and 10',
      },
    },
  },
  charts: {
    actions: {
      saveAsImage: 'Save as Image',
    },
    categories: {
      apartment: 'Apartment',
      apartmentTrend: 'Apartment Trend',
      house: 'House',
      houseTrend: 'House Trend',
    },
    common: {
      averageValue: 'Average Value',
      avgPrice: 'Average Price',
      concentrated: 'concentrated',
      consistency: 'consistency',
      decrease: 'decrease',
      decreased: 'decreased',
      decreases: 'decreases',
      discount: 'a discount of',
      distributed: 'distributed',
      downward: 'downward',
      exponential: 'exponential',
      gradual: 'gradual',
      high: 'high',
      higher: 'higher',
      increase: 'increase',
      increased: 'increased',
      increases: 'increases',
      lessExpensive: 'less expensive',
      limited: 'limited',
      linear: 'linear',
      low: 'low',
      lower: 'lower',
      moderate: 'moderate',
      mom: 'MoM',
      moreExpensive: 'more expensive',
      noData: 'No data available',
      otherRegions: 'other regions',
      smallestPremium: 'the smallest premium at',
      stable: 'stable',
      steep: 'steep',
      strong: 'strong',
      strongUpward: 'strong upward',
      totalTransactions: 'Total Transactions',
      totalValue: 'Total Value',
      totalVolume: 'Total Volume',
      transactionCount: 'Transaction Count',
      transactions: 'Transactions',
      variation: 'variation',
      weak: 'weak',
      yoy: 'YoY',
    },
    empty: {
      newVsResale: 'No new vs resale data is available for the selected filters.',
      priceEvolution: 'No price evolution data is available for the selected filters. Please adjust your search criteria.',
      pricePerRoom: 'No price per room data is available for the selected filters. Please adjust your search criteria.',
      pricePerSqmPerRoom: 'No price/m² per room data is available for the selected filters. Please adjust your search criteria.',
      rentEvolution: 'No rent evolution data is available for the selected filters. Please adjust your search criteria.',
      rentPerRoom: 'No rent per room data is available for the selected filters. Please adjust your search criteria.',
      rentPerSqmPerRoom: 'No rent/m² per room data is available for the selected filters. Please adjust your search criteria.',
      title: 'No Data Available',
    },
    geographicDistribution: {
      activeCantons: 'Active Cantons',
      avg: 'Avg',
      avgTransactionPrice: 'Avg Transaction Price',
      topCitiesByVolume: 'Top Cities by Transaction Volume',
      totalMarketVolume: 'Total Market Volume',
      transactionsByCanton: 'Transactions by Canton',
    },
    inheritanceFlow: {
      donation: 'Donation',
      flowAnalysis: 'Inheritance Flow Analysis',
      flowAnalysisSubtext: 'Wealth transfer from sellers to buyers through property types',
      heritage: 'Heritage',
      inheritanceOverTime: 'Inheritance Transactions Over Time',
      inheritanceOverTimeSubtext: 'Quarterly trends by transaction type',
      noData: 'No inheritance data available',
      partage: 'Partage',
      shareDistribution: 'Share Distribution Analysis',
      shareDistributionSubtext: 'Ownership share patterns in transfers',
    },
    insights: {
      agency: {
        marketConcentration: 'Market Concentration',
        performanceDistribution: 'Performance Distribution',
        valueDistribution: 'Value Distribution',
      },
      bestPerformer: 'Best Performer',
      bestValue: 'Best Value Configuration',
      city: {
        cityPriceRange: 'City Price Range',
        marketActivity: 'Market Activity',
        marketDistribution: 'Market Distribution',
        premiumSegment: 'Premium Segment',
        priceConsistency: 'Price Consistency',
      },
      descriptions: {
        agency: {
          marketConcentration: 'The top 5 agencies control {{percentage}}% of the market with {{count}} listings combined.',
          performanceDistribution: 'With an average of {{avgListings}} listings per agency, the market shows {{distribution}} distribution across {{count}} agencies.',
          valueDistribution: 'The top 10 agencies by portfolio value manage {{percentage}}% of the total market value at {{value}}.',
        },
        city: {
          cityPriceRange: 'Price per m² varies by {{variation}}% between {{cityHigh}} ({{priceHigh}}) and {{cityLow}} ({{priceLow}}).',
          marketActivity: 'The top 5 cities by volume represent {{percentage}}% of all listings, with {{topCity}} leading at {{topCount}} properties.',
          marketDistribution: '{{count}} cities have prices above the average of {{average}}, representing {{percentage}}% of analyzed locations.',
          premiumSegment: '{{city}} has the strongest premium market with {{percentage}}% of listings above {{threshold}}.',
          priceConsistency: '{{city}} shows the most consistent pricing with {{stdDev}} standard deviation in price/m².',
        },
        geography: {
          marketConcentration: 'The top 3 markets account for {{percentage}}% of all listings, indicating {{concentration}} market concentration.',
          nationalBenchmark: '{{count}} out of {{total}} locations have prices above the national average of {{average}}.',
          priceM2Consistency: 'Price per m² shows {{consistency}} across regions with a {{variation}}% coefficient of variation.',
          regionalPriceDisparity: '{{location1}} is {{priceDiff}}% more expensive than {{location2}}, showing significant regional price variation.',
          valueDensityLeader: '{{location}} has the highest price per m² at {{priceM2}}, leading the market in value density.',
        },
        newVsResale: {
          constructionPremiumNegative: 'New construction properties are priced at a {{discount}}% discount with {{priceType}} price/m² of {{newPrice}} compared to {{existingPrice}} for existing properties.',
          constructionPremiumPositive: 'New construction properties command a {{premium}}% premium with {{priceType}} price/m² of {{newPrice}} compared to {{existingPrice}} for existing properties.',
          marketComposition: 'New construction properties represent {{newPercentage}}% of the market with {{totalNew}} listings, while existing properties dominate at {{existingPercentage}}% with {{totalExisting}} listings.',
          marketTrendChanged: 'New construction market share has {{direction}} by {{change}} percentage points from {{startPeriod}} to {{endPeriod}}.',
          marketTrendStable: 'New construction market share has remained stable from {{startPeriod}} to {{endPeriod}}.',
          premiumVariations: '{{highCategory}} properties show the highest new construction premium at {{highPremium}}%, while {{lowCategory}} properties have {{lowPremiumText}}.',
          regionalActivity: '{{topRegion}} leads new construction activity with {{topPercentage}}% of listings being new properties, followed by {{secondRegion}}. The average across all regions is {{avgPercentage}}%.',
        },
        portal: {
          geographicReach: 'Portals operate in an average of {{avgRegions}} regions, with {{topPortal}} having the widest reach at {{topRegions}} regions.',
          marketEfficiency: 'The top 10 portals handle {{percentage}}% of all listings, demonstrating {{efficiency}} market efficiency.',
          portalEcosystem: 'The market consists of {{large}} large portals (>{{threshold}} listings), {{medium}} medium, and {{small}} small portals.',
          portalMarketConcentration: 'The top 5 portals control {{percentage}}% of the market with {{count}} listings combined.',
          pricePositioning: 'The average price across all portals is {{avgPrice}}, with {{highPortal}} positioned highest at {{highPrice}}.',
        },
        priceEvolution: {
          bestPerformer: '{{category}} properties show the strongest growth at {{growth}}%, outperforming other categories in the market.',
          marketStability: '{{category}} shows the most stable pricing with only {{volatility}}% variation, indicating consistent market conditions.',
          marketTrend: 'The overall market has {{direction}} by {{change}}% over the analyzed period, with {{priceType}} prices moving from {{startPrice}} to {{endPrice}}.',
          recentMomentum: 'The last year shows {{momentum}} momentum with prices {{direction}} by {{change}}% compared to the previous period.',
        },
        priceM2PerRoom: {
          bestValue: '{{rooms}}-room {{category}}s offer the best price/m² ratio at {{priceM2}}, representing the optimal value density in the market.',
          marketSweetSpot: '{{rooms}}-room {{category}}s dominate the market with {{count}} listings at an average of {{priceM2}}/m².',
          priceM2Trend: 'Price/m² {{direction}} by approximately {{change}} per additional room in {{category}}s.',
          propertyTypePremium: 'Houses have {{premium}}% {{comparison}} price/m² than apartments on average.',
        },
        pricePerRoom: {
          bestValue: '{{rooms}}-room {{category}}s offer the best value at {{price}} per property, representing the optimal price-to-space ratio in the market.',
          marketSweetSpot: '{{rooms}}-room {{category}}s are the most common configuration with {{count}} listings, representing {{percentage}}% of the market.',
          priceProgression: 'Each additional room in {{category}}s increases the price by approximately {{increment}}, showing {{pattern}} price scaling.',
          propertyTypePremium: 'Houses are on average {{premium}}% {{comparison}} than apartments across all room configurations.',
        },
      },
      geography: {
        marketConcentration: 'Market Concentration',
        nationalBenchmark: 'National Benchmark',
        priceM2Consistency: 'Price/m² Consistency',
        regionalPriceDisparity: 'Regional Price Disparity',
        valueDensityLeader: 'Value Density Leader',
      },
      keyInsights: 'Key Insights',
      marketStability: 'Market Stability',
      marketSweetSpot: 'Market Sweet Spot',
      marketTrend: 'Market Trend',
      newVsResale: {
        constructionPremium: 'New Construction Premium',
        marketComposition: 'Market Composition',
        premiumVariations: 'Premium Variations',
        regionalActivity: 'Regional Activity',
      },
      portal: {
        geographicReach: 'Geographic Reach',
        marketEfficiency: 'Market Efficiency',
        portalEcosystem: 'Portal Ecosystem',
        portalMarketConcentration: 'Portal Market Concentration',
        pricePositioning: 'Price Positioning',
      },
      priceM2Trend: '{{category}} Price/m² Trend',
      priceProgression: '{{category}} Price Progression',
      propertyTypePremium: 'Property Type Premium',
      recentMomentum: 'Recent Momentum',
    },
    kpis: {
      averagePrice: 'Average Price',
      averagePricePerSqm: 'Average Price/m²',
      averagePricePerSqmPerRoom: 'Avg Price/m² per Room',
      averageRent: 'Average Rent',
      averageRentPerSqm: 'Average Rent/m²',
      averageRentPerSqmPerRoom: 'Avg Rent/m² per Room',
      averageRooms: 'Average Rooms',
      avgPricePerRoom: 'Avg Price per Room',
      avgRentPerRoom: 'Avg Rent per Room',
      marketVolume: 'Market Volume',
      medianPrice: 'Median Price',
      medianPricePerRoom: 'Median Price per Room',
      medianPricePerSqm: 'Median Price/m²',
      medianPricePerSqmPerRoom: 'Median Price/m² per Room',
      medianRent: 'Median Rent',
      medianRentPerRoom: 'Median Rent per Room',
      medianRentPerSqm: 'Median Rent/m²',
      medianRentPerSqmPerRoom: 'Median Rent/m² per Room',
      mostExpensive: 'Most Expensive Category',
      priceAllTypes: '{{priceType}} Price (All Types)',
      rentAllTypes: '{{priceType}} Rent (All Types)',
      totalListings: 'Total Listings',
      yearGrowth: '1 Year Growth',
    },
    labels: {
      allRooms: 'All rooms',
      allTypes: 'All Types',
      count: 'Count',
      listings: 'Listings',
      notAvailable: 'N/A',
      numberOfListings: 'Number of Listings',
      numberOfRooms: 'Number of Rooms',
      percentage: 'Percentage (%)',
      percentile10: '10th Percentile',
      percentile10Short: '10th %',
      percentile30: '30th Percentile',
      percentile30Short: '30th %',
      percentile50Median: '50th Percentile (Median)',
      percentile50Short: '50th % (Median)',
      percentile70: '70th Percentile',
      percentile70Short: '70th %',
      percentile90: '90th Percentile',
      percentile90Short: '90th %',
      price: 'Price',
      priceChf: 'Price (CHF)',
      pricePerM2Chf: 'Price per m² (CHF)',
      propertyType: 'Property Type',
      range: 'Range',
      rent: 'Rent',
      rentChf: 'Rent (CHF)',
      rentPerM2Chf: 'Rent per m² (CHF)',
      rooms: 'Rooms',
      stdDev: 'Std Dev',
    },
    marketTiming: {
      activityCalendar: 'Market Activity Calendar',
      activityCalendarSubtext: 'Transaction volume by day',
      avgLagDays: 'Average Lag (days)',
      monthlyActivity: 'Monthly Transaction Activity',
      monthlyActivitySubtext: 'Transaction volume over time',
      noActivity: 'No activity',
      noData: 'No market timing data available',
      numberOfTransactions: 'Number of Transactions',
      publicationLag: 'Publication Lag Analysis',
      publicationLagSubtext: 'Average days between transaction and publication',
    },
    newVsResale: {
      kpis: {
        newShare: 'New Construction Share',
        premium: 'New Construction Premium',
        priceExisting: '{{priceType}} {{priceUnit}} - Existing',
        priceNew: '{{priceType}} {{priceUnit}} - New',
      },
      legends: {
        existingProperties: 'Existing Properties',
        newConstruction: 'New Construction',
      },
      titles: {
        activity: 'New Construction Activity in {{location}}',
        composition: 'Market Composition: New vs Existing Properties Over Time',
        premium: '{{priceType}} Premium for New Construction by Property Category',
      },
      tooltips: {
        existing: 'Existing',
        new: 'New Construction',
        premiumLabel: 'Premium',
        total: 'Total',
      },
    },
    participantDemographics: {
      buyersByGender: 'Buyers by Gender',
      companies: 'Companies',
      companyParticipants: 'Company Participants',
      female: 'Female',
      genderDistributionOverTime: 'Buyers Gender Distribution Over Time',
      genderParity: '50% Gender Parity',
      individualParticipants: 'Individual Participants',
      individuals: 'Individuals',
      male: 'Male',
      participantTypesByLegalForm: 'Participant Types by Legal Form',
      personVsCompany: 'Person vs Company Participants',
      sellersByGender: 'Sellers by Gender',
      totalBuyers: 'Total Buyers',
      totalSellers: 'Total Sellers',
    },
    priceDynamics: {
      avgTransactionPrice: 'Avg. Transaction Price',
      priceByPropertyType: 'Price by Property Type',
      priceDistribution: 'Price Distribution',
      priceVelocityIndex: 'Price Velocity Index',
      totalMarketVolume: 'Total Market Volume',
      yearlyMarketVolume: 'Yearly Market Volume',
    },
    priceM2PerRoom: {
      titles: {
        distribution: '{{priceType}} Distribution by Rooms',
        roomCountVsPrice: 'Room Count vs {{priceType}} Price/m²',
        roomCountVsRent: 'Room Count vs {{priceType}} Rent/m²',
      },
      tooltips: {
        listings: 'Listings',
        price: '{{priceType}} Price/m²',
        range: 'Range',
        rent: '{{priceType}} Rent/m²',
        rooms: 'Rooms',
        stdDev: 'Std Dev',
      },
    },
    priceTypes: {
      average: 'Average',
      median: 'Median',
    },
    propertyCharacteristics: {
      avgSurfaceArea: 'Average Surface Area (m²)',
      complexityIndex: 'Building Complexity Index',
      complexityIndexSubtext: 'Price and Area by Number of Floors',
      noData: 'No property characteristics data available',
      numberOfFloors: 'Number of Floors',
      performanceMatrix: 'Property Type Performance Matrix',
      performanceMatrixSubtext: 'Average Surface Area vs Average Price',
    },
    seasonalPatterns: {
      averageTransactionCount: 'Average Transaction Count',
      month: 'Month',
      monthlyActivity: 'Monthly Transaction Activity',
      monthlyActivitySubtext: 'Volume and value trends by month',
      noData: 'No seasonal pattern data available',
      quarterlyComparison: 'Quarterly Comparison',
      quarterlyComparisonSubtext: 'Transaction volume by quarter',
      seasonalPatterns: 'Seasonal Patterns',
      seasonalPatternsSubtext: 'Average activity by month across all years',
    },
    states: {
      loading: 'Loading data...',
      loadingNewVsResale: 'Loading new vs resale data...',
      loadingPriceM2PerRoom: 'Loading price/m² per room data...',
      loadingPricePerRoom: 'Loading price per room data...',
    },
    titles: {
      priceByRooms: 'Price Distribution by Rooms',
      priceDistribution: 'Price Distribution by Quantiles',
      priceDistributionByQuantiles: 'Price Distribution by Quantiles',
      priceEvolution: 'Price Evolution by Property Type',
      priceEvolutionByType: 'Price Evolution by Property Type',
      priceM2Distribution: 'Price/m² Distribution by Quantiles',
      rentByRooms: 'Rent Distribution by Rooms',
      rentDistribution: 'Rent Distribution by Quantiles',
      rentDistributionByQuantiles: 'Rent Distribution by Quantiles',
      rentEvolution: 'Rent Evolution by Property Type',
      rentEvolutionByType: 'Rent Evolution by Property Type',
      rentM2Distribution: 'Rent/m² Distribution by Quantiles',
      roomCountVsPrice: 'Room Count vs {{priceType}} Price',
      roomCountVsRent: 'Room Count vs {{priceType}} Rent',
    },
    titlesM2: {
      priceDistributionByRooms: 'Price/m² Distribution by Rooms',
      rentDistributionByRooms: 'Rent/m² Distribution by Rooms',
      roomCountVsPrice: 'Room Count vs {{priceType}} Price/m²',
    },
    transactionType: {
      distributionTitle: 'Distribution by Transaction Type',
      dominantType: 'Dominant Type',
      trendsTitle: 'Temporal Evolution',
    },
    unitComposition: {
      averageArea: 'Average Area',
      noData: 'No unit composition data available',
      numberOfRooms: 'Number of Rooms',
      numberOfUnits: 'Number of Units',
      room: 'Room',
      roomDistribution: 'Room Distribution',
      roomDistributionSubtext: 'Number of Units by Room Count',
      rooms: 'Rooms',
      units: 'units',
      unitTypeComposition: 'Unit Type Composition',
      unitTypeCompositionSubtext: 'Size represents unit count, color represents average area',
    },
    views: {
      absolute: 'Absolute Prices',
      growth: 'YoY Growth %',
      index: 'Price Index (Base 100)',
      quantile: 'Quantile Distribution',
    },
    viewTypes: {
      percentage: 'Percentage View',
      sideBySide: 'Side by Side',
      stacked: 'Stacked View',
    },
  },
  common: {
    about: 'About',
    app_description: 'Public Property Analysis',
    app_name: 'Popety.io',
    attachments: {
      clearSearch: 'Clear search',
      filesEmptyDescription: 'No file has been added to this analysis.',
      filesEmptyTitle: 'No files',
      noResultsDescription: 'Try a different search.',
      noResultsTitle: 'No results',
      notesEmptyDescription: 'No note has been added to this analysis.',
      notesEmptyTitle: 'No notes',
      searchNotes: 'Search notes...',
    },
    back: 'Back',
    buildingPermits: {
      saved: {
        approved: 'Approved',
        buildingPermits: 'Building Permits',
        emptyDescription: 'Save building permits from the "Building Permits" tab to compare them later',
        emptyTitle: 'No saved building permits yet',
        loading: 'Loading saved building permits...',
        mostCommonCategory: 'Most Common Category',
        permits: 'Permits',
        totalSaved: 'Total Saved',
      },
    },
    cancel: 'Cancel',
    close: 'Close',
    contact: 'Contact',
    download: 'Download',
    error: 'Error',
    error_loading_data: 'Error Loading Data',
    export: 'Export',
    fields: {
      access_quality: 'Access Quality',
      buildable_area: 'Buildable Area',
      building_type: 'Building Type',
      canton: 'Canton:',
      condition: 'Condition',
      construction_year: 'Construction Year',
      coordinates: 'Coordinates',
      description: 'Description',
      development_potential: 'Development Potential',
      elevation: 'Elevation:',
      elevator: 'Elevator',
      energy_efficiency: 'Energy Efficiency',
      energy_rating: 'Energy Rating',
      filters: {
        location: 'Location',
        price_range: 'Price Range',
        property_type: 'Property Type',
      },
      heating_system: 'Heating System',
      land_area: 'Land Area',
      last_renovation: 'Last Renovation',
      latitude: 'Latitude:',
      location: 'Location',
      longitude: 'Longitude:',
      max_floors: 'Max Floors',
      municipality: 'Municipality',
      parking_spaces: 'Parking Spaces',
      postal_code: 'Postal Code:',
      propertyType: {
        Commercial: 'Commercial',
        Houseappartment: 'House/Apartment',
      },
      slope: 'Slope:',
      street: 'Street:',
      terrain_type: 'Terrain Type',
      total_area: 'Total Area',
      total_floors: 'Total Floors',
      total_units: 'Total Units',
      utilities: 'Utilities',
      zone_type: 'Zone Type',
    },
    filter: 'Filter',
    help: 'Help',
    languages: {
      english: 'English',
      french: 'Français',
      german: 'Deutsch',
      italian: 'Italiano',
      select_language: 'Select language',
    },
    loading: 'Loading...',
    next: 'Next',
    no_data_available: 'No data available',
    on: 'on',
    overview: {
      address_details: 'Address Details',
      building_overview: 'Building Overview',
      geographic_information: 'Geographic Information',
      key_features: 'Key Features',
      land_overview: 'Land Overview',
      location_information: 'Location Information',
    },
    powered_by: 'Powered by Popety.io',
    privacy: 'Privacy',
    refresh: 'Refresh',
    save: 'Save',
    scoreModal: {
      methodology: {
        dataAge: 'Some underlying data may be up to 6 months old',
        dataSources: 'Data sources include cadastral records, zoning regulations, geographic data, and market analysis',
        generalPotential: 'Scores reflect general potential, not guaranteed development outcomes',
        howCalculated: 'How scores are calculated',
        limitations: 'Limitations',
        localRegulations: 'Local regulations may impose additional constraints not reflected in scores',
        marketConditions: 'Market conditions can change independently of these metrics',
        range: 'Scores range from 0 to 100, with 100 being optimal for development',
        title: 'Methodology & Limitations',
        weightedCombination: 'The development score is a weighted combination of the four individual metrics',
      },
      overallScore: 'Overall Score',
      overallScoreDescription: 'This score represents the overall development potential of the land, calculated as a weighted combination of the four individual metrics displayed in the radar chart.',
      scoreBreakdown: 'Score Breakdown',
      scores: {
        geometry: {
          description: 'Based on parcel shape, area, slope, and geographic characteristics that affect buildability and market appeal.',
          displayLabel: 'Geo Shape',
          radarLabel: 'Geometry',
        },
        legacy: {
          description: 'Evaluates the quality and condition of existing structures on the land. A higher score indicates fewer constraints from existing buildings.',
          displayLabel: 'Existing',
          radarLabel: 'Legacy',
        },
        livability: {
          description: 'Measures quality of life factors including proximity to amenities, public transport access, and environmental quality.',
          displayLabel: 'Environment',
          radarLabel: 'Livability',
        },
        potential: {
          description: 'Indicates how much of the allowed building potential is currently unused. A higher score means more development opportunity remains.',
          displayLabel: 'Under-exploited',
          radarLabel: 'Potential',
        },
      },
      scoresUpdated: 'Scores are updated periodically based on the latest available data.',
      title: 'Development Score Details',
    },
    search: 'Search',
    settings: 'Settings',
    shared_by: 'by {{name}}',
    shared_on: 'Shared on {{date}}',
    sidebar: {
      items: {
        amenities: 'Amenities',
        buildingCharacteristics: 'Building Characteristics',
        buildingDetails: 'Building Details',
        buildingPermits: 'Building Permits',
        demographics: 'Demographics',
        electricity: 'Electricity',
        employment: 'Employment',
        energy: 'Energy',
        feasibilityStudy: 'Feasibility Study',
        files: 'Files',
        geoAnalysis: 'Geo Analysis',
        history: 'History',
        noiseAnalysis: 'Noise Analysis',
        notes: 'Notes',
        purchaseListings: 'Purchase Listings',
        purchaseMarket: 'Purchase Market',
        rentalListings: 'Rental Listings',
        rentalMarket: 'Rental Market',
        restrictions: 'Restrictions',
        summary: 'Summary',
        sunlightStudy: 'Sunlight Study',
        taxes: 'Taxes',
        transactions: 'Transactions',
        transportAccess: 'Transport & Access',
        unitDetails: 'Unit Details',
        zoningRules: 'Zoning Rules',
      },
      sections: {
        development: 'Development',
        environment: 'Environment',
        market: 'Market',
        overview: 'Overview',
        socialEconomic: 'Social & Economic',
      },
    },
    sort: 'Sort',
    status: {
      address_not_available: 'Address not available',
      available: 'Available',
      not_available: 'Not Available',
      unknown: 'Unknown',
      unknown_location: 'Unknown location',
    },
    terms: 'Terms',
    try_again: 'Try Again',
    units: {
      buildingUnits: '{{count}} units',
      currency: 'CHF',
      floors: '{{count}} floors',
      na: 'N/A',
      rooms: 'rooms',
      spaces: 'spaces',
      square_meters: 'm²',
    },
    validation: {
      failed_to_validate: 'Failed to validate access',
      invalid_link: 'Invalid Link',
      link_expired: 'This link is invalid or has expired.',
      validating_access: 'Validating access...',
    },
    view: 'View',
    yes_no: {
      no: 'No',
      yes: 'Yes',
    },
  },
  comparables: {
    no_location_data: {
      listings: 'Location data not available for comparables analysis',
      transactions: 'Location data not available for transactions analysis',
    },
  },
  demographics: {
    charts: {
      annualizedGrowthRate: {
        subtitle: 'Averâge annual growth rate across different time periods for accurate comparison',
        title: 'Annualized Growth Rate Comparison',
      },
      axis: {
        annualGrowthRate: 'Annual Growth Rate (%)',
        households: 'Households',
        population: 'Population',
      },
      communityStability: {
        descriptions: {
          established: 'Established (6-10 years)',
          longTerm: 'Long-term (10+ years)',
          natives: 'Natives (since birth)',
          newcomers: 'Newcomers (0-1 year)',
          settling: 'Settling in (1-5 years)',
        },
        implications: {
          established: 'Stable renters, potential first-time buyers',
          longTerm: 'Ownership oriented, community invested',
          mixed: 'Diverse housing needs across the community',
          natives: 'Deep community ties, often inherited properties',
          newcomers: 'High rental demand, furnished units, flexible terms',
          settling: 'Transitioning to longer leases, quality upgrades',
        },
        legend: {
          '0to1Year': '0-1 Year',
          '10plusYears': '10+ Years',
          '1to5Years': '1-5 Years',
          '6to10Years': '6-10 Years',
          sinceBirth: 'Since Birth',
        },
        levels: {
          high: 'High',
          low: 'Low',
          moderate: 'Moderate',
          veryHigh: 'Very High',
        },
        markets: {
          balanced: 'Balanced rental/ownership market',
          mixed: 'Mixed market with varied needs',
          ownershipFocused: 'Ownership-focused market',
          rentalFocused: 'Rental-focused market',
        },
        subtitle: 'Residential tenure patterns indicating community character and market dynamics',
        summary: {
          establishedRésidents: 'Established residents',
          marketDynamics: 'Impacts property demand patterns',
          newcomers: 'Newcomers',
          ownershipPotential: 'Ownership market potential',
          rentalOpportunities: 'Rental market opportunities',
          stability: 'Stability',
          title: 'Community Stability Analysis',
          turnoverHigh: 'High (active rental market)',
          turnoverLow: 'Low (stable community)',
          turnoverModerate: 'Moderate (balanced dynamics)',
          turnoverRate: 'Turnover rate',
        },
        title: 'Community Stability',
        tooltips: {
          count: 'Count',
          marketImpact: 'Market Impact',
          percentage: 'Percentage',
          résidents: 'Residents',
        },
      },
      growthComparison: {
        axis: {
          annualGrowthRate: 'Annual Growth Rate (%)',
        },
        descriptions: {
          exceptional: 'Exceptional growth - Booming market',
          good: 'Good growth - Healthy market',
          moderateDecline: 'Moderate décliné - Challenging conditions',
          modest: 'Modest growth - Stable area',
          significantDecline: 'Significant décliné - Market under pressure',
          slightDecline: 'Slight décliné - Watch market carefully',
          strong: 'Strong growth - High demand area',
        },
        implications: {
          careful: 'Careful analysis required before investment decisions',
          cautious: 'Cautious approach recommended, monitor market trends',
          excellent: 'Excellent investment climate with strong appreciation potential',
          favorable: 'Favorable conditions for property investment and development',
          stable: 'Stable market suitable for long-term investment',
        },
        summary: {
          acrossAllPeriods: 'across all periods',
          averageGrowth: 'Averâge growth',
          challengingPeriod: 'Challenging period',
          growthPattern: 'Growth Pattern',
          peakGrowth: 'Peak growth',
          positiveTrend: 'Positive trend',
          ppRange: 'pp range',
          strongPerformance: 'Strong performance',
          title: 'Growth Pattern Analysis',
          volatility: 'Volatility',
          volatilityHigh: 'High',
          volatilityLow: 'Low',
          volatilityModerate: 'Moderate',
          weakestPeriod: 'Weakest period',
        },
        tooltips: {
          annualized: 'Annualized Growth',
          marketImpact: 'Market Impact',
          perYear: 'per year',
        },
        trends: {
          accelerating: 'Accelerating',
          consistent: 'Consistent',
          decelerating: 'Decelerating',
        },
      },
      growthPeriods: {
        fiveYears: '5 Years',
        oneYear: '1 Year',
        tenYears: '10 Years',
        twoYears: '2 Years',
      },
      householdComposition: {
        legend: {
          '1person': '1 Person',
          '2people': '2 People',
          '3people': '3 People',
          '4people': '4 People',
          '5people': '5 People',
          '6plusPeople': '6+ People',
        },
        markets: {
          diverse: 'Diverse household mix requiring varied property types',
          family: 'Family-dominated area with demand for larger properties and houses',
          modern: 'Couple-focused market with demand for modern 2-3 room properties',
          rental: 'High single-person ratio indicates strong rental market for studios and small apartments',
        },
        recommendations: {
          couple: '2-3 room apartments with modern amenities preferred',
          extendedFamily: 'Multi-generational housing with separate living areas',
          family: '4-5 room apartments and houses with outdoor space',
          largeFamily: 'Large 5+ room properties and houses in demand',
          mixed: 'Diverse property types to serve varied household needs',
          smallFamily: '3-4 room family-friendly apartments needed',
          studio: 'Studios and 1-2 room apartments are in high demand',
        },
        subtitle: 'Distribution of household sizes showing property type demand patterns',
        summary: {
          couples: 'Couples',
          couplesUnits: 'Modern 2-3 room apartments',
          families: 'Families (3+ persons)',
          familiesUnits: '3+ room apartments and houses',
          singlePerson: 'Single-person households',
          singlePersonUnits: 'Studios and 1-2 room units',
          title: 'Property Demand Analysis',
        },
        title: 'Household Composition',
        tooltips: {
          count: 'Count',
          households: 'Households',
          percentage: 'Percentage',
          propertyDemand: 'Property Demand',
        },
      },
      householdSizes: {
        fivePeople: '5 People',
        fourPeople: '4 People',
        onePerson: '1 Person',
        sixPlusPeople: '6+ People',
        threePeople: '3 People',
        twoPeople: '2 People',
      },
      legend: {
        cantonal: 'Cantonal',
        female: 'Female',
        foreign: 'Foreign',
        foreignPopulation: 'Foreign Population',
        households: 'Households',
        interCantonal: 'Inter-Cantonal',
        international: 'International',
        local: 'Local',
        male: 'Male',
        newBorn: 'New Born',
        swiss: 'Swiss',
        swissPopulation: 'Swiss Population',
        totalPopulation: 'Total Population',
      },
      migrationChart: {
        descriptions: {
          cantonal: 'From within canton',
          interCantonal: 'From other cantons',
          international: 'From abroad',
          local: 'Stayed in same city',
          newBorn: 'Born in past year',
        },
        legend: {
          cantonal: 'Cantonal',
          interCantonal: 'Inter-Cantonal',
          international: 'International',
          local: 'Local',
          newBorn: 'New Born',
        },
        profiles: {
          balanced: {
            characteristics: 'Mix of local rétention and new arrivals, healthy turnover',
            title: 'Balanced Migration',
          },
          highInternational: {
            characteristics: 'Strong draw for international residents, diverse cultural needs',
            title: 'High International Attraction',
          },
          régionalHub: {
            characteristics: 'Attracts residents from across Switzerland, growing area',
            title: 'Régional Hub',
          },
          stableLocal: {
            characteristics: 'High rétention rate, established residents, community stability',
            title: 'Stable Local Community',
          },
        },
        sources: {
          cantonal: 'Within canton',
          international: 'International',
          local: 'Local rétention',
          otherCantons: 'Other cantons',
        },
        summary: {
          dominantSource: 'Dominant source',
          externalNatural: 'External & Natural',
          growingInternational: 'Growing international community with diverse housing needs',
          healthyMix: 'Healthy mix of stability and growth',
          highLocalRétention: 'Indicates strong community attachment and low turnover',
          internalMovement: 'Internal Movement',
          populationDynamics: 'Population Dynamics',
        },
        tooltips: {
          origin: 'Origin',
        },
      },
      migrationOrigins: {
        subtitle: 'Sources and patterns of population movement in the area',
        title: 'Migration Origins',
      },
      nationalityChart: {
        legend: {
          foreign: 'Foreign',
          swiss: 'Swiss',
        },
        profiles: {
          balanced: {
            characteristics: 'Mix of Swiss and international residents, diverse préférences',
            title: 'Balanced Community',
          },
          cosmopolitan: {
            characteristics: 'Urban diversity, mixed cultural influences, varied housing needs',
            title: 'Cosmopolitan Community',
          },
          internationalHub: {
            characteristics: 'Globally connected, diverse, modern lifestyle préférences',
            title: 'International Hub',
          },
          traditional: {
            characteristics: 'Predominantly Swiss, local customs, ownership culture',
            title: 'Traditional Swiss Community',
          },
        },
        summary: {
          balanced: 'Balanced market serving both rental and ownership needs with diverse préférences',
          composition: 'Nationality Composition',
          highForeign: 'Strong rental market potential, modern amenities valued, flexible lease terms preferred',
          lowForeign: 'Ownership culture dominates, traditional housing préférences, long-term stability',
          marketImplications: 'Market Implications',
        },
        tooltips: {
          foreignImplication: 'Rental market potential, modern amenities valued, international standards',
          housingImpact: 'Housing Impact',
          population: 'Population',
          swissImplication: 'Traditional ownership préférences, stable long-term residents',
        },
      },
      nationalityComposition: {
        subtitle: 'Distribution of Swiss and foreign residents in the local area',
        title: 'Nationality Composition',
      },
      populationDistribution: {
        subtitle: 'Âge and gender breakdown showing target demographics for property development',
        title: 'Population Distribution',
      },
      populationEvolution: {
        subtitle: 'Historical population trends showing growth patterns and market development',
        title: 'Population Evolution Timeline',
      },
      populationPyramid: {
        annotations: {
          accessibility: 'Accessibility features important',
          familyHousing: 'Family housing demand',
          strongRental: 'Strong rental market potential',
        },
        legend: {
          female: 'Female',
          male: 'Male',
        },
        summary: {
          accessibilityNeeds: 'Accessibility and downsizing needs',
          families: 'Families (30-54)',
          purchasingDemand: 'Primary home purchasing demographic',
          rentalDemand: 'Key rental market demographic',
          seniors: 'Seniors (65+)',
          title: 'Population Structure Insights',
          totalPopulation: 'Total Population',
          youngAdults: 'Young Adults (20-39)',
        },
        tooltips: {
          ageGroup: 'Âge Group',
          population: 'Population',
          ratio: 'Male/Female Ratio',
        },
      },
      populationTrend: {
        axis: {
          households: 'Households',
          population: 'Population',
        },
        legend: {
          foreignPopulation: 'Foreign Population',
          households: 'Households',
          swissPopulation: 'Swiss Population',
          totalPopulation: 'Total Population',
        },
        summary: {
          currentComposition: 'Current composition',
          decreasing: 'Decreasing',
          foreignPopulation: 'Foreign population',
          householdTrend: 'Household trend',
          increasing: 'Increasing',
          periodAnalysis: 'Period Analysis',
          stable: 'Stable',
          title: 'Trend Summary',
          totalGrowth: 'Total growth',
          years: 'years',
        },
        tooltips: {
          change: 'change',
          décline: 'décline',
          foreign: 'Foreign',
          growth: 'growth',
          households: 'Households',
          swiss: 'Swiss',
          total: 'Total',
          yearOverYear: 'Year-over-year',
        },
      },
      résidentialTenure: {
        oneToFiveYears: '1-5 Years',
        sinceBirth: 'Since Birth',
        sixToTenYears: '6-10 Years',
        tenPlusYears: '10+ Years',
        zeroToOneYear: '0-1 Year',
      },
      series: {
        growthRate: 'Growth Rate',
        householdComposition: 'Household Composition',
        migrationOrigin: 'Migration Origin',
        nationality: 'Nationality',
        residents: 'Residents',
        zeroGrowth: 'Zero Growth',
      },
    },
    filters: {
      byBicycle: 'By Bicycle',
      byCar: 'By Car',
      byWalk: 'By Walk',
      city: 'City',
      district: 'District',
      location: 'Location:',
      minBike: '{{time}}min bike',
      minDrive: '{{time}}min drive',
      minWalk: '{{time}}min walk',
      options: {
        radius: {
          '1km': '1km',
          '2km': '2km',
          '500m': '500m',
          '5km': '5km',
        },
        time: {
          '10min': '10 min',
          '15min': '15 min',
          '20min': '20 min',
          '30min': '30 min',
          '5min': '5 min',
        },
      },
      selectLocation: 'Select location',
    },
    insights: {
      currentComposition: 'Current composition',
      decreasing: 'Decreasing',
      foreignPopulationGrowth: 'Foreign population',
      growth: 'growth',
      growthDescriptions: {
        exceptionalGrowth: 'Exceptional growth',
        goodGrowth: 'Good growth',
        moderateDecline: 'Moderate décline',
        modestGrowth: 'Modest growth',
        significantDecline: 'Significant décline',
        slightDecline: 'Slight décline',
        strongGrowth: 'Strong growth',
      },
      growthPatternAnalysis: {
        acrossAllPeriods: 'across all periods',
        averageGrowth: 'Averâge growth',
        growthPattern: 'Growth Pattern',
        patterns: {
          accelerating: 'Accelerating',
          consistent: 'Consistent',
          decelerating: 'Decelerating',
        },
        peakGrowth: 'Peak growth',
        performanceDescriptions: {
          challengingPeriod: '(Challenging period)',
          positiveTrend: '(Positive trend)',
          strongPerformance: '(Strong performance)',
        },
        ppRange: '{{range}}pp range',
        title: 'Growth Pattern Analysis',
        volatility: 'Volatility',
        volatilityLevels: {
          high: 'High',
          low: 'Low',
          moderate: 'Moderate',
        },
        weakestPeriod: 'Weakest period',
      },
      householdMarkets: {
        couplesToModernProperties: 'Couples: {{percentage}}% - Modern 2-3 room properties',
        diverseHousingNeeds: 'Diverse housing needs',
        familiesToLargerProperties: 'Families: {{percentage}}% - 3+ room apartments & houses',
        highRentalMarketPotential: 'High rental market potential',
        modernApartmentDemand: 'Modern apartment demand',
        singlePersonToStudios: 'Single-person: {{percentage}}% - Studios & 1-2 room apartments',
        strongFamilyHousingDemand: 'Strong family housing demand',
        title: 'Market Implications',
      },
      householdTrend: 'Household trend',
      housingMarketImplications: {
        balancedMarket: 'Balanced market serving both rental and ownership needs with diverse préférences',
        modernAmenities: 'Modern amenities valued, rental market potential',
        ownershipCulture: 'Ownership culture dominates, traditional housing préférences, long-term stability',
        strongRentalMarket: 'Strong rental market potential, modern amenities valued, flexible lease terms preferred',
        title: 'Housing Market Implications:',
        traditionalPreferences: 'Traditional housing préférences, ownership culture',
      },
      increasing: 'Increasing',
      marketImpact: {
        carefulMarketAnalysisRequired: 'Careful market analysis required',
        cautiousOptimismWarranted: 'Cautious optimism warranted',
        excellentInvestmentClimate: 'Excellent investment climate',
        favorableMarketConditions: 'Favorable market conditions',
        stableMarketPotential: 'Stable market potential',
      },
      marketImplications: {
        generationalOwnershipLowMobility: 'Generational ownership, low mobility',
        highRentalDemand: 'High rental demand, flexible leases',
        mixedMarketCharacteristics: 'Mixed market characteristics',
        ownershipPreferenceFamilyProperties: 'Ownership preference, family properties',
        rentalToOwnershipTransition: 'Rental to ownership transition market',
        stableOwnershipMarketLowTurnover: 'Stable ownership market, low turnover',
        title: 'Market Implications',
      },
      migrationCategories: {
        externalAndNatural: 'External & Natural:',
        internalMovement: 'Internal Movement:',
      },
      migrationDescriptions: {
        bornInPastYear: 'Born in past year',
        fromAbroad: 'From abroad',
        fromOtherCantons: 'From other cantons',
        fromWithinCanton: 'From within canton',
        stayedInSameCity: 'Stayed in same city',
      },
      migrationProfiles: {
        balancedMigration: {
          characteristics: 'Mix of local rétention and new arrivals, healthy turnover',
          profile: 'Balanced Migration',
        },
        highInternationalAttraction: {
          characteristics: 'Strong draw for international residents, diverse cultural needs',
          profile: 'High International Attraction',
        },
        régionalHub: {
          characteristics: 'Attracts residents from across Switzerland, growing area',
          profile: 'Régional Hub',
        },
        stableLocalCommunity: {
          characteristics: 'High rétention rate, established residents, community stability',
          profile: 'Stable Local Community',
        },
      },
      nationalityComposition: 'Nationality Composition:',
      nationalityProfiles: {
        balancedCommunity: {
          characteristics: 'Mix of Swiss and international residents, diverse préférences',
          profile: 'Balanced Community',
        },
        cosmopolitanCommunity: {
          characteristics: 'Urban diversity, mixed cultural influences, varied housing needs',
          profile: 'Cosmopolitan Community',
        },
        internationalHub: {
          characteristics: 'Globally connected, diverse, modern lifestyle préférences',
          profile: 'International Hub',
        },
        traditionalSwissCommunity: {
          characteristics: 'Predominantly Swiss, local customs, ownership culture',
          profile: 'Traditional Swiss Community',
        },
      },
      populationDynamics: {
        dominantSource: 'Dominant source: {{source}} ({{percentage}}%)',
        dominantSources: {
          international: 'International',
          localRétention: 'Local rétention',
          otherCantons: 'Other cantons',
          withinCanton: 'Within canton',
        },
        growingInternationalCommunity: ' - Growing international community with diverse housing needs',
        healthyMixOfStabilityAndGrowth: ' - Healthy mix of stability and growth',
        strongCommunityAttachment: ' - Indicates strong community attachment and low turnover',
        title: 'Population Dynamics:',
      },
      propertyRecommendations: {
        couple: '2-3 rooms, modern amenities',
        extendedFamily: 'Large houses, multi-generational',
        family: '4-5 rooms, outdoor space',
        largeFamily: '5+ rooms, houses',
        mixed: 'Mixed property types',
        smallFamily: '3-4 rooms, family-friendly',
        studio: 'Studios, 1-2 rooms',
      },
      pyramidAnnotations: {
        accessibilityImportant: 'Accessibility\\nfeatures important',
        familyHousingDemand: 'Family housing\\ndemand',
        strongRentalMarket: 'Strong rental\\nmarket potential',
      },
      pyramidInsights: {
        seniors: 'Seniors (65+):',
        totalPopulation: 'Total Population:',
        youngAdults: 'Young Adults (20-39):',
      },
      stabilityAnalysis: {
        establishedRésidents: 'Established residents',
        marketDynamics: 'Market dynamics',
        marketTypes: {
          balancedMarket: 'Balanced market',
          mixedRentalOwnership: 'Mixed rental/ownership',
          ownershipFocused: 'Ownership-focused',
          rentalFocused: 'Rental-focused',
        },
        newcomers: 'Newcomers',
        ownershipPotential: 'Ownership potential',
        rentalMarketOpportunities: 'Rental market opportunities',
        stability: 'Stability',
        stabilityLevels: {
          high: 'High',
          low: 'Low',
          moderate: 'Moderate',
          veryHigh: 'Very High',
        },
        title: 'Community Stability Analysis',
        turnoverLevels: {
          high: 'High',
          low: 'Low',
          moderate: 'Moderate',
        },
        turnoverRate: 'Turnover rate',
      },
      stabilityImplications: {
        established: 'Established residents, ownership preference',
        longTerm: 'Long-term residents, stable community',
        natives: 'Local natives, deep community ties',
        newcomers: 'Recent arrivals, high rental demand',
        settling: 'Settling in, rental to ownership transition',
      },
      totalGrowth: 'Total growth',
      trendSummary: '{{years}}-Year Trend Summary ({{startYear}}-{{endYear}})',
    },
    metrics: {
      annualGrowthRate: {
        subtitle: '10-year compound rate',
        title: 'Annual Growth Rate (CAGR)',
      },
      averageHouseholdSize: {
        people: '{{count}} people',
        subtitle: '{{count}} total households',
        title: 'Averâge Household Size',
      },
      communityStability: {
        subtitle: '{{count}} long-term residents',
        title: 'Community Stability',
      },
      currentPopulation: {
        subtitle: 'In year {{year}}',
        title: 'Current Population',
      },
      familyHouseholds: {
        subtitle: '{{count}} households',
        title: 'Family Households',
      },
      foreignResidents: {
        subtitle: '{{count}} residents',
        title: 'Foreign Residents',
      },
      growth10Year: {
        subtitle: 'Long-term trend',
        title: '10-Year Growth',
      },
      growth1Year: {
        subtitle: 'Recent population change',
        title: '1-Year Growth',
      },
      growth2Year: {
        subtitle: 'Short-term trend',
        title: '2-Year Growth',
      },
      growth5Year: {
        subtitle: 'Medium-term trend',
        title: '5-Year Growth',
      },
      householdSize: {
        subtitle: '{{count}} households',
        title: 'Household Size',
      },
      medianAge: {
        subtitle: 'Community age profile',
        title: 'Median Age',
        years: '{{age}} years',
      },
      newResidents: {
        subtitle: '{{count}} recent arrivals',
        title: 'New Residents',
      },
      populationGrowth: {
        subtitle: '10-year évolution',
        title: 'Population Growth',
      },
      singlePersonHouseholds: {
        subtitle: '{{count}} households',
        title: 'Single-Person Households',
      },
      totalPopulation: {
        subtitle: 'Local area residents',
        title: 'Total Population',
      },
      twoPersonHouseholds: {
        subtitle: '{{count}} households',
        title: 'Two-Person Households',
      },
    },
    states: {
      error: 'Error loading demographic data: {{error}}',
      fetchError: 'Failed to fetch demographic data',
      loading: 'Loading demographic data...',
      noBuildingData: 'No building data available for demographics analysis',
      noData: 'Demographic data is not available for this location.',
      noTrendData: 'No trend data available',
    },
    subtitle: 'Population characteristics and market insights for the local area',
    tabs: {
      growth: 'Growth Analysis',
      market: 'Market Composition',
      overview: 'Overview',
    },
    title: 'Demographics',
    tooltips: {
      averageHouseholdSize: {
        calculation: 'Total Population / Total Number of Households',
        importance: 'Détermines optimal unit sizes and property development mix',
        limitations: 'Averâge may not reflect full range of household compositions',
        shortDescription: 'Averâge number of people per household',
        source: 'Swiss Federal Statistical Office household census data',
        title: 'Averâge Household Size',
      },
      communityStability: {
        calculation: '(10+ Year Résidents + Since Birth Residents) / Total Population x 100',
        importance: 'High stability indicates mature communities with strong ownership potential',
        limitations: 'Based on time in current municipality, not specific neighborhood',
        shortDescription: 'Percentâge of residents living in the area for 10+ years or since birth',
        source: 'Swiss Federal Statistical Office résidential duration data',
        title: 'Community Stability',
      },
      compoundAnnualGrowthRate: {
        calculation: '((Current Pop / Pop 10 Years Ago)^(1/10) - 1) x 100',
        importance: 'Smooths out yearly variations to show underlying growth trend',
        limitations: 'Assumes steady growth, actual growth may be irregular',
        shortDescription: 'Averâge annual growth rate over 10 years, accounting for compounding',
        source: 'Calculated from Swiss Federal Statistical Office data',
        title: 'Compound Annual Growth Rate',
      },
      currentPopulation: {
        calculation: 'Sum of all residents in the 500m radius around the property',
        importance: 'Baseliné for calculating growth rates and market size',
        limitations: 'Based on administrative boundaries and census methodology',
        shortDescription: 'Total population in the local area for the most recent year',
        source: 'Swiss Federal Statistical Office current year population data',
        title: 'Current Population',
      },
      familyHouseholds: {
        calculation: '(3+ Person Households) / Total Households x 100',
        importance: 'Indicates demand for larger properties with family-oriented features',
        limitations: 'Includes various household types, not just families with children',
        shortDescription: 'Percentâge of households with three or more residents',
        source: 'Swiss Federal Statistical Office household size data',
        title: 'Family Households (3+ People)',
      },
      foreignResidents: {
        calculation: 'Foreign Population / Total Population x 100',
        importance: 'Indicates international character and potential rental market',
        limitations: 'Nationality at time of census, may not reflect cultural diversity',
        shortDescription: 'Percentâge of residents with foreign nationality',
        source: 'Swiss Federal Statistical Office nationality data',
        title: 'Foreign Residents',
      },
      growth10Year: {
        calculation: '(Current Population - 10 Years Ago) / 10 Years Ago x 100',
        importance: 'Reveals long-term demographic trends and structural changes',
        limitations: 'Historical performance may not predict future trends',
        shortDescription: 'Population change over the last decade',
        source: 'Swiss Federal Statistical Office decade demographic comparison',
        title: '10-Year Population Growth',
      },
      growth1Year: {
        calculation: '(Current Population - Previous Year) / Previous Year x 100',
        importance: 'Shows immediate market trends and short-term demand changes',
        limitations: 'May reflect temporary factors or seasonal variations',
        shortDescription: 'Population change over the most recent year',
        source: 'Swiss Federal Statistical Office annual population data',
        title: '1-Year Population Growth',
      },
      growth2Year: {
        calculation: '(Current Population - 2 Years Ago) / 2 Years Ago x 100',
        importance: 'Indicates short-term trends beyond annual fluctuations',
        limitations: 'Still subject to cyclical variations and temporary factors',
        shortDescription: 'Population change over the last two years',
        source: 'Swiss Federal Statistical Office demographic tracking',
        title: '2-Year Population Growth',
      },
      growth5Year: {
        calculation: '(Current Population - 5 Years Ago) / 5 Years Ago x 100',
        importance: 'Shows medium-term demographic trends and economic cycles',
        limitations: 'May include effects of economic cycles or policy changes',
        shortDescription: 'Population change over the last five years',
        source: 'Swiss Federal Statistical Office five-year demographic analysis',
        title: '5-Year Population Growth',
      },
      medianAge: {
        calculation: 'Estimated from age group distributions using linear interpolation',
        importance: 'Indicates target market for different property types and amenities',
        limitations: 'Approximation based on age groups, not individual ages',
        shortDescription: 'Middle age value when all residents are arranged by age',
        source: 'Swiss Federal Statistical Office age group data',
        title: 'Median Age',
      },
      newResidents: {
        calculation: '0-1 Year Residents / Total Population x 100',
        importance: 'High percentages indicate dynamic areas with rental opportunities',
        limitations: 'Includes all types of moves, from local relocations to international migration',
        shortDescription: 'Percentâge of residents who moved to the area in the last year',
        source: 'Swiss Federal Statistical Office migration data',
        title: 'New Residents (0-1 Year)',
      },
      populationGrowth: {
        calculation: '(Current Population - Population 10 years ago) / Population 10 years ago',
        importance: 'Growth indicates increasing property demand and investment potential',
        limitations: 'Historical trends may not predict future performance',
        shortDescription: 'Population change over the last 10 years',
        source: 'Swiss Federal Statistical Office yearly population data',
        title: 'Population Growth',
      },
      singlePersonHouseholds: {
        calculation: 'Single-Person Households / Total Households x 100',
        importance: 'High percentages indicate strong rental market demand for smaller units',
        limitations: 'Includes all âgés, from young professionals to elderly residents',
        shortDescription: 'Percentâge of households with only oné résident',
        source: 'Swiss Federal Statistical Office household composition data',
        title: 'Single-Person Households',
      },
      totalPopulation: {
        calculation: 'Sum of all residents within the defined geographic area',
        importance: 'Indicates market size and density for real estate demand',
        limitations: 'Based on official statistics, may not reflect seasonal variations',
        shortDescription: 'Total number of residents in the 500m radius around the property',
        source: 'Swiss Federal Statistical Office demographic data',
        title: 'Total Population',
      },
      twoPersonHouseholds: {
        calculation: 'Two-Person Households / Total Households x 100',
        importance: 'Indicates demand for 2-3 bedroom properties, typical for couples and small families',
        limitations: 'Includes various household types: couples, roommates, parent with child, etc.',
        shortDescription: 'Percentâge of households with two residents',
        source: 'Swiss Federal Statistical Office household composition data',
        title: 'Two-Person Households',
      },
    },
  },
  electricity: {
    categories: {
      C1: 'Very small business, max 8 kW',
      C2: 'Small business, max 15 kW',
      C3: 'Medium business, max 50 kW',
      C4: 'Large business, 150 kW, low voltage',
      C5: 'Large business, 150 kW, medium voltage',
      C6: 'Large business, 400 kW, medium voltage',
      C7: "Large business, 1'630 kW, medium voltage",
      H1: 'Apt. 2 rooms, electric cooker',
      H2: 'Apt. 4 rooms, electric cooker',
      H3: 'Apt. 4 rooms + cooker + water heater',
      H4: 'Apt. 5 rooms + cooker + tumble dryer',
      H5: 'House 5 rooms, all electric equipment',
      H6: 'House 5 rooms + resistance heating',
      H7: 'House 5 rooms + heat pump 5 kW',
      H8: 'Large apt. condo, highly electrified',
    },
    categoryDescriptions: {
      C1: "Very small business, max demand 8 kW, 8'000 kWh/year",
      C2: "Small business, max demand 15 kW, 30'000 kWh/year",
      C3: "Medium business, max demand 50 kW, 150'000 kWh/year",
      C4: "Large business, 150 kW demand, low voltage, 500'000 kWh/year",
      C5: "Large business, 150 kW demand, medium voltage, own transformer station, 500'000 kWh/year",
      C6: "Large business, 400 kW demand, medium voltage, own transformer station, 1'500'000 kWh/year",
      C7: "Large business, 1'630 kW demand, medium voltage, own transformer station, 7'500'000 kWh/year",
      H1: "2-room apartment with electric cooker, 1'600 kWh/year",
      H2: "4-room apartment with electric cooker, 2'500 kWh/year",
      H3: "4-room apartment with electric cooker, electric water heater (no tumble dryer), 4'500 kWh/year",
      H4: "5-room apartment with electric cooker, electric water heater and tumble dryer, 4'500 kWh/year",
      H5: "Detached house, 5 rooms, electric cooker, electric water heater, tumble dryer, 7'500 kWh/year",
      H6: "Detached house, 5 rooms, electric cooker, electric water heater, tumble dryer, electric resistance heating, 25'000 kWh/year",
      H7: "Detached house, 5 rooms, electric cooker, electric water heater, tumble dryer, heat pump 5 kW, 13'000 kWh/year",
      H8: "Large apartment in condominium, highly electrified (cooker, water heater, dryer, dishwasher), 7'500 kWh/year",
    },
    categoryGroups: {
      commercial: 'Businesses (C1-C7)',
      commercialSubtitle: 'Commercial / industrial consumption',
      residential: 'Households (H1-H8)',
      residentialSubtitle: 'Residential consumption',
    },
    charts: {
      noData: 'No chart data available',
      priceEvolution: {
        axis: {
          price: 'Price (Rp./kWh)',
        },
        subtitle: 'Historical tariff trends (Rp./kWh)',
        summary: {
          avgChange: 'Avg. change',
          decreasing: 'Decreasing',
          increasing: 'Increasing',
          stable: 'Stable',
          title: 'Price trends {{startYear}}–{{endYear}}',
          trend: 'Trend',
        },
        title: 'Price Evolution by Grid Operator',
      },
    },
    comparison: {
      aboveCantonMedian: 'above canton median',
      aboveNationalMedian: 'above national median',
      belowCantonMedian: 'below canton median',
      belowNationalMedian: 'below national median',
      canton: 'Canton median',
      switzerland: 'Switzerland median',
      thisLocation: 'This location',
      title: 'Geographic Price Comparison',
    },
    efficiency: {
      high: 'Low Cost',
      low: 'High Cost',
      medium: 'Average Cost',
    },
    evolution: {
      '10year': '10 years',
      '1year': '1 year',
      '2year': '2 years',
      '5year': '5 years',
      na: 'N/A',
      title: 'Price Evolution Summary',
    },
    filters: {
      category: 'Category',
      categoryTrigger: 'Category:',
      location: 'Location',
    },
    gridOperators: {
      cheapest: 'Cheapest',
      distribution: 'Network usage',
      energy: 'Energy',
      name: 'Grid operator',
      supplement: 'Supplement',
      taxes: 'Taxes',
      title: 'Grid Operator Comparison',
      total: 'Total',
      unit: 'Rp./kWh',
    },
    insights: {
      highEfficiency: 'Electricity prices in this municipality are below both canton and national medians. This is favorable for operating costs and heat pump economics.',
      lowEfficiency: 'Electricity prices in this municipality are above both canton and national medians. This significantly increases operating costs, especially for properties with electric heating or heat pumps.',
      mediumEfficiency: 'Electricity prices in this municipality are close to regional and national medians. Operating costs are in the typical range for Switzerland.',
      title: 'Electricity Cost Rating',
    },
    metrics: {
      annualCost: {
        subtitle: 'Estimated yearly bill (cheapest)',
        title: 'Annual Cost',
      },
      cheapestPrice: {
        subtitle: 'Best available rate (Rp./kWh)',
        title: 'Cheapest Price',
      },
      priceRange: {
        subtitle: 'Min – Max across grid operators',
        title: 'Price Range',
      },
    },
    states: {
      categoryNotAvailable: 'No data available for this category. Only the H4 category (Medium house) is currently available.',
      error: 'Error: {{error}}',
      fetchError: 'Failed to fetch electricity data',
      loading: 'Loading electricity price data...',
      noData: 'No electricity price data available for this location.',
      noHistoricalData: 'No historical price data available.',
    },
    subtitle: 'Tariff data from grid operators (ElCom)',
    tabs: {
      overview: 'Overview',
      trends: 'Trends',
    },
    title: 'Electricity Prices',
    tooltips: {
      annualCost: {
        calculation: 'Cheapest tariff (Rp./kWh) × annual consumption (kWh) for the selected category.',
        importance: 'Key component of operating costs for total cost of ownership calculations.',
        limitations: 'Actual consumption may vary. Based on ElCom standard consumption profiles.',
        shortDescription: 'Estimated yearly electricity bill based on the cheapest grid operator and standard consumption.',
        source: 'ElCom (Federal Electricity Commission)',
        title: 'Estimated Annual Cost',
      },
      cheapestPrice: {
        calculation: 'Includes network usage, energy, taxes, and federal supplement (KEV).',
        importance: 'Directly impacts operating costs (Nebenkosten) for property owners and tenants.',
        limitations: 'Prices may change annually. Based on standard consumption profiles from ElCom.',
        shortDescription: 'The lowest total electricity tariff available in this municipality from any grid operator.',
        source: 'ElCom (Federal Electricity Commission)',
        title: 'Cheapest Electricity Price',
      },
      priceRange: {
        calculation: 'Minimum and maximum total price across all grid operators for the selected category.',
        importance: 'A wider range means potential savings by choosing the right grid operator.',
        limitations: 'Not all grid operators may serve all addresses within a municipality.',
        shortDescription: 'The spread between cheapest and most expensive grid operator in this municipality.',
        source: 'ElCom (Federal Electricity Commission)',
        title: 'Price Range',
      },
    },
  },
  elevation: {
    constraints: {
      amongTallest: {
        description: 'This building is already in the top {{percentile}}% of heights in the neighborhood. Additional height may face scrutiny.',
        title: 'Among Tallest in Neighborhood:',
      },
      architecturalCohesion: {
        description: 'Neighboring buildings are from a similar construction period. Elevation design should maintain architectural harmony.',
        title: 'Architectural Cohesion:',
      },
      heritageProtected: {
        description: 'This building has heritage protection status ({{rank}}). Any modifications require special authorization and may be restricted.',
        title: 'Heritage Protected:',
      },
      maxHeightReached: {
        description: 'The building has already reached or exceeded the maximum legal height for this zone. No additional floors can be added.',
        title: 'Maximum Height Reached:',
      },
      protectedNearby: {
        description: 'There are heritage-protected buildings in the immediate vicinity. Elevation projects may require heritage impact assessment.',
        title: 'Protected Buildings Nearby:',
      },
      structuralAssessment: {
        description: 'Building is {{age}} years old. A comprehensive structural assessment is recommended before any elevation project.',
        title: 'Structural Assessment Required:',
      },
    },
    elevationCharts: {
      far: {
        available: 'Available',
        current: 'Current',
        maximum: 'Maximum',
        subtitle: 'Current development density vs. maximum allowed',
        title: 'Floor Area Ratio ({{indiceType}}) Utilization',
        used: 'FAR Used',
      },
      height: {
        available: 'Available',
        availableMeters: '+{{meters}}m available',
        currentBuilding: 'Current\nBuilding',
        height: 'Height',
        legalMaximum: 'Legal\nMaximum',
        legend: {
          availableSpace: 'Available Space (+{{height}}m)',
          currentBuilding: 'Current Building ({{height}}m)',
          legalMaximum: 'Legal Maximum ({{height}}m)',
          neighborsAverage: 'Neighbors Avg ({{height}}m)',
          neighborsMaximum: 'Neighbors Max ({{height}}m)',
        },
        maxAllowedByZoning: 'Maximum allowed by zoning',
        neighborsAverage: 'Neighbors\nAverage',
        neighborsMaximum: 'Neighbors\nMaximum',
        subtitle: 'Building height vs. legal maximum and neighborhood context',
        title: 'Height Comparison',
        utilization: 'Utilization',
      },
    },
    header: {
      subtitle: 'Analysis of vertical expansion possibilities',
      subtitleFull: 'Comprehensive analysis of building elevation potential based on zoning regulations, structural capacity, and neighborhood context',
      title: 'Upper Elevation Potential',
    },
    overview: {
      availableFloors: {
        label: 'Available Floors',
        tooltip: {
          calculation: 'Maximum legal floors - Current floors = Available floors',
          importance: 'Key metric for assessing vertical expansion potential',
          limitations: 'Subject to structural feasibility and building permits',
          shortDescription: 'Number of additional floors that can potentially be added based on zoning regulations',
          source: 'Cantonal zoning regulations',
          title: 'Available Floors for Elevation',
        },
      },
      availableHeight: {
        label: 'Available Height',
        limited: 'Limited space',
        none: 'No space',
        oneFloor: '1 floor possible',
        tooltip: {
          calculation: 'Maximum legal height - Current height = Available height',
          importance: 'Determines the physical space available for new floors',
          limitations: 'Does not account for roof structure requirements',
          shortDescription: 'Additional height in meters that can be added to the building',
          source: 'Building height data and zoning limits',
          title: 'Available Height for Elevation',
        },
        twoFloors: '2+ floors possible',
      },
      elevationScore: {
        label: 'Elevation Score',
        tooltip: {
          calculation: 'Weighted combination of available floors, regulatory compliance, and structural factors',
          categories: {
            excellent: 'Excellent potential',
            limited: 'Limited potential',
            moderate: 'Moderate potential',
            veryLow: 'Very low potential',
          },
          importance: 'Quick assessment of elevation viability for investment decisions',
          limitations: 'Does not replace professional structural and legal assessment',
          shortDescription: 'Composite score assessing the overall potential for building elevation',
          source: 'Popety.io proprietary algorithm',
          title: 'Overall Elevation Feasibility Score',
        },
      },
      feasibility: {
        buildingAge: {
          historic: 'Historic',
          label: 'Building Age',
          mature: 'Mature',
          modern: 'Modern',
          old: 'Old',
          tooltip: {
            calculation: 'Current year - Construction year',
            categories: {
              historic: 'Historic (100+ years): Comprehensive assessment essential',
              mature: 'Mature (30-60 years): Assessment recommended',
              modern: 'Modern (0-30 years): Standard structural capacity',
              old: 'Old (60-100 years): Detailed assessment required',
            },
            importance: 'Older buildings may require structural reinforcement',
            shortDescription: "How the building's age affects elevation feasibility and required assessments",
            source: 'Federal building registry (GWR)',
            title: 'Building Age Impact on Elevation',
          },
          years: '{{years}} years',
        },
        heritageProtection: {
          label: 'Heritage Protection',
          tooltip: {
            importance: 'Protected buildings face significant restrictions on modifications',
            shortDescription: 'The heritage protection classification of the building, if any',
            source: 'Cantonal heritage registers',
            title: 'Heritage Protection Status',
          },
        },
        overallRating: {
          excellent: 'Excellent',
          good: 'Good',
          label: 'Overall Rating',
          limited: 'Limited',
          poor: 'Poor',
          tooltip: {
            calculation: 'Weighted combination of regulatory, structural, and neighborhood factors',
            categories: {
              excellent: {
                description: 'Highly favorable conditions for elevation',
                label: 'Excellent (70-100)',
              },
              good: {
                description: 'Favorable with some considerations',
                label: 'Good (40-69)',
              },
              limited: {
                description: 'Significant constraints to overcome',
                label: 'Limited (20-39)',
              },
              poor: {
                description: 'Major obstacles; elevation unlikely feasible',
                label: 'Poor (0-19)',
              },
            },
            importance: 'Quick reference for investment decision-making',
            limitations: 'Professional assessment recommended for final decisions',
            shortDescription: 'Comprehensive assessment combining all feasibility factors',
            title: 'Overall Feasibility Rating',
          },
        },
        quartierBuildings: {
          label: 'Quartier Buildings',
          tooltip: {
            importance: 'Larger sample provides more reliable neighborhood context',
            shortDescription: 'Number of buildings in the analyzed neighborhood area',
            source: 'Federal building registry (GWR)',
            title: 'Total Buildings in Neighborhood',
          },
        },
        similarPeriod: {
          label: 'Similar Period Buildings',
          noFlexible: 'No - More flexible',
          tooltip: {
            importance: 'May influence design requirements for elevation projects',
            shortDescription: 'Whether neighboring buildings were constructed in a similar time period, requiring architectural cohesion',
            source: 'Analysis of neighborhood construction dates',
            title: 'Neighboring Buildings from Similar Construction Period',
          },
          yesRequired: 'Yes - Cohesion required',
        },
        title: 'Feasibility Assessment',
      },
      legalFramework: {
        availableFarSpace: {
          label: 'Available FAR Space',
          tooltip: {
            calculation: '(Maximum FAR - Current FAR) × Land area',
            importance: 'Key metric for determining additional buildable area',
            shortDescription: 'Additional floor area in m² that can be built based on FAR regulations',
            source: 'Calculated from land registry and zoning data',
            title: 'Available Floor Area Ratio Space',
          },
        },
        currentFloors: {
          label: 'Current Floors',
          tooltip: {
            calculation: 'Count of floors above ground level, excluding basement',
            importance: 'Baseline for calculating additional floor potential',
            shortDescription: 'The current number of above-ground floors in the building',
            source: 'Federal building registry (GWR)',
            title: 'Current Number of Floors',
          },
        },
        currentHeight: {
          label: 'Current Height',
          tooltip: {
            calculation: 'Measured from natural ground level to roof ridge',
            importance: 'Reference point for calculating available elevation space',
            shortDescription: 'The measured height of the building from ground level to the highest point',
            source: 'Federal building registry (GWR)',
            title: 'Current Building Height',
          },
        },
        farIndex: {
          label: 'FAR Index Used',
          tooltip: {
            calculation: 'Determined by cantonal regulations based on zone type',
            categories: {
              sp: {
                description: 'Floor area index - Canton Vaud',
                label: 'Floor area (FA)',
              },
              spd: {
                description: 'Determining floor area index - Canton Geneva',
                label: 'Determining floor area (DFA)',
              },
              std: {
                description: 'Determining land area index',
                label: 'Determining land area (DLA)',
              },
            },
            importance: 'Determines the calculation method for buildable area',
            shortDescription: 'The type of floor area ratio index applicable to this property',
            source: 'Cantonal construction regulations',
            title: 'Floor Area Ratio Index',
          },
        },
        maxLegalFloors: {
          label: 'Max Legal Floors',
          tooltip: {
            calculation: 'Derived from maximum height divided by standard floor height (3m)',
            importance: 'Determines the upper limit for vertical expansion',
            limitations: 'May vary based on building type and specific zone rules',
            shortDescription: 'The maximum number of floors allowed for buildings in this zone',
            source: 'Cantonal zoning regulations',
            title: 'Maximum Legal Number of Floors',
          },
        },
        maxLegalHeight: {
          label: 'Max Legal Height',
          tooltip: {
            calculation: 'Defined by cantonal and municipal zoning plans',
            importance: 'Hard limit that cannot be exceeded without special dispensation',
            limitations: 'May be subject to additional constraints like distance rules',
            shortDescription: 'The maximum height allowed for buildings in this zone according to zoning regulations',
            source: 'Municipal zoning regulations',
            title: 'Maximum Legal Building Height',
          },
        },
        title: 'Legal Framework',
      },
      legalStatus: {
        floorsPossible: '{{count}} floor(s) possible',
        label: 'Legal Status',
        noExpansion: 'No expansion possible',
        tooltip: {
          categories: {
            allowed: {
              description: 'Building can be elevated within zoning limits',
              label: 'Elevation Allowed',
            },
            assessment: {
              description: 'Detailed assessment needed to determine feasibility',
              label: 'Requires Assessment',
            },
            maximum: {
              description: 'Building has reached maximum allowed height',
              label: 'Maximum Reached',
            },
            protected: {
              description: 'Heritage protection restricts modifications',
              label: 'Protected Building',
            },
          },
          importance: 'Determines if elevation is legally possible',
          limitations: 'Based on current regulations; may change over time',
          shortDescription: 'Current regulatory status regarding building elevation possibilities',
          source: 'Cantonal building regulations and heritage registers',
          title: 'Legal Status for Elevation',
        },
      },
      neighborhoodFit: {
        avgHeight: {
          label: 'Neighbors Avg Height',
          tooltip: {
            calculation: 'Mean height of all buildings within neighborhood radius',
            importance: 'Reference for contextual building height assessment',
            shortDescription: 'The average height of buildings in the immediate neighborhood',
            source: 'Federal building registry (GWR)',
            title: 'Average Height of Neighboring Buildings',
          },
        },
        buildingDensity: {
          label: 'Building Density',
          tooltip: {
            calculation: 'Building footprint / Land area, compared to neighborhood',
            importance: 'High density may limit expansion options',
            shortDescription: 'How dense the building coverage is compared to the neighborhood average',
            source: 'Land registry and building footprint data',
            title: 'Building Density Percentile',
          },
        },
        contiguityRatio: {
          label: 'Contiguity Ratio',
          tooltip: {
            calculation: 'Shared wall length / Total perimeter × 100',
            importance: 'High contiguity affects construction complexity and neighbor coordination',
            shortDescription: 'Percentage of building perimeter shared with adjacent buildings',
            source: 'Building footprint analysis',
            title: 'Building Contiguity Ratio',
          },
        },
        heightPercentile: {
          label: 'Height Percentile',
          tooltip: {
            calculation: 'Percentage of neighborhood buildings that are shorter',
            categories: {
              belowAvg: 'Below average',
              lowerMid: 'Lower middle',
              tallest: 'Among tallest',
              upperMid: 'Upper middle',
            },
            importance: 'Indicates how elevation might affect neighborhood skyline',
            shortDescription: "How this building's height compares to others in the immediate neighborhood",
            source: 'Analysis of neighboring buildings within 100m radius',
            title: 'Building Height Percentile in Neighborhood',
          },
        },
        protectedNearby: {
          label: 'Protected Nearby',
          tooltip: {
            importance: 'May require heritage impact assessment for elevation projects',
            shortDescription: 'Indicates if there are heritage-protected buildings in the immediate vicinity',
            source: 'Cantonal heritage registers',
            title: 'Protected Buildings Nearby',
          },
        },
        tallestNeighbor: {
          label: 'Tallest Neighbor',
          tooltip: {
            calculation: 'Maximum height among all neighborhood buildings',
            importance: 'Indicates existing height precedent in the area',
            shortDescription: 'The height of the tallest building in the immediate neighborhood',
            source: 'Federal building registry (GWR)',
            title: 'Tallest Building in Neighborhood',
          },
        },
        title: 'Neighborhood Fit',
      },
    },
    regulatory: {
      approvals: {
        architecturalPlans: 'Architectural Plans',
        buildingPermit: 'Building Permit',
        elevator: 'Elevator Installation',
        fireSafety: 'Fire Safety Approval',
        heritageConsultation: 'Heritage Consultation',
        heritageImpact: 'Heritage Impact Assessment',
        recommended: 'Recommended',
        required: 'Required',
        structuralReview: 'Structural Review',
        title: 'Required Approvals',
      },
      farCompliance: {
        availableSpace: {
          label: 'Available FAR Space',
          tooltip: {
            importance: 'Key metric for determining additional construction potential',
            shortDescription: 'Additional buildable area in m² based on FAR limits',
            source: 'Calculated from land registry and zoning data',
            title: 'Available Floor Area Space',
          },
        },
        indiceType: {
          label: 'Index Type Used',
          tooltip: {
            shortDescription: 'The specific FAR calculation method used in this canton',
            source: 'Cantonal construction regulations',
            title: 'Floor Area Ratio Index Type',
          },
        },
        sp: 'Floor area (FA)',
        spd: 'Determining floor area (DFA)',
        std: 'Determining land area (DLA)',
        title: 'FAR Compliance',
      },
      heightFloor: {
        availableFloors: 'Available Floors',
        availableHeight: 'Available Height',
        currentFloors: 'Current Floors',
        currentHeight: {
          label: 'Current Height',
          tooltip: {
            shortDescription: 'Measured height from ground level to roof peak',
            source: 'Federal building registry (GWR)',
            title: 'Current Building Height',
          },
        },
        maxLegalFloors: 'Max Legal Floors',
        maxLegalHeight: {
          label: 'Max Legal Height',
          tooltip: {
            importance: 'Legal limit that cannot be exceeded without special authorization',
            shortDescription: 'Maximum building height allowed by zoning regulations',
            source: 'Municipal zoning regulations',
            title: 'Maximum Legal Height',
          },
        },
        title: 'Height & Floor Regulations',
      },
      timeline: {
        construction: 'Construction',
        constructionDuration: '{{min}}-{{max}} months',
        heritageReview: 'Heritage Review',
        heritageReviewDuration: '+3-6 months',
        permitApplication: 'Permit Application',
        permitApplicationDuration: '3-6 months',
        preliminaryStudies: 'Preliminary Studies',
        preliminaryStudiesDuration: '2-4 months',
        title: 'Estimated Timeline',
        totalDuration: 'Total Duration',
        totalProtected: '18-24 months',
        totalStandard: '12-18 months',
      },
    },
    score: {
      label: 'Elevation Score',
      tooltip: 'Overall assessment of elevation feasibility combining regulatory, structural, and neighborhood factors',
    },
    shared: {
      estimated: 'estimated',
      month: 'month',
      na: 'N/A',
      no: 'No',
      none: 'None',
      units: 'units',
      year: 'year',
      yes: 'Yes',
    },
    states: {
      error: 'Error loading data: {{error}}',
      loading: 'Loading elevation data...',
      noBuilding: 'No building selected',
      noData: {
        description: 'Upper elevation potential analysis is not available for this building. This may be due to missing zoning data or the building being in a zone where elevation analysis is not applicable.',
        title: 'Elevation Data Not Available',
      },
    },
    status: {
      elevationAllowed: 'Elevation Allowed',
      maximumReached: 'Maximum Reached',
      protectedBuilding: 'Protected Building',
      requiresAssessment: 'Requires Assessment',
    },
    structural: {
      condition: {
        assessmentNeeded: 'Assessment needed',
        buildingAge: 'Building Age',
        foundationReinforcement: 'Foundation Reinforcement',
        inDepthRequired: 'In-depth required',
        likelyNotRequired: 'Likely not required',
        likelyRequired: 'Likely required',
        loadBearingWalls: 'Load-Bearing Walls',
        mature: 'Mature',
        modern: 'Modern',
        old: 'Old',
        professionalReview: 'Professional review needed',
        standardReview: 'Standard review',
        structuralCapacity: {
          label: 'Structural Capacity',
          tooltip: {
            importance: 'Critical factor for determining elevation feasibility',
            shortDescription: "Assessment of the building's ability to support additional floors",
            source: 'Based on building age and construction standards',
            title: 'Structural Load-Bearing Capacity',
          },
        },
        title: 'Building Condition Assessment',
        years: '{{years}} years',
      },
      method: {
        craneAccess: 'Crane Access',
        critical: 'Critical',
        highCarefulPlanning: 'High - careful planning',
        lightSteelClt: 'Light steel/CLT frame',
        neighborImpact: 'Neighbor Impact',
        recommended: 'Recommended',
        recommendedMethod: 'Recommended Method',
        siteSurveyRequired: 'Site survey required',
        standardMeasures: 'Standard measures',
        steelFrameConcrete: 'Steel frame + concrete',
        title: 'Construction Method',
        traditionalMasonry: 'Traditional masonry',
        weightOptimization: 'Weight Optimization',
      },
      reinforcement: {
        assessmentRequired: 'Assessment required',
        basicAssessment: 'Basic assessment',
        estimatedWeight: 'Estimated Additional Weight',
        foundationAssessment: 'Foundation Assessment',
        inDepthGeotechnical: 'In-depth geotechnical study',
        reinforcementNeeded: 'Reinforcement needed',
        seismic: 'Seismic Compliance',
        siaStandards: 'SIA standards apply',
        standardSoilTest: 'Standard soil test',
        structuralFrame: 'Structural Frame',
        title: 'Structural Reinforcement Needs',
        typicallyAdequate: 'Typically adequate',
        weightRange: '{{min}}-{{max}} kg/m²',
      },
      requirements: {
        accessDuringConstruction: 'Access During Construction',
        elevator: 'Elevator Requirement',
        elevatorRequired: 'Elevator required (4+ floors)',
        enhancedRequirements: 'Enhanced requirements',
        fireSafety: 'Fire Safety',
        notRequired: 'Not required',
        planningRequired: 'Planning required',
        standard: 'Standard',
        temporaryRoof: 'Temporary roof needed',
        title: 'Construction Requirements',
        weatherProtection: 'Weather Protection',
      },
    },
    tabs: {
      overview: 'Overview',
      regulatory: 'Regulatory',
      structural: 'Structural',
    },
  },
  employment: {
    charts: {
      employmentTrend: {
        axis: {
          employment: 'Employment',
        },
        legend: {
          fullTimeEmployment: 'Full-Time Employment',
          totalEmployment: 'Total Employment',
        },
        noData: 'No employment trend data available',
        subtitle: 'Historical employment evolution showing job market trajectory (2011-2022)',
        summary: {
          annualCompoundGrowth: 'annual compound growth',
          cagr: 'CAGR',
          currentFTRatio: 'Current FT ratio',
          declining: 'Declining',
          fullTimeGrowth: 'Full-time growth',
          growing: 'Growing',
          jobMarketStatus: 'Job market status',
          ofJobsAreFullTime: 'of jobs are full-time',
          rapidGrowth: 'Rapid growth',
          stableGrowth: 'Stable growth',
          title: '{{years}}-Year Employment Trend ({{startYear}}-{{endYear}})',
          totalJobGrowth: 'Total job growth',
        },
        title: 'Employment Trend',
        tooltips: {
          fullTime: 'Full-Time',
          totalJobs: 'Total Jobs',
          year: 'Year',
        },
      },
      fullTimeVsTotal: {
        subtitle: 'Comparing full-time and total employment trends showing job quality evolution',
        title: 'Full-Time vs Total Employment',
      },
      jobsPerEstablishment: {
        average: 'Avg',
        axis: {
          ratio: 'Jobs per Establishment',
        },
        noData: 'No jobs per establishment data available',
        subtitle: 'Economic efficiency indicator showing average business size over time',
        summary: {
          balancedMix: 'Balanced mix of business sizes',
          consolidating: 'Consolidating - Larger businesses emerging, fewer small firms',
          currentRatio: 'Current ratio',
          fragmenting: 'Fragmenting - More small businesses, entrepreneurial growth',
          historicalChange: 'Historical change',
          interpretation: 'Interpretation',
          jobsPerEstablishment: 'jobs per establishment',
          largeEmployerDominated: 'Large employer dominated - Corporate economy',
          periodAverage: 'Period average',
          smallBusinessEconomy: 'Small business economy - Entrepreneurial environment',
          title: 'Economic Efficiency Trend ({{startYear}}-{{endYear}})',
        },
        title: 'Jobs per Establishment Ratio',
        tooltips: {
          employment: 'Employment',
          establishments: 'Establishments',
          jobsPerEstablishment: 'jobs/establishment',
          ratio: 'Ratio',
          year: 'Year',
        },
      },
      publicPrivate: {
        axis: {
          employment: 'Employment',
          establishments: 'Establishments',
        },
        legend: {
          privateSector: 'Private Sector',
          publicSector: 'Public Sector',
        },
        noData: 'No public/private distribution data available',
        subtitle: 'Historical split between public and private sector establishments',
        summary: {
          balancedMix: 'Balanced public-private mix',
          governmentDominated: 'Government-dominated economy - Stable but slower growth',
          investmentImplications: 'Investment implications',
          marketCharacter: 'Market character',
          marketDrivenDemand: 'Market-driven demand, higher growth potential, diverse tenant mix',
          privateDriven: 'Private sector-driven economy - Dynamic and entrepreneurial',
          privateSector: 'Private sector',
          publicSector: 'Public sector',
          stableTenantBase: 'Stable tenant base, lower vacancy risk, government-focused real estate',
          title: 'Public vs Private Sector ({{year}})',
        },
        title: 'Public vs Private Distribution',
        tooltips: {
          private: 'Private',
          public: 'Public',
          total: 'Total',
          year: 'Year',
        },
      },
      sectorComposition: {
        noData: 'No sector data available',
        subtitle: 'Economic structure by sector showing employment distribution',
        summary: {
          balancedDiversified: 'Balanced diversified economy',
          dominantSector: 'Dominant sector',
          economicCharacter: 'Economic character',
          highlyServiceOriented: 'Highly service-oriented economy',
          jobs: 'jobs',
          primarySectorEconomy: 'Primary sector economy',
          strongIndustrialBase: 'Strong industrial base',
          title: 'Economic Structure',
        },
        title: 'Sector Composition',
        tooltips: {
          jobs: 'Jobs',
          share: 'Share',
        },
      },
      sectorEvolution: {
        axis: {
          employment: 'Employment',
        },
        legend: {
          primarySector: 'Primary Sector',
          secondarySector: 'Secondary Sector',
          tertiarySector: 'Tertiary Sector',
        },
        noData: 'No sector evolution data available',
        subtitle: 'Historical sector composition showing economic transitions (2011-2022)',
        summary: {
          economicTransformation: 'Economic transformation',
          gradualTransition: 'Gradual economic transition',
          serviceSectorTrend: 'Service sector trend',
          significantStructuralChange: 'Significant structural change',
          stableSectorComposition: 'Stable sector composition',
          title: 'Sector Evolution ({{startYear}}-{{endYear}})',
          totalEmploymentChange: 'Total employment change',
        },
        title: 'Sector Evolution Over Time',
        tooltips: {
          total: 'Total',
          year: 'Year',
        },
      },
      totalEmploymentTrend: {
        subtitle: 'Historical employment showing growth phases and turning points (2011-2022)',
        title: 'Total Employment Trend',
      },
    },
    common: {
      establishments: 'establishments',
      jobs: 'jobs',
    },
    filters: {
      byBicycle: 'By Bicycle',
      byCar: 'By Car',
      byWalk: 'By Walk',
      city: 'City',
      district: 'District',
      location: 'Location:',
      minBike: '{{minutes}}min bike',
      minDrive: '{{minutes}}min drive',
      minWalk: '{{minutes}}min walk',
      selectLocation: 'Select location',
    },
    loading: {
      employment: 'Loading employment data...',
      error: 'Error loading employment data:',
      fetchFailed: 'Failed to fetch employment data',
      noData: 'Employment data is not available for this location.',
    },
    metrics: {
      cagr: {
        subtitle: '10-year compound rate',
        title: 'Annual Growth Rate (CAGR)',
      },
      dominantSector: {
        subtitle: '{{percentage}}% of total employment',
        title: 'Dominant Sector',
      },
      employmentGrowth: {
        subtitle: '10-year evolution',
        title: 'Employment Growth',
      },
      establishmentGrowth: {
        subtitle: '10-year evolution',
        title: 'Establishment Growth',
      },
      fiveYearGrowth: {
        subtitle: 'Medium-term trajectory',
        title: '5-Year Growth',
      },
      fullTimeRatio: {
        subtitle: 'Stability indicator',
        title: 'Full-Time Employment Ratio',
      },
      jobsPerEstablishment: {
        subtitle: 'Economic efficiency',
        title: 'Jobs per Establishment',
      },
      oneYearGrowth: {
        subtitle: 'Most recent trend',
        title: '1-Year Growth',
      },
      privateSectorShare: {
        subtitle: '{{count}} establishments',
        title: 'Private Sector Share',
      },
      publicSectorShare: {
        subtitle: '{{count}} establishments',
        title: 'Public Sector Share',
      },
      tenYearGrowth: {
        subtitle: 'Long-term structural change',
        title: '10-Year Growth',
      },
      totalEmployment: {
        subtitle: 'Jobs in the area',
        title: 'Total Employment',
      },
      totalEstablishments: {
        subtitle: 'Business count',
        title: 'Total Businesses',
      },
      twoYearGrowth: {
        subtitle: 'Recent trend confirmation',
        title: '2-Year Growth',
      },
    },
    section: {
      subtitle: 'Job market trends and business activity insights for the local area',
      title: 'Employment',
    },
    sectors: {
      agriculture: 'Agriculture',
      industry: 'Industry',
      primary: {
        description: 'Agriculture, Mining',
        name: 'Primary Sector (Agriculture, Mining)',
        short: 'Primary',
      },
      privateSector: 'Private Sector',
      publicSector: 'Public Sector',
      secondary: {
        description: 'Industry, Construction',
        name: 'Secondary Sector (Industry, Construction)',
        short: 'Secondary',
      },
      services: 'Services',
      tertiary: {
        description: 'Services',
        name: 'Tertiary Sector (Services)',
        short: 'Tertiary',
      },
    },
    tabs: {
      business: 'Business Activity',
      growth: 'Employment Growth',
      overview: 'Overview',
      sectors: 'Economic Sectors',
    },
    tooltips: {
      cagr: {
        calculation: '((Current Employment / Employment 10 Years Ago)^(1/10) - 1) × 100',
        importance: 'Smooths out yearly variations to show underlying employment growth trend. More accurate than simple average.',
        limitations: 'Assumes steady growth, actual growth may be irregular with boom/bust cycles',
        shortDescription: 'Average annual employment growth rate over 10 years, accounting for compounding',
        source: 'Calculated from Swiss Federal Statistical Office data',
        title: 'Compound Annual Growth Rate',
      },
      dominantSector: {
        calculation: 'Sector with max(Sector 1 %, Sector 2 %, Sector 3 %)',
        importance: "Indicates the area's economic character. Services-dominant areas have white-collar workforce supporting higher property values. Industry-dominant areas need worker housing. Agriculture indicates rural character.",
        limitations: 'Sector 3 (Services) is very broad, including everything from retail to finance.',
        shortDescription: 'Economic sector with the highest share of employment',
        source: 'Swiss Federal Statistical Office - Sector employment data',
        title: 'Dominant Sector',
      },
      employmentGrowth: {
        calculation: '(Current Employment - Employment 10 years ago) / Employment 10 years ago',
        importance: 'Job growth is THE major driver for real estate demand. Positive growth indicates appreciation potential and increasing property demand.',
        limitations: 'Historical trends may not predict future performance. External shocks can alter trajectory.',
        shortDescription: 'Employment change over the last 10 years',
        source: 'Swiss Federal Statistical Office - Historical employment data',
        title: 'Employment Growth',
      },
      establishmentGrowth: {
        calculation: '(Current Establishments - Establishments 10 Years Ago) / Establishments 10 Years Ago',
        importance: 'Leading indicator for employment growth. New businesses often hire ahead of revenue. Positive growth suggests entrepreneurial ecosystem and future job creation.',
        limitations: "Business formation can precede failure. Net count doesn't show turnover dynamics.",
        shortDescription: 'Change in number of businesses over 10 years',
        source: 'Swiss Federal Statistical Office - Historical establishment data',
        title: 'Establishment Growth',
      },
      fiveYearGrowth: {
        calculation: '(Current Year Employment - Employment 5 Years Ago) / Employment 5 Years Ago',
        importance: 'Medium-term trend indicator. More reliable than short-term but still responsive to structural changes.',
        limitations: 'Includes COVID-19 pandemic period which may distort trends.',
        shortDescription: 'Employment change over the last 5 years',
        source: 'Swiss Federal Statistical Office - Annual employment data',
        title: '5-Year Employment Growth',
      },
      fullTimeRatio: {
        calculation: '(Full-Time Employment / Total Employment) × 100',
        importance: 'Higher ratios indicate more stable employment and income. More full-time workers means more reliable demand for housing and commercial space.',
        limitations: "Part-time can be voluntary or involuntary. Doesn't reflect income levels or job security.",
        shortDescription: 'Percentage of total employment that is full-time',
        source: 'Swiss Federal Statistical Office - Employment type statistics',
        title: 'Full-Time Employment Ratio',
      },
      jobsPerEstablishment: {
        calculation: 'Total Employment / Total Establishments',
        importance: 'Indicates average business size and economic structure. Higher ratios suggest larger employers, lower ratios indicate small business economy.',
        limitations: "Doesn't distinguish between sectors. Large employers can skew the average.",
        shortDescription: 'Average number of employees per business',
        source: 'Calculated from establishment and employment census data',
        title: 'Jobs per Establishment',
      },
      oneYearGrowth: {
        calculation: '(Current Year Employment - Previous Year Employment) / Previous Year Employment',
        importance: 'Shows most recent momentum. Rapid recent growth may indicate emerging opportunity, decline may signal early warning.',
        limitations: 'Can be volatile due to short timeframe. Single-year data may not reflect trend.',
        shortDescription: 'Employment change over the last year',
        source: 'Swiss Federal Statistical Office - Annual employment data',
        title: '1-Year Employment Growth',
      },
      primarySector: {
        calculation: 'Sum of all employment in NOGA Sector 1 activities',
        importance: 'Primary sector dominance indicates rural character with specialized real estate opportunities. Typically lower property values but stable long-term demand.',
        limitations: 'Subject to seasonal variations. May include part-time agricultural workers.',
        shortDescription: 'Jobs in agriculture, forestry, fishing, and mining',
        source: 'Swiss Federal Statistical Office - Sector classification by NOGA codes',
        title: 'Primary Sector Employment',
      },
      privateSectorEstablishments: {
        calculation: '(Private Sector Establishments / Total Establishments) × 100',
        importance: 'High private sector indicates entrepreneurial, market-driven economy. More dynamic but potentially volatile. Diverse commercial real estate demand.',
        limitations: "Doesn't distinguish between small businesses and large corporations.",
        shortDescription: 'Percentage of establishments that are private businesses',
        source: 'Swiss Federal Statistical Office - Sector classification',
        title: 'Private Sector Establishments',
      },
      publicSectorEstablishments: {
        calculation: '(Public Sector Establishments / Total Establishments) × 100',
        importance: 'High public sector presence indicates government-dependent economy. More stable but slower growth. Different tenant profile for commercial real estate.',
        limitations: "Doesn't reflect employment size. One large government entity counted same as small office.",
        shortDescription: 'Percentage of establishments that are government entities',
        source: 'Swiss Federal Statistical Office - Sector classification',
        title: 'Public Sector Establishments',
      },
      secondarySector: {
        calculation: 'Sum of all employment in NOGA Sector 2 activities',
        importance: 'Industrial base creates demand for workforce housing, logistics facilities, and commercial properties. Blue-collar workforce typically requires affordable housing options.',
        limitations: 'Can be cyclical with economic conditions. Automation may reduce employment over time.',
        shortDescription: 'Jobs in manufacturing, construction, and industrial production',
        source: 'Swiss Federal Statistical Office - Sector classification by NOGA codes',
        title: 'Secondary Sector Employment',
      },
      tenYearGrowth: {
        calculation: '(Current Year Employment - Employment 10 Years Ago) / Employment 10 Years Ago',
        importance: 'Long-term structural trend. Best indicator of fundamental economic transformation and property demand trajectory.',
        limitations: 'Long timeframe may obscure recent changes. Includes multiple economic cycles.',
        shortDescription: 'Employment change over the last 10 years',
        source: 'Swiss Federal Statistical Office - Annual employment data',
        title: '10-Year Employment Growth',
      },
      tertiarySector: {
        calculation: 'Sum of all employment in NOGA Sector 3 activities',
        importance: 'Service sector dominance indicates urban character with strong demand for residential and retail properties. White-collar workforce supports higher property values.',
        limitations: 'Broad category including very different job types and income levels.',
        shortDescription: 'Jobs in services, retail, finance, education, healthcare, and hospitality',
        source: 'Swiss Federal Statistical Office - Sector classification by NOGA codes',
        title: 'Tertiary Sector Employment',
      },
      totalEmployment: {
        calculation: 'Sum of all employment (full-time and part-time) across all sectors',
        importance: 'Indicates economic activity level and labor market size. Higher employment suggests stronger property demand.',
        limitations: 'Based on official statistics, may not include informal economy or self-employed individuals',
        shortDescription: 'Total number of jobs in the defined geographic area',
        source: 'Swiss Federal Statistical Office - Enterprise Census',
        title: 'Total Employment',
      },
      totalEstablishments: {
        calculation: 'Count of all registered business locations (public + private sector)',
        importance: 'Indicates business ecosystem size and economic diversity. More establishments suggest vibrant commercial environment supporting property values.',
        limitations: "Doesn't reflect business size or revenue. Includes very small businesses.",
        shortDescription: 'Total number of business establishments in the area',
        source: 'Swiss Federal Statistical Office - Enterprise Census',
        title: 'Total Establishments',
      },
      twoYearGrowth: {
        calculation: '(Current Year Employment - Employment 2 Years Ago) / Employment 2 Years Ago',
        importance: 'Confirms whether 1-year trend is sustained. Helps filter out one-time events.',
        limitations: 'Still relatively short-term. May include pandemic effects.',
        shortDescription: 'Employment change over the last 2 years',
        source: 'Swiss Federal Statistical Office - Annual employment data',
        title: '2-Year Employment Growth',
      },
    },
  },
  energy: {
    dataSource: {
      egid: 'Building ID (EGID)',
      regbl: 'Swiss Federal Building Registry (GWR)',
      title: 'Data Source',
      viewInRegBL: 'View in GWR',
    },
    dataSourceBanner: {
      description: 'This data is collected and maintained by federal and cantonal authorities. Last update dates vary by field and are shown next to each data point.',
      title: 'Data Source: Swiss Federal Building Registry (GWR)',
      viewCompleteRecord: 'View complete building record in GWR',
    },
    freshness: {
      daysAgo: '{{count}} days ago',
      fresh: 'Recently updated',
      levels: {
        aging: 'Aging',
        outdated: 'Outdated',
        recent: 'Recent',
      },
      monthsAgo: '{{count}} months ago',
      oneYearAgo: '1 year ago',
      stale: 'Data may be outdated',
      thisYear: 'this year',
      today: 'Today',
      yearsAgo: '{{count}} years ago',
      yesterday: 'Yesterday',
    },
    header: {
      subtitle: 'Building energy data from Swiss Federal Building Registry (GWR)',
      title: 'Energy Analysis',
    },
    heating: {
      card: {
        egidNotAvailable: 'EGID not available',
        entryOf: 'Entry {{number}} of {{total}}',
        mostRecent: 'Most Recent',
        title: 'Heating Systems',
      },
      checkRegBL: 'Check GWR',
      metrics: {
        distributionSystem: 'Distribution System',
        generatorType: 'Generator Type',
        lastUpdated: 'Last Updated',
        noDataAvailable: 'No data available',
        notDeclared: 'Not declared',
        powerSource: 'Power Source',
        status: 'Status',
      },
      multipleEntries: {
        description: 'This building has {{count}} separate entries in GWR, possibly from different registration dates or updates. All entries are shown below, sorted by most recent first.',
        title: 'Multiple Registry Entries Found',
      },
      noData: 'No heating system data available in GWR for this building.',
      sections: {
        additionalHeating: 'Additional Heating',
        additionalWaterHeating: 'Additional Water Heating',
        primaryHeating: 'Primary Heating',
        waterHeating: 'Water Heating',
      },
    },
    idc: {
      actionPlan: {
        heating: 'Upgrade heating system',
        insulation: 'Improve building insulation',
        solar: 'Install solar panels',
        title: 'Recommended Actions',
        windows: 'Replace windows with energy-efficient models',
      },
      comparison: {
        buildingAge: 'Similar Building Age',
        canton: 'Canton Average',
        district: 'District Average',
        title: 'IDC Comparison',
      },
      costEstimator: {
        annual: 'Annual Cost',
        perM2: 'Cost per m²',
        title: 'Estimated Energy Costs',
      },
      gauge: {
        current: 'Current IDC',
        legalLimit: 'Legal Limit',
        target: 'Target',
      },
      ratings: {
        average: 'Average',
        critical: 'Critical',
        excellent: 'Excellent',
        good: 'Good',
        poor: 'Poor',
      },
      regulatory: {
        compliant: 'Compliant',
        deadline: 'Compliance Deadline',
        nonCompliant: 'Non-compliant',
        title: 'Regulatory Compliance',
      },
      subtitle: 'Energy performance indicator for Geneva buildings',
      title: 'IDC - Heat Consumption Index',
    },
    idcComparisonCard: {
      noData: 'No comparison data available for this building.',
      noDataForZone: 'No data available for this zone.',
      performanceText: 'Your IDC of {{idc}} MJ/m² is at the {{percentile}} percentile among {{count}} buildings in {{scope}}.',
      scopeLabels: {
        municipality: 'Municipality',
        npa: 'Postal Code',
        radius_500m: '500m Radius',
        region: 'Canton',
      },
      stats: {
        average: 'Average',
        maximum: 'Maximum',
        median: 'Median',
        minimum: 'Minimum',
        percentile25: '25th percentile',
        percentile75: '75th percentile',
      },
      title: 'IDC Comparisons',
      tooltipDescription: 'Compare the IDC of this building with statistics from other buildings in Geneva. A lower percentile indicates better energy performance.',
      tooltipDescriptionLoading: 'Compare the IDC of this building with statistics from other buildings in Geneva in different geographic zones.',
    },
    idcDistributionChart: {
      title: 'IDC Distribution - {{scope}}',
      tooltipBuildings: 'Number of buildings: <strong>{{count}}</strong>',
      xAxisName: 'IDC (MJ/m²·year)',
      yAxisName: 'Number of buildings',
      yourBuilding: 'Your building',
    },
    idcGaugeChart: {
      legend: {
        compliant: 'Compliant (0-{{threshold}})',
        critical: 'Critical (>{{threshold}})',
        optimizationRequired: 'Optimization required ({{min}}-{{max}})',
        warning: 'Warning ({{min}}-{{max}})',
      },
      title: 'IDC Position',
      unit: 'MJ/m²·year',
    },
    idcRegulatoryBanner: {
      actionTypes: {
        audit: 'Energy audit recommended',
        mandatoryRenovation: 'Mandatory renovation required',
        noObligation: 'No regulatory obligation',
        optimization: 'Energy optimization required',
      },
      deadline: 'Deadline: {{year}}',
      yearsRemaining: {
        one: '({{count}} year remaining)',
        other: '({{count}} years remaining)',
      },
    },
    idcTab: {
      dataSourceNote: {
        description: 'Cantonal Energy Office (OCEN) - Canton of Geneva. The IDC is calculated based on actual declared and verified consumption. For more information:',
        linkText: 'ge.ch/energy',
        title: 'Data source:',
      },
      infoBanner: 'Heat Consumption Index (IDC) - Mandatory indicator for heated buildings in the Canton of Geneva. The IDC measures the annual energy consumption for heating and domestic hot water relative to the energy reference area (ERA).',
      metrics: {
        regulatoryThreshold: {
          title: 'Regulatory Threshold',
          tooltip: {
            calculation: 'Set at {{threshold}} MJ/m²/year ({{kWh}} kWh/m²/year) since September 2022',
            description: 'Threshold set by the Canton of Geneva above which optimization measures are required',
            importance: 'Exceeding this threshold triggers the obligation to implement energy optimization measures',
            source: 'Energy Law (LEn) - Canton of Geneva',
          },
        },
        significantExceedanceThreshold: {
          exceeded: 'Exceeded - Mandatory renovation',
          notExceeded: 'Not exceeded',
          periods: {
            from2031: 'from 2031',
            until2026: 'until 2026',
            until2030: 'until 2030',
          },
          title: 'Significant Exceedance Threshold',
          tooltip: {
            calculation: 'Currently {{threshold}} MJ/m² ({{period}}). The threshold is progressively lowered: 800 MJ/m² (2022-2026) → 650 MJ/m² (2027-2030) → 550 MJ/m² (2031+)',
            description: 'Beyond this threshold, mandatory energy renovation is required',
            importance: 'Exceeding this threshold triggers the legal obligation to carry out energy renovation within 3 years of the administrative decision',
            limitations: 'The threshold varies by year and will be progressively reduced to encourage continuous improvement of the building stock',
            source: 'Energy Regulation (REn) - Canton of Geneva',
          },
        },
        yourPosition: {
          title: 'Your Position',
          tooltip: {
            calculation: '(Building IDC - Regulatory Threshold) / Regulatory Threshold × 100',
            description: 'Deviation from the regulatory threshold of {{threshold}} MJ/m²',
            importance: 'Indicates whether your building complies with regulatory requirements or needs optimization measures',
            source: 'Calculated from OCEN data',
          },
        },
      },
    },
    regblLink: {
      viewBuildingTitle: 'View building {{egid}} in Swiss Federal Building Registry',
      viewInRegBL: 'View in GWR',
    },
    solar: {
      comparison: {
        actual: 'Current Installation',
        optimal: 'Optimal Potential',
        title: 'Solar Potential Comparison',
        utilizationRate: 'Utilization Rate',
      },
      history: {
        title: 'Installation History',
      },
      installation: {
        estimatedProduction: 'Est. Annual Production',
        installedPower: 'Installed Power',
        moduleArea: 'Module Area',
        title: 'Solar Installation',
        yearInstalled: 'Year Installed',
      },
      potential: {
        electricalEfficiency: 'Electrical Efficiency',
        roofArea: 'Suitable Roof Area',
        thermalEfficiency: 'Thermal Efficiency',
        title: 'Solar Potential',
      },
    },
    solarComparison: {
      actualConditions: 'Actual Conditions',
      annualProductionPotential: 'Annual Production Potential',
      bestAnnualProduction: 'Best Annual Production',
      bestCase: 'Best Case',
      bestSolarIrradiance: 'Best Solar Irradiance',
      bestSuitableArea: 'Best Suitable Area',
      estimatedCapacity: 'Estimated Capacity',
      noData: 'No solar potential data available for this building.',
      noteDescription: 'Actual conditions includes all suitable roof areas regardless of orientation. Optimal conditions uses only the best-oriented surfaces (typically south-facing, ~30° slope). Use "Actual" for realistic planning.',
      noteTitle: "What's the difference?",
      optimalConditions: 'Optimal Conditions',
      realistic: 'Realistic',
      solarIrradiance: 'Solar Irradiance',
      suitableRoofArea: 'Suitable Roof Area',
      title: 'Solar Potential Comparison',
      titleActualVsOptimal: 'Solar Potential: Actual vs Optimal',
      tooltips: {
        annualProduction: {
          calculation: 'Roof Area × Irradiance × Panel Efficiency (~17-20%) × System Losses (~15%)',
          description: 'Estimated electricity production if the suitable roof area is fully equipped with solar panels',
          importance: 'This is the key metric for estimating potential energy savings and return on investment',
          limitations: 'Assumes full roof coverage with standard panels. Actual production depends on panel type, installation quality, and maintenance.',
          source: 'SFOE Solar Cadastre (Swiss Federal Office of Energy)',
          title: 'Annual Production Potential',
        },
        bestAnnualProduction: {
          calculation: 'Best Suitable Area × Best Irradiance × Panel Efficiency × System Losses',
          description: 'Maximum electricity production using only optimally-oriented roof areas',
          importance: 'Shows the theoretical maximum efficiency. May produce less total energy than using all suitable areas if optimal area is small.',
          limitations: 'Useful for comparison but may not represent the best economic choice if optimal area is limited.',
          source: 'SFOE Solar Cadastre (Swiss Federal Office of Energy)',
          title: 'Best Annual Production',
        },
        bestSolarIrradiance: {
          calculation: 'Average irradiance on south-facing surfaces with optimal tilt (~30° in Switzerland)',
          description: 'Maximum solar radiation on the best-oriented roof sections',
          importance: 'Represents the peak efficiency potential. Compare with actual irradiance to see how much orientation affects production.',
          limitations: 'Only achievable on ideally oriented roof sections. Most buildings have limited optimal-facing area.',
          source: 'SFOE Solar Cadastre (Swiss Federal Office of Energy)',
          title: 'Best Solar Irradiance',
        },
        bestSuitableArea: {
          calculation: 'Filtered subset of total suitable area: only south-facing surfaces with ~30° slope receive maximum annual irradiance',
          description: 'Roof surface area with optimal orientation for solar panels (best-facing sections only)',
          importance: 'Represents the most efficient placement zones. Installing here maximizes energy production per panel.',
          limitations: 'May be significantly smaller than total suitable area. Focusing only on optimal areas may underutilize available roof space.',
          source: 'SFOE Solar Cadastre (Swiss Federal Office of Energy)',
          title: 'Best Suitable Area',
        },
        estimatedCapacity: {
          calculation: 'Suitable Roof Area ÷ 6.5 m²/kWp (industry standard: ~6.5 m² needed per 1 kWp of installed capacity)',
          description: 'Theoretical maximum solar installation capacity in kilowatt-peak (kWp)',
          importance: 'Helps estimate installation size, costs, and compare with existing installations. A typical household needs 3-5 kWp.',
          limitations: 'This is a rough estimate. Actual capacity depends on panel efficiency, installation constraints, and roof obstructions.',
          source: 'Calculated estimate based on industry standards',
          title: 'Estimated Capacity',
        },
        estimatedCapacityOptimal: {
          calculation: 'Best Suitable Area ÷ 6.5 m²/kWp (industry standard)',
          description: 'Maximum installation capacity using only best-oriented roof sections',
          importance: 'Compare with actual capacity estimate to see how much roof orientation affects potential installation size.',
          limitations: 'Often smaller than actual capacity estimate. Consider whether maximizing efficiency or total production is more important.',
          source: 'Calculated estimate based on industry standards',
          title: 'Estimated Capacity (Optimal)',
        },
        solarIrradiance: {
          calculation: 'Modeled from meteorological data, topography, roof orientation, and local shading from buildings and vegetation',
          description: 'Average solar radiation energy received per square meter of roof surface annually',
          importance: 'Higher irradiance values indicate better solar energy potential. Values above 1000 kWh/m²/year are considered good for Switzerland.',
          limitations: 'Based on modeling, not actual measurements. Weather variations between years can affect real values by ±10-15%.',
          source: 'SFOE Solar Cadastre (Swiss Federal Office of Energy)',
          title: 'Solar Irradiance',
        },
        suitableRoofArea: {
          calculation: '3D analysis of roof surfaces filtering by slope (>10°), orientation, and minimum size requirements',
          description: 'Total roof surface area suitable for solar panel installation',
          importance: 'Determines the maximum number of solar panels that can be installed and directly impacts potential energy production',
          limitations: 'Does not account for obstacles like chimneys, skylights, HVAC units, or structural limitations. Professional assessment recommended.',
          source: 'SFOE Solar Cadastre (Swiss Federal Office of Energy)',
          title: 'Suitable Roof Area',
        },
      },
    },
    solarInstallation: {
      added: 'added',
      firstInstallation: 'First Installation',
      installationCount: '{{count}} installation',
      installationEvents: 'Installation Events',
      installationHistory: 'Installation History',
      installationsCount: '{{count}} installations',
      installationYear: 'Installation Year',
      installed: 'installed',
      noData: 'No solar installation recorded for this building.',
      title: 'Solar Installation',
      totalInstalledCapacity: 'Total Installed Capacity',
    },
    states: {
      error: 'Error loading energy analysis: {{error}}',
      loading: 'Loading energy analysis...',
      noData: 'No building data available',
    },
    tabs: {
      heating: 'Heating',
      idc: 'IDC Geneva',
      solar: 'Solar Energy',
    },
  },
  environment: {
    air_quality: {
      aqi: 'Air Quality Index',
      category: 'Category',
      title: 'Air Quality',
    },
    failed_to_fetch: 'Failed to fetch environment data',
    loading: 'Loading environmental data...',
    no_data: 'No Environmental Data Available',
    no_data_description: 'Environmental data is not available for this location. This could be due to limited monitoring coverage in this area.',
    noise: {
      aircraft: 'Aircraft Noise',
      description: 'Noise levels and sound pollution analysis for this location',
      guidelines: 'Noise Level Guidelines',
      levels: {
        moderate: 'Moderate',
        noisy: 'Noisy',
        quiet: 'Quiet',
        very_noisy: 'Very Noisy',
        very_quiet: 'Very Quiet',
      },
      railway_day: 'Railway Noise (Day)',
      road_day: 'Road Noise (Day)',
      road_night: 'Road Noise (Night)',
      title: 'Noise Levels',
    },
    noise_analysis: 'Noise Analysis',
    sunlight: {
      afternoon_sun: 'Afternoon Sun',
      daily_hours: 'Daily Sunlight',
      description: 'Solar exposure and sunlight availability throughout the day',
      levels: {
        excellent: 'Excellent',
        good: 'Good',
        low: 'Low',
        moderate: 'Moderate',
        very_low: 'Very Low',
      },
      morning_sun: 'Morning Sun',
      seasonal_variation: 'Seasonal Variation',
      title: 'Solar Exposure',
    },
    sunlight_study: 'Sunlight Study',
    title: 'Environmental Analysis',
  },
  estimate: {
    autoValuations: {
      back: 'Back to valuations',
      details: 'Details',
      empty: {
        text: 'Automated valuations from AVM providers are not available for this property.',
        title: 'No Automated Valuations',
      },
      meta: {
        confidenceScore: 'Confidence Score',
        dataRange: 'Data Range',
        dealType: 'Deal Type',
        landArea: 'Land Area',
        listingsCount: 'Listings Count',
        method: 'Method',
        modelVersion: 'Model Version',
        pricePerM2: 'Price per m²',
        provider: 'Provider',
        unknown: 'Unknown',
        valuePerM2LandConservative: 'Value per m² of land (Conservative)',
        valuePerM2LandOptimistic: 'Value per m² of land (Optimistic)',
        values: {
          purchase: 'Purchase',
          rent: 'Rent',
          sale: 'Sale',
        },
      },
      methodDescriptions: {
        popety_io: "Automated valuation based on Popety.io's proprietary algorithm analyzing property characteristics, recent market transactions, and location-specific factors.",
        pricehubble: "Valuation powered by PriceHubble's machine learning models using comprehensive market data and property attributes.",
        wuest_partner: 'Professional valuation by Wüest Partner based on their extensive Swiss real estate market expertise and data.',
      },
      methodology: 'Methodology',
      subtitle: 'Professional property valuations from leading AVM providers',
      title: 'Automated Valuations',
    },
    comparables: {
      active_listings: 'Active Listings',
      allSaved: 'All saved',
      averagePrice: 'Average Price',
      avgLivingArea: 'Avg Living Area',
      avgPricePerSqm: 'Avg Price/m²',
      listing_price: 'Listing Price',
      listings: 'Listings',
      listingsStats: '{{count}} saved listings - Avg. {{average}}',
      listingsTitle: 'Listings Comparables',
      livingArea: 'Living area',
      noListingsDescription: 'No listings were saved for this estimate. Listings can be saved from the main application.',
      noListingsSaved: 'No listings saved',
      noTransactionsDescription: 'No transactions were saved for this estimate. Transactions can be saved from the main application.',
      noTransactionsSaved: 'No transactions saved',
      perListing: 'Per listing',
      priceRange: 'Price Range',
      recent_sales: 'Recent Sales',
      similar_properties: 'Similar Properties',
      sold_price: 'Sold Price',
      sqm: 'm²',
      title: 'Comparable Properties',
      to: 'to',
      totalSaved: 'Total Saved',
      totalValue: 'Total Value',
      transactionsStats: '{{count}} saved transactions - Avg. {{average}}',
      transactionsTitle: 'Transactions Comparables',
    },
    confirmDelete: {
      cancel: 'Cancel',
      confirm: 'Delete',
      defaultItem: 'this item',
      deleting: 'Deleting...',
      message: 'Are you sure you want to delete "{{name}}"?',
      title: 'Delete Valuation',
      warning: 'This action cannot be undone.',
    },
    error_loading_data: 'Error Loading Data',
    failed_to_load: 'Failed to load property estimate data',
    land: {
      area: 'Area',
      buildableArea: 'Buildable Area',
      canton: 'Canton',
      coordinates: 'Geographic Coordinates',
      generalInfo: 'General Information',
      latitude: 'Latitude',
      longitude: 'Longitude',
      maxFloors: 'Max Floors',
      multiplePlots: '{{count}} plots',
      municipality: 'Municipality',
      noLandData: 'No land data available',
      plot: 'Plot',
      plotNumber: 'Plot Number',
      singlePlot: '1 plot',
      title: 'Land Information',
      zoneName: 'Zone Name',
      zoneType: 'Zone Type',
      zoningInfo: 'Zoning Information',
    },
    manualValuations: {
      confidence: {
        high: 'High',
        low: 'Low',
        medium: 'Medium',
      },
      emptyText: 'No manual valuations have been added for this estimate.',
      emptyTitle: 'No Manual Valuations',
      methods: {
        avm: 'Automated Valuation',
        comparable: 'Comparable Sales',
        custom: 'Custom Valuation',
        dcf: 'DCF Method',
        developer: 'Developer Method',
        intrinsic: 'Intrinsic Value Method',
        staticYield: 'Static Yield Method',
      },
      subtitle: 'Professional valuation methods for accurate property assessment',
      title: 'Manual Valuations',
      ui: {
        chartColor: 'Chart color: {{color}}',
      },
    },
    market: {
      activity: 'Market Activity',
      average_price: 'Average Price',
      time_on_market: 'Time on Market',
      trends: 'Market Trends',
    },
    navigation: {
      amenities: 'Amenities',
      demographics: 'Demographics',
      history: 'History',
      listings_comparables: 'Listings Comparables',
      noise_analysis: 'Noise Analysis',
      property_details: 'Property Details',
      purchase_market: 'Purchase Market',
      rental_market: 'Rental Market',
      sunlight_study: 'Sunlight Study',
      transactions_comparables: 'Transactions Comparables',
      valuations: 'Valuations',
    },
    pricePerSqm: {
      basisLabel: 'Calculation basis',
      basisLiving: 'Living area',
      basisUsable: 'Usable area',
      basisWeighted: 'Weighted area',
      fallbackHint: 'Using {{effective}} — {{requested}} not available',
      gearButton: 'Price per m² settings',
      showToggle: 'Show price per m²',
      unavailable: 'Not available',
    },
    property: {
      address: 'Address',
      area: 'Area',
      bathrooms: 'Bathrooms',
      bedrooms: 'Bedrooms',
      condition: 'Condition',
      rooms: 'Rooms',
      type: 'Property Type',
      year_built: 'Year Built',
    },
    propertyDetails: {
      attributes: 'Property Attributes',
      description: 'Description',
      noDataAvailable: 'No property details available',
      photos: 'Photos',
      situationLocation: 'Situation & Location',
      subtitle: 'Overview of the property characteristics',
      title: 'Property Details',
    },
    sections: {
      environment: 'Environment',
      estimate: 'Estimate',
      market: 'Market',
      property: 'Property',
      social_economic: 'Social & Economic',
    },
    share: {
      section_not_available: 'Section Not Available',
      section_not_shared: 'This section was not included in the shared link.',
    },
    sidebar: {
      autoValuations: 'Auto Valuations',
      building: 'Building',
      buildingPermits: 'Building Permits',
      employment: 'Employment',
      energy: 'Energy',
      land: 'Land',
      manualValuations: 'Manual Valuations',
      overview: 'Overview',
      summary: 'Summary',
      transportAccess: 'Transport Access',
    },
    summary: {
      checklist: {
        avmRetrieved: 'AVM valuations retrieved',
        finalSelected: 'Final price selected',
        listingsSelected: 'Listings comparables selected',
        manualAdded: 'Manual valuation added',
        propertyDetails: 'Property details added',
        title: 'Valuation Checklist',
        transactionsSelected: 'Transactions comparables selected',
      },
      finalValuation: 'Final Valuation',
      finalValue: 'Final Value',
      listingsComparables: 'Listings Comparables',
      noFinalValuation: 'No final valuation has been set for this estimate.',
      range: 'Range: {{min}} - {{max}}',
      transactionsComparables: 'Transactions Comparables',
      valuationComparison: 'Valuation Comparison',
    },
    title: 'Property Analysis',
    valuation: {
      confidence: 'Confidence Level',
      estimated_value: 'Estimated Value',
      price_per_sqm: 'Price per m²',
      range: 'Value Range',
      title: 'Property Valuation',
    },
    valuations: {
      confidence: {
        high: 'High',
        low: 'Low',
        medium: 'Medium',
      },
      detail: {
        confidence: 'Confidence',
        daysAgo: '{{days}} days ago',
        estimatedValue: 'Estimated Value',
        today: 'Today',
        valueRange: 'Value Range',
        weeksAgo: '{{weeks}} weeks ago',
        yesterday: 'Yesterday',
      },
    },
  },
  explore: {
    aiFilter: {
      building: {
        description: "Describe the building you're looking for, and I'll help you find it.",
        placeholder: "e.g., 'Modern office buildings in Zurich downtown'",
        prompts: {
          '0': 'Recent Residential buildings (after 2010) with more than 5 floors',
          '1': 'Buildings with gas or petrol heating source but a good solar potential on the roof',
          '2': 'Buildings with a rent listing in the last 6 months',
          '3': 'Residential buildings with at least 20 units and a short travel time to centers',
        },
        title: 'Building Filter Assistant',
      },
      clearAllResponses: 'Clear All Responses ({{count}})',
      description: "Describe what you're looking for in natural language, and I'll apply the appropriate filters.",
      deviceSelector: {
        iphoneNotRecommended: ' (iPhone - Not recommended)',
        microphoneDefault: 'Microphone {{id}}',
        recommended: ' (Recommended)',
        selectMicrophone: '🎤 Select Microphone:',
      },
      errors: {
        general: 'Error',
        processingFailed: 'Failed to process your request. Please try again.',
        voiceProcessingFailed: 'Failed to process your voice request. Please try again.',
        voiceRecording: 'Voice Recording Error',
      },
      examplePrompts: {
        '0': 'Show me vacant plots over 500m² in Zone 3',
        '1': 'Private properties built after 2010',
        '2': 'Find plots near the lake with building permits',
      },
      land: {
        description: "Describe the land you're looking for, and I'll help you find it.",
        placeholder: "e.g., 'Development land in Zurich with good scores'",
        prompts: {
          '0': 'Lands over 1000m² with development score above 70% and no protected buildings',
          '1': 'Bare lands in buildable zones in the canton of Zurich',
          '2': 'Lands with old buildings (<1950) but not protected',
          '3': 'Lands with building permit for development projects published in the last 2 years',
        },
        title: 'Land Filter Assistant',
      },
      response: {
        filtersApplied: 'Filters Applied',
      },
      textInput: {
        apply: 'Apply',
        placeholder: 'Type or speak your filter request...',
      },
      thinkingAnimation: {
        analyzing: 'Analyzing your request...',
      },
      title: 'AI Filter Assistant',
      voiceInput: {
        notSupported: 'Voice recording not supported',
        recording: 'Recording... {{duration}}s - Click to stop and send',
        startRecording: 'Click to start voice recording',
      },
    },
    buildingCategories: {
      characteristics: 'Characteristics',
      classification: 'Classification',
      energy: 'Energy',
      environmental: 'Environmental',
      history: 'History',
      myMaps: 'My Maps',
    },
    buildingClassification: {
      garage: 'Garage',
      industrial: 'Industrial',
      mixedLow: 'Residential minority(ies)',
      mixHigh: 'Residential majority(s)',
      notClassified: 'Not classified',
      office: 'Offices',
      other: 'Other',
      public: 'Public',
      residential: 'Residential',
      retail: 'Retail',
    },
    buildingClassifications: {
      Garage: 'Garage',
      Industrial: 'Industrial',
      Mixed_1: 'Mixed Use',
      Mixed_2: 'Mixed Use',
      Offices: 'Offices',
      Other: 'Other',
      Public: 'Public',
      Residential: 'Residential',
      Retail: 'Retail',
    },
    buildingLayers: {
      buildingPeriod: 'Building Period',
      buildingPermits: 'Building Permits',
      buildingType: 'Building Type',
      constructionYear: 'Construction Year',
      favorites: 'Favorites',
      heatingSystem: 'Heating System',
      lakeView: 'Lake View',
      mountainView: 'Mountain View',
      myTags: 'My Tags',
      noiseExposure: 'Noise Exposure',
      numberOfDwellings: 'Number of Dwellings',
      numberOfFloors: 'Number of Floors',
      numberOfUnits: 'Number of Units',
      officialCategory: 'Official Category',
      popetyClassification: 'Building Classification',
      prospectiveBuildings: 'Prospective Buildings',
      protectionLevel: 'Heritage Protection Level',
      publicTransportQuality: 'Public Transport Quality',
      renovationPeriod: 'Renovation Period',
      rentListings: 'Rent Listings',
      saleListings: 'Sale Listings',
      solarExposure: 'Solar Exposure',
      transactions: 'Transactions',
      travelTimeToCenters: 'Travel Time to Centers',
      waterHeatingSystem: 'Water Heating System',
    },
    buildingPanel: {
      administrativeDetails: {
        addresses: 'Addresses',
        buildingName: 'Building Name',
        egids: 'Federal Building IDs (EGIDs)',
        officialNumber: 'Official Number',
        renovationRange: 'Renovation Year',
        title: 'Administrative Details',
        units: 'units',
        yearRange: 'Construction Year',
      },
      dwellings: {
        area: 'Area',
        dwellingNumber: 'Dwelling',
        features: 'Features',
        floor: 'Floor',
        hideIndividual: 'Hide Individual Dwellings',
        kitchen: 'Kitchen',
        lastConstruction: 'Last Construction',
        medianArea: 'Median Area',
        medianRooms: 'Median Rooms',
        monthlyRent: 'Monthly Rent',
        multiFloor: 'Multi-floor',
        noDwellings: 'No dwelling information available',
        perMonth: '/ month',
        pricePredictions: 'Price Predictions',
        purchasePrice: 'Purchase Price',
        rooms: 'Rooms',
        singleFloor: 'Single floor',
        sizeRange: 'Size Range',
        status: 'Status',
        title: 'Dwelling Information',
        totalArea: 'Total Area',
        totalDwellings: 'Total Dwellings',
        viewIndividual: 'View Individual Dwellings',
      },
      dwellingsLabel: 'Dwellings',
      emptyStates: {
        noAdministrativeDetails: 'No administrative details available',
      },
      error: {
        buildingId: 'Building ID: {{propertyId}}',
        general: 'Error loading building data',
        notFound: 'No building data found',
        retry: 'Retry',
      },
      federalRegistry: {
        addressesLabel: 'Addresses',
        title: 'Federal Building Registry',
      },
      floorsLabel: 'Floors',
      history: {
        empty: {
          description: 'There are no recorded events for this building',
          title: 'No history found',
        },
        error: {
          description: 'An error occurred while loading building history data',
          title: 'Failed to load history',
        },
        filtered: {
          description: 'Try adjusting your filter selection to see more events',
          title: 'No events match filters',
        },
        filters: {
          permits: 'Permits',
          rentals: 'Rentals',
          sales: 'Sales',
          transactions: 'Transactions',
        },
        loading: 'Loading building history',
      },
      information: {
        buildingYear: 'Building Year',
        category: 'Category',
        energyEfficiency: 'Energy Efficiency',
        heatingType: 'Heating Type',
        height: 'Height',
        notAvailable: 'N/A',
        title: 'Building Information',
        type: 'Type',
        volume: 'Volume',
      },
      links: {
        description: 'Links for building {{buildingId}}',
        title: 'Building Links',
      },
      loading: 'Loading building data for ID: {{propertyId}}...',
      market: {
        description: 'Market data for building {{buildingId}}',
        title: 'Market Data',
      },
    },
    buildingStatus: {
      existing: 'Existing',
      planned: 'Planned',
      under_construction: 'Under Construction',
    },
    buildingTooltip: {
      area: 'Area',
      buildingInfo: 'Building Information',
      dwellings: 'Dwellings',
      energy: 'Energy',
      environment: 'Environment',
      floors: 'Floors',
      heating: 'Heating',
      height: 'Height',
      listings: 'Listings',
      noAddress: 'No address available',
      noiseLevel: 'Noise Level',
      permits: 'Permits',
      relatedData: 'Related Data',
      transactions: 'Transactions',
      transport: 'Transport',
      units: 'Units',
      viewQuality: 'View Quality',
      year: 'Year Built',
    },
    categories: {
      buildings: 'Buildings',
      environmental: 'Environmental',
      externalMaps: 'External maps',
      myMaps: 'My Maps',
      noise: 'FO - Noise',
      satelliteTimeTravel: 'FO - Satellite Time Travel',
      score: 'Score',
      urbanization: 'FO - Urbanization',
      zone: 'Zone',
    },
    createDeal: {
      addContact: 'Add Contact',
      addDescription: 'Add a description...',
      addNotes: 'Add any additional notes...',
      addParticipant: 'Add Participant',
      addParticipantTitle: 'Add Participant',
      addUser: 'Add User',
      buildingTitle: 'Create New Building Deal',
      cancel: 'Cancel',
      contact: 'Contact',
      contactRole: 'Contact Role',
      created: 'Created',
      createDeal: 'Create Deal',
      creating: 'Creating...',
      dealId: 'Deal ID',
      dealInformation: 'Deal Information',
      dealName: 'Deal Name',
      dealType: 'Deal Type',
      dealValue: 'Deal Value',
      description: 'Description',
      editBuildingTitle: 'Edit Building Deal',
      editTitle: 'Edit Deal',
      enterDealName: 'Enter deal name',
      expectedCloseDate: 'Expected Close Date',
      lastModified: 'Last Modified',
      loadingUsers: 'Loading users...',
      metadata: 'Metadata',
      noPipelines: 'No pipelines available',
      notes: 'Notes',
      noUsersFound: 'No users found',
      optional: 'Optional',
      participantRole: 'Role',
      participants: 'Participants',
      pipeline: 'Pipeline',
      pipelineStage: 'Pipeline & Stage',
      removeParticipant: 'Remove Participant',
      roleContributor: 'Contributor',
      roleOwner: 'Owner',
      roleParticipant: 'Participant',
      roleViewer: 'Viewer',
      searchingUsers: 'Searching users...',
      searchUsers: 'Search users by name or email...',
      selectPipelineFirst: 'Select a pipeline first',
      selectUser: 'Select a user to add',
      stage: 'Stage',
      summary: 'Summary',
      title: 'Create New Deal',
      updateDeal: 'Update Deal',
    },
    dataSources: {
      faoData: 'Official Gazette',
      faoDataHeritage: 'Canton Geneva Heritage',
      federalEnergyOffice: 'Federal Office of Energy',
      federalEnvironmentOffice: 'Federal Office for the Environment',
      federalSpatialDevelopment: 'Federal Register of Buildings and Dwellings',
      federalStatisticalOffice: 'Federal Statistical Office',
      federalTransportOffice: 'Federal Office of Transport',
      marketData: 'Swiss Real Estate portals',
      personalCollection: 'Personal Collection',
      popetyioLabs: 'Popety.io Data Labs',
    },
    deals: {
      addDeal: 'Add Deal',
      archived: 'Archived',
      attachError: 'Failed to attach deals. Please try again.',
      attachExisting: 'Attach Existing Deal',
      attaching: 'Attaching...',
      attachSelected: 'Attach Selected',
      availableDeals: 'Available Deals',
      cancel: 'Cancel',
      confirmDelete: 'Are you sure you want to remove this deal from the property?',
      contact: 'Contact',
      created: 'Created',
      createdOn: 'Created on',
      createFirstDeal: 'Create First Deal',
      createNewDeal: 'Create a new deal to get started',
      dealName: 'Deal Name',
      dealsSelected: 'deals selected',
      dealType: 'Deal Type',
      dealTypeDevelopment: 'Development',
      dealTypeJointVenture: 'Joint Venture',
      dealTypeLease: 'Lease',
      dealTypeSale: 'Sale',
      dealValue: 'Deal Value (CHF)',
      description: 'Description',
      edit: 'Edit',
      editDeal: 'Edit Deal',
      emptyDescription: 'Start by creating a deal for this property',
      emptyTitle: 'No deals yet',
      enterDealName: 'Enter deal name',
      enterDescription: 'Enter description',
      enterNotes: 'Enter notes',
      expectedClose: 'Expected Close',
      expectedCloseDate: 'Expected Close Date',
      loading: 'Loading deals...',
      loadingAvailableDeals: 'Loading available deals...',
      noAvailableDeals: 'No available deals',
      noMatchingDeals: 'No matching deals found',
      noParticipants: 'No participants',
      notApplicable: 'N/A',
      notes: 'Notes',
      owner: 'Owner',
      participants: 'Participants',
      pipeline: 'Pipeline',
      remove: 'Remove from property',
      removing: 'Removing...',
      retry: 'Retry',
      searchForDeals: 'Search for deals',
      searchPlaceholder: 'Search by name, pipeline, or type...',
      title: 'Property Deals',
      tryDifferentSearch: 'Try adjusting your search criteria',
      type: 'Type',
      unassigned: 'Unassigned',
      update: 'Update Deal',
      updating: 'Updating...',
      value: 'Deal Value',
      viewInPipeline: 'View in Pipeline',
    },
    filterPanel: {
      area: {
        landArea: 'Land Area',
        maxPlaceholder: 'Max area',
        minPlaceholder: 'Min area',
        title: 'Area',
      },
      buildingFilters: {
        common: {
          loadingTags: 'Loading tags...',
          noTagsAvailable: 'No tags available',
          noTagsHelpBuilding: 'No tags available. Create tags from the building details panel.',
          noTagsHelpLand: 'No tags available. Create tags from the land details panel.',
          selectPermitTypes: 'Select permit types',
          selectTags: 'Select tags',
        },
        environmental: {
          distanceToPowerlines: {
            '0to100m': '0 to 100m',
            over100m: 'Over 100m',
            placeholder: 'Select distance',
          },
          lakeView: {
            '0ha': '0 ha',
            '0to100ha': '0 to 100 ha',
            over100ha: 'Over 100 ha',
            placeholder: 'Select lake view',
          },
          mountainView: {
            '0to4peaks': '0 to 4 peaks',
            '5to13peaks': '5 to 13 peaks',
            moreThan13peaks: 'More than 13 peaks',
            placeholder: 'Select mountain view',
          },
          noiseExposure: {
            '45to52db': '45 to 52 dB',
            moreThan52db: 'More than 52 dB',
            placeholder: 'Select noise levels',
            upTo45db: 'Up to 45 dB',
          },
          publicTransport: {
            badlyServed: 'Badly served',
            mediumServed: 'Medium served',
            placeholder: 'Select transport quality',
            veryBadlyServed: 'Very badly served',
            veryWellServed: 'Very well served',
            wellServed: 'Well served',
          },
          slope: {
            '0to4degrees': '0 to 4 degrees',
            '4to9degrees': '4 to 9 degrees',
            moreThan9degrees: 'More than 9 degrees',
            placeholder: 'Select slope',
          },
          taxBurden: {
            high: 'High (over 7.1%)',
            medium: 'Medium (5.1% to 7.1%)',
            placeholder: 'Select tax burden',
            small: 'Small (0 to 5.1%)',
          },
          travelTime: {
            long: 'Long',
            medium: 'Medium',
            placeholder: 'Select travel times',
            short: 'Short',
          },
        },
        status: {
          accessible: 'Accessible',
          active: 'Active',
          activeStatus: 'Active Status',
          approximate: 'Approximate',
          exactLocation: 'Exact Location',
          furnished: 'Furnished',
          furnishedStatus: 'Furnished Status',
          inactive: 'Inactive',
          newConstruction: 'New Construction',
          no: 'No',
          noPets: 'No Pets',
          notAccessible: 'Not Accessible',
          petsAllowed: 'Pets Allowed',
          selectAccessibility: 'Select accessibility...',
          selectActiveStatus: 'Select active status...',
          selectConstructionStatus: 'Select construction status...',
          selectFurnishedStatus: 'Select furnished status...',
          selectLocationPrecision: 'Select location precision...',
          selectPetPolicy: 'Select pet policy...',
          title: 'Status Filters',
          unfurnished: 'Unfurnished',
          wheelchairAccessible: 'Wheelchair Accessible',
          yes: 'Yes',
        },
      },
      buildingFiltersTitle: 'Building Filters',
      buildingMode: 'Building',
      clearAll: 'Clear all filters',
      close: 'Close filters',
      landFilters: {
        building: {
          buildingHeight: 'Building Height',
          buildingVolume: 'Building volume above ground (m3)',
          constructionYear: 'Construction Year',
          floorNumber: 'Floor Number',
          grossFloorArea: 'Gross usable floor area (GUFA)',
          groundingArea: 'Grounding Area (m2)',
          hideUnknownYear: 'Hide unknown year',
          numberOfDwellings: 'Number of Dwellings',
          title: 'Building',
        },
        common: {
          display: 'Display',
          displayOnly: 'Display Only',
          from: 'From',
          hide: 'Hide',
          max: 'Max',
          min: 'Min',
          mixed: 'Mixed',
          private: 'Private',
          public: 'Public',
          selectOption: 'Select option',
          to: 'To',
        },
        development: {
          availableBuildableCapacity: 'Available buildable capacity (Available FA)',
          buildableCapacity: 'Buildable capacity (Zoning FA)',
          developmentScore: 'Development Score',
          title: 'Development',
          underExploitedScore: 'Under Exploited Score',
        },
        history: {
          buildingPermit: 'Building Permit',
          buildingPermitsClassification: 'Building permits classification',
          onlyDevelopment: 'Only Development',
          permitClassifications: {
            development: 'Development',
            other: 'Other',
          },
          purchaseDate: 'Purchase Date',
          purchasePrice: 'Purchase Price',
          rentDate: 'Rent Date',
          rentPrice: 'Rent Price',
          title: 'History',
          transactionDate: 'Transaction Date',
          transactionPrice: 'Transaction Price',
        },
        land: {
          title: 'Plot',
        },
        landUsePlanAssignments: {
          label: 'Land Use Plan Assignment',
          noAssignments: 'No land use plan assignments available',
          placeholder: 'Select a land use plan assignment',
          selectLocationFirst: 'Please select a location first',
        },
        locationZoning: {
          landUsePlan: 'Land Use Plan',
          location: 'Location',
          noBuildingZone: 'No Building Zone',
          noLandUsePlans: 'No land use plans available',
          plan: 'Plan',
          planPlaceholder: 'Plan number',
          selectLandUsePlan: 'Select a land use plan',
          selectLocationFirst: 'Please select a location first',
          specialZone: 'Special Zone',
          title: 'Location & Zoning',
        },
        ownership: {
          numberOfOwners: 'Number of owners',
          ownersType: 'Owners Type',
          title: 'Ownership',
        },
        plot: {
          area: 'Area',
          bareLand: 'Bare Land',
          title: 'Plot',
        },
        restrictions: {
          archaeologicalZone: 'Archaeological Zone',
          buildingRight: 'Building Right',
          builtSitesProtectedZone: 'Built Sites Protected Zone',
          dangerZone: 'Danger Zone',
          forestLimitZone: 'Forest Limit Zone',
          forestZone: 'Forest Zone',
          mandatoryPlanningZone: 'Mandatory Planning Zone',
          natureProtectionZone: 'Nature Protection Zone',
          noMaxCosZone: 'No max BCC zone',
          notYetDefinedSpecialZone: 'Not Yet Defined Special Zone',
          otherZone: 'Other Zone',
          pollutedZone: 'Polluted Zone',
          protectedBuilding: 'Protected Building',
          protectedObjects: 'Protected Objects',
          reservedZone: 'Reserved Zone',
          title: 'Restrictions',
          underwaterProtectedZone: 'Underwater Protected Zone',
          watercourseLimitZone: 'Watercourse Limit Zone',
        },
      },
      landFiltersTitle: 'Land Filters',
      loadFilters: 'Load saved filters',
      location: {
        municipality: 'Municipality',
        region: 'Region',
        searchPlaceholder: 'Search for regions, municipalities, cities...',
        selectMunicipality: 'Please select a municipality',
        selectPlan: 'Please select a plan',
        selectRegion: 'Please select a region',
        title: 'Location',
      },
      municipalities: {
        carouge: 'Carouge',
        geneva: 'Geneva',
        lancy: 'Lancy',
        meyrin: 'Meyrin',
        vernier: 'Vernier',
      },
      plotMode: 'Plot',
      propertyType: {
        placeholder: 'Select property type',
      },
      quickFilters: {
        maxArea: 'Max {{area}}m²',
        minArea: 'Min {{area}}m²',
        privateOwnership: 'Private ownership',
        privateProperty: 'Private property',
        title: 'Quick filters',
        zone3: 'Zone 3',
      },
      regions: {
        basel: 'Basel Region',
        central: 'Central Switzerland',
        lakeGeneva: 'Lake Geneva Region',
        ticino: 'Ticino',
        zurich: 'Zurich Region',
      },
      savePreset: 'Save filter preset',
      title: 'Filters',
    },
    financial: {
      'Nombre de logements': 'Number of Dwellings',
    },
    heatingTypes: {
      district: 'District Heating',
      electric: 'Electric',
      gas: 'Gas',
      heat_pump: 'Heat Pump',
      oil: 'Oil',
      solar: 'Solar',
      wood: 'Wood',
    },
    landPlotTooltip: {
      buildings: 'Buildings',
      landArea: 'Land Area',
      noAddress: 'No address available',
      noZoning: 'No zoning information',
      units: 'Units',
      zoning: 'Zoning',
    },
    layers: {
      availability: 'Availability',
      buildingArea: 'Building Area',
      constructionYear: 'Construction Year',
      daytimeRailwayNoise: 'Daytime Railway Noise',
      daytimeRoadTrafficNoise: 'Daytime Road Traffic Noise',
      densifiableArea: 'Densifiable Area',
      developmentPotential: 'Development Potential',
      favorites: 'Favorites',
      legacyRiskScore: 'Legacy Risk Score',
      livabilityScore: 'Livability Score',
      myTags: 'My Tags',
      numberOfUnits: 'Number of Units',
      prospectiveProperties: 'Prospective Properties',
      protectedBuildings: 'Protected Buildings',
      restrictions: 'Restrictions',
      underExploitationIndex: 'Under Exploitation Index',
      zoneLayout: 'Zone Layout',
    },
    legends: {
      categoricalLabels: {
        availability: {
          available: 'Available',
          notAvailable: 'Not Available',
        },
        buildingArea: {
          no: 'No',
          yes: 'Yes',
        },
        buildingClassification: {
          garage: 'Garage',
          industrial: 'Industrial',
          mixed1: 'Mixed Use 1',
          mixed2: 'Mixed Use 2',
          notClassified: 'Not Classified',
          offices: 'Offices',
          other: 'Other',
          public: 'Public',
          residential: 'Residential',
          retail: 'Retail',
        },
        buildingPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': '2015 onward',
          before1919: 'Before 1919',
        },
        buildingType: {
          exclusivelyResidential: 'Exclusively Residential',
          nonResidential: 'Non-Residential',
          partiallyResidential: 'Partially Residential',
          residentialWithAnnex: 'Residential with Annex',
          special: 'Special Construction',
          temporary: 'Temporary Housing',
          unknown: 'Unknown',
        },
        customContent: {
          customTags: 'Custom tags',
          favoriteProperties: 'Favorite properties',
          prospectiveProperties: 'Prospective properties',
        },
        lakeView: {
          large: 'Large lake view (> 100 ha)',
          none: 'No lake view',
          small: 'Small lake view (< 100 ha)',
        },
        monumentProtection: {
          no: 'Not protected',
          yes: 'Protected',
        },
        mountainView: {
          few: 'Few peaks (< 5)',
          many: 'Many peaks (> 13)',
          medium: 'Medium peaks (5-13)',
        },
        noiseExposure: {
          high: 'High (> 52 dB)',
          low: 'Low (< 45 dB)',
          medium: 'Medium (45-52 dB)',
        },
        officialCategory: {
          agricultural: 'Agricultural Building',
          apartment: 'Apartment Building (3+ units)',
          collectiveHousing: 'Collective Housing',
          commercial: 'Commercial Building',
          communityHousing: 'Community Housing',
          crops: 'Crop Production Building',
          cultural: 'Cultural / Recreation',
          education: 'Education / Research',
          garage: 'Garage',
          health: 'Hospital / Healthcare',
          hotel: 'Hotel',
          industrial: 'Industrial Building',
          livestock: 'Livestock Building',
          monument: 'Historic Monument',
          museum: 'Museum / Library',
          office: 'Office Building',
          otherAgricultural: 'Other Agricultural',
          otherUnclassified: 'Other Unclassified',
          religious: 'Religious Building',
          restaurant: 'Restaurant / Bar',
          singleFamily: 'Single Family Home',
          sports: 'Sports Facility',
          tourism: 'Tourism Accommodation',
          transport: 'Transport / Communication',
          twoFamily: 'Two-Family Home',
          unknown: 'Unknown',
          warehouse: 'Warehouse / Silo / Storage',
        },
        powerSource: {
          air: 'Air',
          districtHeating: 'District heating',
          electricity: 'Electricity',
          gas: 'Gas',
          geothermal: 'Geothermal',
          none: 'None',
          oil: 'Oil',
          solar: 'Solar (thermal)',
          unknown: 'Unknown',
          wood: 'Wood',
        },
        protectionStatus: {
          level1: 'Level 1',
          level2: 'Level 2',
          level3: 'Level 3',
          level4: 'Level 4 (Highest)',
          notProtected: 'Not protected',
        },
        renovationPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': '2015 onward',
          before1919: 'Before 1919',
        },
        transportQuality: {
          badly: 'Badly served',
          medium: 'Medium served',
          veryBadly: 'Very badly served',
          veryWell: 'Very well served',
          well: 'Well served',
        },
        travelTime: {
          long: 'Long',
          medium: 'Medium',
          short: 'Short',
        },
        zoneTypes: {
          archaeological: 'Archaeological',
          danger: 'Danger',
          forest: 'Forest',
          polluted: 'Polluted',
          reserved: 'Reserved',
          watercourse: 'Watercourse',
        },
      },
      gradientLabels: {
        before1950: '< 1950',
        db45: '45 dB',
        db55: '55 dB',
        db65: '65 dB',
        db75Plus: '75+ dB',
        high: 'High',
        low: 'Low',
        medium: 'Medium',
        older: 'Older',
        oneOrMore: '1+',
        recent: 'Recent',
        twentyOrMore: '20+',
        year1960: '1960',
        year1970: '1970',
        year1990: '1990',
        year2010: '2010',
        year2024: '2024',
      },
      titles: {
        availability: 'Zone Availability',
        averageBuildingYear: 'Average Building Year',
        averageRenovationYear: 'Average Renovation Year',
        buildingArea: 'Building Area',
        buildingClassification: 'Building Classification',
        buildingPeriod: 'Building Period',
        buildingPermitLastYear: 'Building Permits Last Year',
        buildingProtectionStatus: 'Building Protection Status',
        buildingType: 'Building Type',
        daytimeRailwayNoise: 'Daytime Railway Noise',
        daytimeRoadTrafficNoise: 'Daytime Road Traffic Noise',
        developmentPotentialScore: 'Development Potential Score',
        favorites: 'Favorites',
        heatingEnergySource: 'Heating Energy Source',
        lakeView: 'Lake View',
        legacyRiskScore: 'Legacy Risk Score',
        listingRentLastYear: 'Rental Listings Last Year',
        listingSaleLastYear: 'Sale Listings Last Year',
        livabilityScore: 'Livability Score',
        mountainView: 'Mountain View',
        myTags: 'My Tags',
        nighttimeRailwayNoise: 'Nighttime Railway Noise',
        nighttimeRoadTrafficNoise: 'Nighttime Road Traffic Noise',
        noiseExposure: 'Noise Exposure',
        numberOfDwellings: 'Number of Dwellings',
        numberOfFloors: 'Number of Floors',
        numberOfUnits: 'Number of Units',
        officialCategory: 'Official Category',
        prospects: 'Prospects',
        publicTransportQuality: 'Public Transport Quality',
        renovationPeriod: 'Renovation Period',
        solarExposure: 'Solar Exposure',
        transactionLastYear: 'Transactions Last Year',
        travelTimeToCenters: 'Travel Time to Centers',
        underExploitationScore: 'Under Exploitation Score',
        waterHeatingSource: 'Water Heating Source',
        zoneRestrictions: 'Zone Restrictions',
      },
      units: {
        decibels: 'Decibels',
        dwellings: 'dwellings',
        floors: 'floors',
        kwhPerM2: 'kWh/m²',
        score: 'Score',
        units: 'units',
      },
    },
    listView: {
      actions: {
        addTag: 'Add tag',
        addToDeal: 'Add to deal',
        addToFavorites: 'Add to favorites',
        export: 'Export',
      },
      columns: {
        activity: 'Activity',
        addLabel: '+ Add a label',
        address: 'Address',
        area: 'Area',
        building: 'Building',
        buildings: 'Buildings',
        floors: 'Floors',
        history: 'History',
        labels: 'Labels',
        municipality: 'Municipality',
        notClassified: 'Not classified',
        otherAddresses: '+{{count}} addresses',
        otherZones: '+{{count}} other zones',
        plotNumber: 'Plot Number',
        score: 'Score',
        surface: 'Surface',
        type: 'Type',
        units: 'Units',
        volume: 'Volume',
        year: 'Year',
        zone: 'Zone',
      },
      exportSelected: 'Export Selected',
      found: 'found',
      of: 'of',
      results: 'results',
      rowsPerPage: 'Rows per page',
      selectAll: 'Select all',
      sortBy: 'Sort by',
      sortOptions: {
        address: 'Address',
        buildings: 'Buildings',
        landType: 'Land Type',
        municipality: 'Municipality',
        plotId: 'Plot ID',
        recentActivity: 'Recent Activity',
        surfaceArea: 'Surface Area',
        units: 'Units',
        utilizationRate: 'Utilization Rate',
      },
    },
    mapControls: {
      '2d': '2D',
      '3d': '3D',
      layers: 'Layers',
      legend: 'Legend',
      print: 'Print',
      satellite: 'Satellite',
      street: 'Street',
    },
    mapLayerPanel: {
      activeLayer: {
        label: 'Active Layer',
        neutralView: 'Neutral view',
        noLayer: 'No Layer',
        noLayerSelected: 'No Layer Selected',
        turnOff: 'Turn Off',
      },
      favorites: {
        add: 'Add to favorites',
        remove: 'Remove from favorites',
        title: 'Favorite layers',
      },
      search: {
        legend: {
          category: 'Category',
        },
        placeholder: 'Search layers...',
      },
      title: 'Map Layers',
      wms: {
        error: 'Failed to load external layers',
        externalSource: 'External Source',
        info: 'Layer information',
        loading: 'Loading external layers...',
      },
    },
    propertyPanel: {
      actionLabels: {
        activity: 'Activity',
        alert: 'Alert',
        deal: 'Deal',
        exit: 'Exit',
        favorite: 'Favorite',
        group: 'Group',
      },
      activities: {
        empty: {
          description: 'Try adjusting your filters or search terms',
          title: 'No activities found',
        },
        filters: {
          all: 'All Activities',
          analysis: 'Analysis',
          favorites: 'Favorites',
          files: 'Files',
          notes: 'Notes',
          tags: 'Tags',
        },
        hoursAgo: '{{count}} hour ago',
        hoursAgo_plural: '{{count}} hours ago',
        minutesAgo: '{{count}} minute ago',
        minutesAgo_plural: '{{count}} minutes ago',
        searchPlaceholder: 'Search activities...',
        title: 'Activities',
        today: 'Today',
        yesterday: 'Yesterday',
      },
      addToDeal: 'Add to Deal',
      addToFavorites: 'Add to Favorites',
      buildingsLabel: 'Buildings',
      createAlert: 'Create Alert',
      creatingEstimation: 'Creating estimation...',
      deals: {
        addDeal: 'Add Deal',
        allPipelines: 'All Pipelines',
        allStatuses: 'All Statuses',
        attachExisting: 'Attach Existing',
        attachExistingBuilding: 'Attach Existing Deal',
        attachSelected: 'Attach Selected',
        buildingTitle: 'Building Deals',
        cancel: 'Cancel',
        confirmDeleteText: 'Remove this deal from the property?',
        created: 'Created',
        createDeal: 'Create Deal',
        createFirst: 'Create First Deal',
        daysAgo: '{{days}}d ago',
        edit: 'Edit',
        emptyBuildingDescription: 'Start by creating or attaching a deal for this building',
        emptyDescription: 'Start by creating or attaching a deal for this property',
        emptyTitle: 'No deals yet',
        foundDeals_one: '{{count}} deal found',
        foundDeals_other: '{{count}} deals found',
        hoursAgo: '{{hours}}h ago',
        justNow: 'Just now',
        loadingPipelines: 'Loading pipelines...',
        loadPipelinesError: 'Failed to load pipelines',
        lost: 'Lost',
        minsAgo: '{{mins}} min ago',
        noDealsAvailable: 'No deals available',
        noDealsFound: 'No deals found',
        noPipeline: 'No pipeline',
        noResults: 'No deals match your search',
        noStage: 'No stage',
        open: 'Open',
        participants: 'Participants',
        pipeline: 'Pipeline',
        remove: 'Remove',
        removeDeal: 'Remove deal',
        searchDealsError: 'Failed to search deals',
        searchPlaceholder: 'Search deals by name, pipeline, or stage...',
        selectAll: 'Select All',
        selected: 'Selected',
        stage: 'Stage',
        status: 'Status',
        summary: 'Summary',
        title: 'Property Deals',
        untitledDeal: 'Untitled Deal',
        viewInPipeline: 'View in Pipeline',
        won: 'Won',
      },
      errors: {
        noLandId: 'No land ID available',
      },
      estimateCreated: 'Estimate created successfully',
      files: {
        confirmDelete: 'Are you sure you want to delete {{name}}?',
        delete: 'Delete',
        download: 'Download',
        empty: {
          description: 'Upload files to get started or try adjusting your search',
          title: 'No files found',
        },
        filters: {
          all: 'All Files',
        },
        searchPlaceholder: 'Search files...',
        title: 'Files',
        uploadButton: 'Browse Files',
        uploadText: 'Drag & drop files here or click to browse',
      },
      history: {
        adjustFilters: 'Try adjusting your filters to see more events',
        error: 'Error loading history data',
        loading: 'Loading history data...',
        loadingText: 'Please wait while we fetch detailed information',
        noEvents: 'No events found',
        onlineDays: 'Online: {{days}} days',
        permitRequest: 'Permit Request',
        permits: 'Permits',
        rentalListing: 'Rental Listing',
        rentals: 'Rentals',
        rooms: 'Rooms',
        saleListing: 'Sale Listing',
        sales: 'Sales',
        transaction: 'Transaction',
        transactions: 'Transactions',
      },
      information: {
        active: 'Active',
        beneficiary: 'Beneficiary',
        buildingCount: 'Building Count',
        buildingPeriod: 'Building Period',
        buildings: 'Buildings',
        built: 'Built',
        company: 'Company',
        conditions: 'Conditions',
        constructible: 'Constructible',
        created: 'Created',
        duration: 'Duration',
        dwellings: 'Dwellings',
        energyConsumption: 'Energy Consumption',
        energySurface: 'Energy Surface',
        floors: 'Floors',
        foundation: 'Foundation',
        grossFloorArea: 'Gross Floor Area',
        groundFloorArea: 'Ground Floor Area',
        heatingSource: 'Heating Source',
        inactive: 'Inactive',
        individual: 'Individual',
        landArea: 'Land Area',
        landInfo: 'Land Information',
        landType: 'Land Type',
        lastOwnerChange: 'Last Owner Change',
        lastRenovation: 'Last Renovation',
        maxHeight: 'Max Height',
        no: 'No',
        noDataAvailable: 'No detailed information available for this property',
        owners: 'Owners',
        plotNumber: 'Plot Number',
        protected: 'Protected',
        renovated: 'Renovated',
        residentialArea: 'Residential Area',
        residentialFloors: 'Residential Floors',
        restrictions: 'Restrictions',
        searchGoogle: 'Search on Google',
        searchLinkedIn: 'Search on LinkedIn',
        searchLocalCh: 'Search on local.ch',
        solarPotential: 'Solar Potential',
        totalResidentialArea: 'Total Residential Area',
        type: 'Type',
        unitCount: 'Unit Count',
        validity: 'Validity',
        volume: 'Volume',
        yes: 'Yes',
        zones: 'Zones',
      },
      links: {
        accessOfficialData: 'Access official data and legal documents',
        buildingInformation: 'Building Information',
        buildingPermitsHistory: 'Building permits and construction history',
        buildingStatistics: 'Building Statistics',
        cadastreRDPPF: 'Cadastre RDPPF',
        cantonalGeoportal: 'Cantonal Geoportal',
        cantonalInteractiveMap: 'Cantonal interactive map and data',
        constructionHistory: 'Construction History',
        constructionPermits: 'Construction Permits',
        demographics: 'Demographics',
        detailedBuildingData: 'Detailed building characteristics and data',
        energyAndEnvironmentalData: 'Energy performance and environmental data',
        energyCertificate: 'Energy Certificate',
        energyEnvironment: 'Energy & Environment',
        exploreWithMaps: 'Explore the plot with different mapping tools',
        federalBuildingRegistry: 'Federal Building Registry',
        federalGeoportal: 'Federal Geoportal',
        geoAdminFederalData: 'map.geo.admin.ch - Federal data',
        googleEarth: 'Google Earth',
        googleMaps: 'Google Maps',
        landRegistry: 'Land Registry',
        localBuildingRecords: 'Local building records and permits',
        mapsNavigation: 'Maps and Navigation',
        municipalPortal: 'Municipal Portal',
        neighborhood: 'Neighborhood',
        neighborhoodLocalMarket: 'Neighborhood information and local market',
        neighborhoodStatistics: 'Neighborhood demographics and statistics',
        noBuildingData: 'Building data is required to generate external links',
        noiseExposure: 'Noise Exposure',
        noLinksAvailable: 'No external links available',
        noPropertyData: 'Property data is required to generate external links',
        officialBuildingData: 'Official building and dwelling data',
        officialBuildingStats: 'Official federal building statistics',
        officialEnergyRating: 'Official GEAK energy rating',
        officialExtractServitudes: 'Official extract and servitudes',
        officialRegistries: 'Official Registries',
        permitsHistory: 'History of issued permits in the area',
        publicLawRestrictions: 'Public law restrictions on land ownership',
        purchaseListings: 'Purchase Listings',
        recentSalesHistory: 'History sales history in the area',
        rentalListings: 'Rental Listings',
        rooftopSolarAnalysis: 'Rooftop solar potential analysis',
        similarPurchasePropertiesMarket: 'Sale listings in the same area on the market',
        similarRentalPropertiesMarket: 'Rental listings in the same area on the market',
        situationPlan: 'cadastre.ch - Situation Plan',
        situationPlanDescription: 'Official Swiss situation plan',
        solarPotential: 'Solar Potential',
        streetViewRoutes: 'Street View and routes',
        trafficNoiseData: 'Traffic and railway noise data',
        transactions: 'Transactions',
        view3dSatelliteHistory: '3D view and satellite history',
      },
      loading: 'Loading property data...',
      loadingForId: 'Loading property data for ID: {{id}}...',
      market: {
        all: 'All',
        allResidentialProperties: 'All residential properties',
        apartment: 'Apartment',
        avgPricePerSqm: 'Average price per m²',
        avgRentPerSqm: 'Average rent per m²',
        canton: 'Canton',
        cantonLevel: 'Canton level',
        cityGeneva: 'City of Geneva',
        dataUnavailable: 'Market data is currently unavailable',
        district: 'District',
        districtGeneva: 'District of Geneva',
        districtLevel: 'District level',
        faoData: 'Canton of Geneva',
        house: 'House',
        locationRequired: 'Property location is required to display market information',
        marketComparison: 'Market Comparison',
        marketOverview: 'Market Overview',
        medianPrice: 'Median Price',
        medianPricePerSqm: 'Median price per m²',
        medianRent: 'Median Rent',
        medianRentPerSqm: 'Median rent per m²',
        municipality: 'Municipality',
        municipalityLevel: 'Municipality level',
        noMarketData: 'No market data available',
        noRecentListings: 'No recent listings available',
        priceEvolution: 'Price Evolution',
        pricePerSqm: 'Price per m²',
        pricePerSqmEvolution: 'Price per m² Evolution',
        recentListings: 'Recent Listings',
        rent: 'Rent',
        rentPerSqm: 'Rent per m²',
        rooms: 'rooms',
        sale: 'Sale',
        thisYear: 'this year',
        viewMoreAnalysis: 'View more analysis',
        viewMoreListings: 'View more listings',
        yearOverYear: 'over 1 year',
      },
      noAddress: 'No address available',
      noPropertyData: 'No property data found',
      notes: 'Notes',
      notesPanel: {
        addNote: 'Add note',
        aiAssistant: 'AI Assistant',
        cancel: 'Cancel',
        clearSearch: 'Clear search',
        daysAgo: '{{count}} days ago',
        deleteConfirm: 'Delete this note?',
        deleteNote: 'Delete',
        editNote: 'Edit',
        hoursAgo: '{{count}} hour ago',
        hoursAgo_plural: '{{count}} hours ago',
        justNow: 'Just now',
        loading: 'Loading notes...',
        minutesAgo: '{{count}} minute ago',
        minutesAgo_plural: '{{count}} minutes ago',
        newNote: 'New note',
        noNotes: 'No notes',
        noNotesText: 'Start by adding a first note on this property',
        noResults: 'No results found',
        noResultsText: 'Try with other keywords',
        noteHint: 'Add your observations on this property',
        resultsInfo: '{{visible}} result',
        resultsInfo_plural: '{{visible}} results on {{total}} notes',
        saveNote: 'Save',
        searchPlaceholder: 'Search in notes...',
        title: 'Notes',
        weeksAgo: '{{count}} week ago',
        weeksAgo_plural: '{{count}} weeks ago',
        yesterday: 'Yesterday',
      },
      openAnalysis: 'Open Analysis',
      openEstimation: 'Open Estimation',
      propertyIdLabel: 'Property ID: {{id}}',
      removeFromFavorites: 'Remove from Favorites',
      retry: 'Retry',
      surfaceLabel: 'm² Surface',
      tabs: {
        comingSoon: 'Coming soon...',
        history: 'History',
        information: 'Information',
        links: 'Links',
        market: 'Market',
      },
      unitsLabel: 'Units',
    },
    propertyTooltip: {
      buildingInformation: {
        title: 'Building Information',
      },
      buildings: {
        buildingLabel: 'Building {{id}}',
        buildingYear: 'Building Year',
        energyReferenceSurface: 'Energy reference surface',
        floorNumber: 'Floor number',
        grossUsefulFloorArea: 'Gross useful floor area',
        groundFloorArea: 'Ground Floor Area',
        heatingEnergySource: 'Heating Energy source',
        idc: 'IDC',
        maxHeight: 'Max Height',
        numberOfDwellings: 'Number of dwellings',
        protected: 'Protected building',
        renovationYear: 'Renovation year',
        residentialFloorNumber: 'Residential Floor number',
        solarPotential: 'Solar potential',
        title: 'Buildings',
        totalResidentialArea: 'Total residential area',
        units: 'units',
        volume: 'Volume',
      },
      energy: {
        idc: 'IDC (Heat Consumption Index)',
        minergie: 'Minergie',
        title: 'Energy & Sustainability',
      },
      landInformation: {
        area: 'Area',
        buildingArea: 'Building Area',
        buildingPeriod: 'Building period',
        buildingRights: 'Building Rights',
        district: 'District',
        egrid: 'EGRID',
        lastRenovation: 'Last building renovation',
        municipality: 'Municipality',
        notApplicable: 'Not Applicable',
        numberOfBuildings: 'Number of buildings',
        numberOfDwellings: 'Number of dwellings',
        propertyNature: 'Property Nature',
        propertyNatureBF: 'Standard Property',
        propertyNatureDDP: 'Distinct Permanent Right (DDP)',
        swimmingPool: 'Swimming Pool',
        title: 'Land',
        totalResidentialArea: 'Total residential area',
        type: 'Type',
        zone: 'Zone',
      },
      lands: {
        title: 'Associated Land Parcels',
        unknownEgrid: 'Unknown EGRID',
        unknownType: 'Unknown Type',
      },
      owners: {
        company: 'Company',
        lastChange: 'Last change',
        localLabel: 'local',
        searchGoogle: 'Search on Google',
        searchLinkedIn: 'Search on LinkedIn',
        searchLocal: 'Search on local.ch',
        searchZefix: 'Search on Zefix (Swiss commercial register)',
        title: 'Owners',
        unknown: 'Unknown owner',
      },
      restrictions: {
        active: 'Active',
        coverage: '{{percent}}% coverage',
        coverageArea: 'Coverage area',
        description: 'Description',
        inactive: 'Inactive',
        newConstruction: 'New construction authorized',
        status: 'Status',
        title: 'Restrictions',
        type: 'Type',
      },
      transport: {
        title: 'Transport & Accessibility',
      },
      view: {
        title: 'Views & Orientation',
      },
      zones: {
        adoptedDate: 'adopted {{date}}',
        authorizedCOS: 'Authorized BCC',
        authorizedCUS: 'Authorized FAC',
        authorizedIBUS: 'Authorized GFAR',
        buildingArea: 'Building Area',
        category: 'Category',
        categoryCantonal: 'Cantonal',
        categoryGeneral: 'Communal',
        categoryLocal: 'Local',
        categoryPartial: 'Partial',
        name: 'Name',
        notApplicable: 'N/A',
        part: 'Part',
        planType: 'Plan type',
        title: 'Zones',
        zone: 'Zone',
      },
    },
    qualityLevels: {
      average: 'Average',
      excellent: 'Excellent',
      good: 'Good',
      high: 'High',
      low: 'Low',
      medium: 'Medium',
      poor: 'Poor',
      very_poor: 'Very Poor',
    },
    viewToggle: {
      list: 'List',
      map: 'Map',
    },
    wmsLayers: {
      ' Cadastral Surveying (OpenData)': 'Cadastral Surveying',
      airport_noise: 'Airport Noise',
      building_zones_switzerland_harmonized: 'Building Zones Switzerland',
      daily_railway_noise: 'Daily Railway Noise',
      daily_traffic_noise: 'Daily Traffic Noise',
      nightly_railway_noise: 'Nightly Railway Noise',
      nightly_traffic_noise: 'Nightly Traffic Noise',
      swissimage_past_1960: '1960 Swiss Aerial Imagery',
      swissimage_past_1970: '1970 Swiss Aerial Imagery',
      swissimage_past_1980: '1980 Swiss Aerial Imagery',
      swissimage_past_1990: '1990 Swiss Aerial Imagery',
      swissimage_past_2000: '2000 Swiss Aerial Imagery',
      swissimage_past_2010: '2010 Swiss Aerial Imagery',
      swissimage_past_2015: '2015 Swiss Aerial Imagery',
      swissimage_past_2020: '2020 Swiss Aerial Imagery',
      unconsolidated_deposits_thickness_model: 'Unconsolidated Deposits Thickness',
    },
  },
  feasibility: {
    assessment: {
      marginal: {
        description: 'The project is close to the {{target}}% viability threshold ({{marginal}}–{{target}}%). Consider optimizing costs or revenue.',
        title: 'Marginal Viability',
      },
      not_viable: {
        description: 'The project is below the {{marginal}}% developer-margin threshold. Significant changes are needed.',
        title: 'Not Viable',
      },
      viable: {
        description: 'The project meets the {{target}}% developer-margin target and shows strong financial viability.',
        title: 'Project Viable',
      },
    },
    empty: {
      description: 'No feasibility study data is available for this shared analysis.',
      title: 'No Feasibility Study',
    },
    keyMetrics: {
      belowTarget: 'Below Target',
      critical: 'Critical',
      developerMetrics: 'Developer Metrics',
      internalRateOfReturn: 'Internal Rate of Return (annualized)',
      investmentOverview: 'Investment Overview',
      netProfitEquity: 'Net profit / Total equity invested',
      revenueInvestment: 'Revenue / Total investment',
      targetLabel: 'Target: ≥ {{target}}%',
      targetMet: 'Target Met',
      totalEquityInProject: 'Total equity committed to the project',
    },
    metrics: {
      developerMargin: 'Developer Margin',
      equityInvested: 'Equity Invested',
      irr: 'IRR',
      profitMultiple: 'Profit Multiple',
      roiOnEquity: 'ROI on Equity',
    },
    quickFacts: {
      durationValue: '{{months}} months ({{years}} years)',
      equityRequired: 'Equity Required',
      landFinancing: 'Land Financing',
      notAvailable: 'N/A',
      pricePerM2: 'Avg Price/m²',
      projectDuration: 'Project Duration',
      projectType: 'Project Type',
      saleableArea: 'Saleable Area',
      timelineSplit: 'Timeline Split',
      timelineValue: '{{planning}}m planning + {{build}}m build',
      totalUnits: 'Total Units',
    },
    residual: {
      interpretation: 'At this maximum bid the {{pct}}% GDV target profit is met if the assumptions hold. Financing is taken as currently modelled and is not iterated with the land price.',
      maxBid: 'Maximum bid',
      negativeNote: 'Residual is negative — construction, financing and target profit exceed project value. The plot cannot support this programme at the target margin.',
      noPlotArea: 'Plot area unavailable — CHF/m² not shown',
      perM2Value: '{{value}} / m² of plot',
      question: 'What can I pay for this plot and still hit the target profit?',
      title: 'Residual land value',
    },
    sections: {
      costBreakdown: 'Cost Breakdown',
      financialSummary: 'Financial Summary',
      keyPerformanceIndicators: 'Key Performance Indicators',
      projectQuickFacts: 'Project Quick Facts',
    },
    summaryCards: {
      costBreakdown: 'Land: {{land}} | Construction: {{construction}}',
      financingCosts: 'Financing Costs',
      fromSales: 'From unit sales & additional revenue',
      grossProfit: 'Gross: {{gross}}',
      interestAndFees: 'Interest & fees during project',
      netProfit: 'Net Developer Profit',
      totalCosts: 'Total Costs',
      totalRevenue: 'Total Revenue',
    },
    waterfall: {
      construction: 'Construction',
      financing: 'Financing',
      landCosts: 'Land Costs',
      netProfit: 'Net Profit',
      revenue: 'Revenue',
    },
  },
  geoAnalysis: {
    charts: {
      altitude: 'Altitude (meters)',
      distance: 'Distance',
      flatArea: 'Flat Area',
      meters: 'm',
      plotBoundary: 'Plot Boundary',
      position: 'Position',
      slopedArea: 'Sloped Area',
      status: 'Status',
      xAxis: 'X (meters)',
      yAxis: 'Y (meters)',
    },
    directions: {
      east: 'East',
      eastWest: 'East-West',
      flat: 'Flat',
      north: 'North',
      northEast: 'North-East',
      northSouth: 'North-South',
      northWest: 'North-West',
      south: 'South',
      southEast: 'South-East',
      southWest: 'South-West',
      square: 'Square',
      west: 'West',
    },
    error: 'Unable to load geographical data',
    header: {
      scoreLabel: 'Geo score',
      scoreTooltip: 'Overall geographical suitability score based on slope, orientation, and shape',
      subtitle: 'Comprehensive topographic and geometric analysis for plot {{egrid}}',
      title: 'Geographical Analysis',
    },
    loading: 'Loading geographical data...',
    metrics: {
      areaEfficiency: 'Area Efficiency',
      averageSlope: 'Average Slope',
      buildable: 'Buildable',
      compactness: 'Compactness',
      compactnessScore: 'Compactness Score',
      constructionSuitability: 'Construction Suitability',
      dataPoints: 'Data Points',
      dimensions: 'Dimensions (L x W)',
      dominantOrientation: 'Dominant Orientation',
      elevationRange: 'Elevation Range',
      faces: 'Faces',
      gridSize: 'Grid Size',
      lengthWidth: 'Length x Width',
      maxAltitude: 'Max Altitude',
      maxFlatArea: 'Max Flat Area',
      maximum: 'Maximum',
      maximumFlatArea: 'Maximum Flat Area',
      maximumSlope: 'Maximum Slope',
      minAltitude: 'Min Altitude',
      minimum: 'Minimum',
      percentOfTotal: '% of Total',
      perimeter: 'Perimeter',
      regularity: 'Regularity',
      shapeFactor: 'Shape Factor',
      shapeRegularity: 'Shape Regularity',
      slopeThreshold: 'Slope Threshold',
      sunExposure: 'Sun exposure',
      totalArea: 'Total Area',
    },
    noAltitudeData: 'No altitude data available',
    noData: 'No data available',
    noElevationData: 'No elevation data available for this region',
    noPolygonData: 'No polygon data available',
    noSlopeAnalysis: 'No slope analysis available',
    plotTooSmall: 'Plot Too Small for Slope Analysis',
    plotTooSmallDescription: 'The plot is too small to perform a detailed slope analysis. Minimum area required is 100m².',
    sections: {
      altitudeProfile: 'Altitude Profile',
      developmentAnalysis: 'Development Analysis',
      flatAreaAnalysis: 'Flat Area Analysis',
      geometryAnalysis: 'Geometry Analysis',
      orientationAnalysis: 'Orientation Analysis (Sun Exposure)',
      plotBoundaryVisualization: 'Plot Boundary Visualization',
      shapeMetrics: 'Shape Metrics',
      slopeDistribution: 'Slope Distribution',
      slopeSunOrientation: 'Slope & Sun',
      topographicVisualization: '3D Topographic Visualization',
    },
    slopeRanges: {
      flat: 'Flat (0-5°)',
      gentle: 'Gentle (5-10°)',
      moderate: 'Moderate (10-15°)',
      range0_5: '0-5° (Flat)',
      range10_15: '10-15° (Moderate)',
      range15_25: '15-25° (Steep)',
      range5_10: '5-10° (Gentle)',
      rangeOver25: '>25° (Very Steep)',
      steep: 'Steep (15-25°)',
      verysteep: 'Very Steep (>25°)',
    },
    status: {
      challenging: 'Challenging',
      excellent: 'Excellent',
      good: 'Good',
      irregular: 'Irregular',
      loading: 'Loading...',
      moderate: 'Moderate',
      na: 'N/A',
      neutral: 'Neutral',
      noData: 'No Data',
      poor: 'Poor',
      realData: 'Real Data',
      regular: 'Regular',
    },
    sunExposureNotes: {
      excellent: 'Passive-heating potential',
      moderate: 'Balanced daylight',
      neutral: 'No dominant slope',
      poor: 'Limited direct sun',
    },
    tabs: {
      analysis: 'Slope & Orientation',
      overview: 'Overview',
      shape: 'Shape & Geometry',
      topography: '3D Topography',
    },
    tooltips: {
      areaEfficiency: {
        calculation: 'Flat area / Total area × 100%',
        importance: 'Higher efficiency means more of the plot is immediately usable.',
        shortDescription: 'Percentage of flat, buildable area compared to total plot area.',
        source: 'Composite analysis from elevation and cadastral data',
        title: 'Area Efficiency',
      },
      averageSlope: {
        calculation: 'Weighted average of slope values from elevation grid points.',
        categories: [
          {
            description: 'Ideal for construction, minimal earthwork required',
            label: 'Flat',
            range: '0-5°',
          },
          {
            description: 'Good for construction with minor adaptations',
            label: 'Gentle',
            range: '5-10°',
          },
          {
            description: 'Requires significant earthwork and retaining structures',
            label: 'Moderate',
            range: '10-15°',
          },
          {
            description: 'Challenging construction, specialized techniques needed',
            label: 'Steep',
            range: '>15°',
          },
        ],
        importance: 'Critical for construction feasibility and drainage planning.',
        limitations: 'Does not show local slope variations within the plot.',
        shortDescription: 'The mean slope angle across the entire plot surface.',
        source: 'SwissTopo elevation data (swissALTI3D)',
        title: 'Average Slope',
      },
      compactness: {
        calculation: '4π × Area / Perimeter² (1.0 = perfect circle)',
        importance: 'More compact shapes have lower boundary costs per unit area.',
        shortDescription: 'Ratio of plot area to perimeter, indicating shape efficiency.',
        source: 'Calculated from cadastral polygon data',
        title: 'Compactness',
      },
      compactnessScore: {
        calculation: 'Isoperimetric quotient: 4π × Area / Perimeter²',
        categories: [
          {
            description: 'Very compact shape, efficient use of space',
            label: 'High',
            range: '>0.7',
          },
          {
            description: 'Moderate compactness, typical for most plots',
            label: 'Medium',
            range: '0.4-0.7',
          },
          {
            description: 'Elongated or complex shape, less efficient',
            label: 'Low',
            range: '<0.4',
          },
        ],
        importance: 'Higher compactness means less boundary relative to area, reducing costs.',
        shortDescription: 'Measures how compact (circle-like) the plot shape is.',
        source: 'Calculated from cadastral polygon data',
        title: 'Compactness Score',
      },
      constructionSuitability: {
        calculation: 'Composite score based on slope, shape, and flat area percentage.',
        categories: [
          {
            description: 'Ideal conditions for construction',
            label: 'Excellent',
            range: '>80%',
          },
          {
            description: 'Favorable conditions with minor challenges',
            label: 'Good',
            range: '60-80%',
          },
          {
            description: 'Significant earthwork or adaptation needed',
            label: 'Moderate',
            range: '40-60%',
          },
          {
            description: 'Complex construction requirements',
            label: 'Challenging',
            range: '<40%',
          },
        ],
        importance: 'Quick indicator of development potential and construction costs.',
        shortDescription: 'Overall assessment of how suitable the plot is for construction.',
        source: 'Composite analysis from multiple data sources',
        title: 'Construction Suitability',
      },
      dimensions: {
        calculation: 'Calculated from minimum bounding rectangle.',
        importance: 'Helps determine maximum building dimensions that can fit on the plot.',
        shortDescription: "Length and width of the plot's bounding rectangle.",
        source: 'Calculated from cadastral polygon data',
        title: 'Dimensions',
      },
      dominantOrientation: {
        calculation: 'Determined by analyzing the aspect (slope direction) of the terrain.',
        importance: 'Affects solar gain, natural lighting, and energy efficiency of buildings.',
        shortDescription: 'The primary compass direction the plot faces, affecting sun exposure.',
        source: 'SwissTopo elevation data (swissALTI3D)',
        title: 'Dominant Orientation',
      },
      flatAreaAnalysis: {
        calculation: 'Grid analysis to identify contiguous flat zones.',
        importance: 'Flat areas are optimal for building placement and require less earthwork.',
        shortDescription: 'Identifies and measures areas with slope less than 5°.',
        source: 'SwissTopo elevation data (swissALTI3D)',
        title: 'Flat Area Analysis',
      },
      maxFlatArea: {
        calculation: 'Largest connected component analysis of flat grid cells.',
        importance: 'Determines the maximum building footprint possible without excavation.',
        shortDescription: 'The largest contiguous flat area on the plot.',
        source: 'SwissTopo elevation data (swissALTI3D)',
        title: 'Maximum Flat Area',
      },
      maximumSlope: {
        calculation: 'Maximum value from the slope grid analysis.',
        importance: 'Identifies potential problem areas for construction.',
        shortDescription: 'The steepest slope angle found anywhere on the plot.',
        source: 'SwissTopo elevation data (swissALTI3D)',
        title: 'Maximum Slope',
      },
      perimeter: {
        calculation: 'Sum of all edge lengths of the boundary polygon.',
        importance: 'Affects fencing costs and boundary considerations.',
        shortDescription: 'The total length of the plot boundary.',
        source: 'Calculated from cadastral polygon data',
        title: 'Perimeter',
      },
      regularity: {
        calculation: 'Plot area / Bounding rectangle area × 100%',
        importance: 'Higher regularity means more usable space for construction.',
        shortDescription: 'How well the plot fills its bounding rectangle.',
        source: 'Calculated from cadastral polygon data',
        title: 'Regularity',
      },
      shapeFactor: {
        calculation: 'Length / Width of minimum bounding rectangle.',
        categories: [
          {
            description: 'Nearly equal length and width',
            label: 'Square',
            range: '1.0-1.5',
          },
          {
            description: 'Moderate length-to-width ratio',
            label: 'Rectangular',
            range: '1.5-3.0',
          },
          {
            description: 'Long and narrow shape',
            label: 'Elongated',
            range: '>3.0',
          },
        ],
        importance: 'Indicates whether the plot is square, rectangular, or elongated.',
        shortDescription: "Ratio of length to width of the plot's bounding rectangle.",
        source: 'Calculated from cadastral polygon data',
        title: 'Shape Factor',
      },
      shapeRegularity: {
        calculation: 'Ratio of plot area to its minimum bounding rectangle area.',
        categories: [
          {
            description: 'Nearly rectangular, optimal for building placement',
            label: 'Regular',
            range: '>80%',
          },
          {
            description: 'Complex shape, may limit building options',
            label: 'Irregular',
            range: '<80%',
          },
        ],
        importance: 'Regular shapes are easier and more cost-effective to build on.',
        shortDescription: 'How close the plot shape is to a regular rectangle.',
        source: 'Calculated from cadastral polygon data',
        title: 'Shape Regularity',
      },
      slopeDistribution: {
        calculation: 'Grid-based slope analysis with categorization.',
        importance: 'Shows the variety of terrain conditions across the plot.',
        shortDescription: 'Breakdown of the plot by slope categories.',
        source: 'SwissTopo elevation data (swissALTI3D)',
        title: 'Slope Distribution',
      },
      totalArea: {
        calculation: 'Calculated using the Shoelace formula on the polygon coordinates.',
        importance: 'Essential for determining construction potential and property value.',
        limitations: 'May differ slightly from official cadastral measurements.',
        shortDescription: 'The total surface area of the plot calculated from its boundary polygon.',
        source: 'Calculated from cadastral polygon data',
        title: 'Total Area',
      },
    },
  },
  history: {
    actions: {
      exportCSV: 'Export to CSV',
      exportExcel: 'Export to Excel',
      filterByType: 'Filter by Type',
      sortByDate: 'Sort by Date',
      sortByPrice: 'Sort by Price',
      viewDetails: 'View Details',
    },
    adjustFilters: 'Try adjusting your filters',
    back: 'Back',
    buildingHistory: 'Building History',
    buildingHistorySubtitle: 'Any events gathered by Popety.io that happened on building {{egid}} in the last years.',
    detailView: {
      active: 'Active',
      addressNotSpecified: 'Address not specified',
      available: 'Available',
      balcony: 'Balcony',
      bathrooms: 'Bathrooms',
      built: 'Built',
      constructionYear: 'Construction Year',
      days: 'days',
      description: 'Description',
      elevator: 'Elevator',
      energyLabel: 'Energy Label',
      featuresAndAmenities: 'Features & Amenities',
      floor: 'Floor',
      furnished: 'Furnished',
      garage: 'Garage',
      garden: 'Garden',
      heatingType: 'Heating Type',
      immediately: 'Immediately',
      inactive: 'Inactive',
      landArea: 'Land Area',
      livingArea: 'Living Area',
      onlineFor: 'Online for',
      parking: 'Parking',
      petsAllowed: 'Pets Allowed',
      propertyAgents: 'Property Agents',
      propertyCategory: 'Property Category',
      propertyDetails: 'Property Details',
      propertyForRent: 'Property for Rent',
      propertyForSale: 'Property for Sale',
      propertyType: 'Property Type',
      published: 'Published',
      renovationYear: 'Renovation Year',
      rooms: 'Rooms',
      statusLabel: 'Status',
      terrace: 'Terrace',
    },
    error: 'Error',
    eventDetails: 'Event Details',
    fields: {
      address: 'Address',
      architect: 'Architect',
      area: 'Area',
      availableDate: 'Available',
      balcony: 'Balcony',
      bathrooms: 'Bathrooms',
      broker: 'Broker',
      buildingClassification: 'Building Classification',
      buyers: 'Buyers',
      classification: 'Class',
      constructionYear: 'Built',
      date: 'Date',
      description: 'Description',
      elevator: 'Elevator',
      energyLabel: 'Energy',
      floor: 'Floor',
      furnished: 'Furnished',
      garage: 'Garage',
      garden: 'Garden',
      heatingType: 'Heating',
      inquiryEnd: 'End Date',
      inquiryStart: 'Start Date',
      landArea: 'Land',
      listingType: 'Listing Type',
      onlineDays: 'Online Days',
      owner: 'Owner',
      ownersType: 'Owners Type',
      parking: 'Parking',
      permitNumber: 'Permit',
      permitType: 'Permit Type',
      petsAllowed: 'Pets allowed',
      previousTransaction: 'Previous Transaction',
      price: 'Price',
      pricePerSqm: 'Price/m²',
      projectArea: 'Area',
      projectValue: 'Value',
      propertyCategory: 'Category',
      propertyType: 'Property Type',
      reason: 'Reason',
      renovationYear: 'Renovated',
      rooms: 'Rooms',
      sellers: 'Sellers',
      status: 'Status',
      terrace: 'Terrace',
      type: 'Type',
      units: 'Units',
      workDescription: 'Work Description',
      workType: 'Type',
    },
    filters: {
      allTime: 'All Time',
      buildingPermits: 'Building Permits',
      dateRange: 'Date Range',
      export: 'Export',
      listings: 'Listings',
      rentalListings: 'Rental Listings',
      saleListings: 'Sale Listings',
      searchPlaceholder: 'Search history...',
      transactions: 'Transactions',
    },
    loading: 'Loading...',
    noBuildingDataAvailable: 'No building data available',
    noDataAvailable: 'No data available',
    noEstimateDataAvailable: 'No estimate data available',
    noEvents: 'No history events found',
    noLandDataAvailable: 'No land data available',
    ownershipType: 'Ownership Type',
    plotHistory: 'Plot History',
    plotHistorySubtitle: 'Any events gathered by Popety.io that happened on plot {{egrid}} in the last years.',
    propertyHistory: 'Property History',
    propertyHistorySubtitle: 'Any events gathered by Popety.io that happened on this property in the last years.',
    propertyTypes: {
      apartment: 'Apartment',
      commercial: 'Commercial',
      house: 'House',
      land: 'Land',
      office: 'Office',
      other: 'Other',
      parking: 'Parking',
    },
    sections: {
      inquiryPeriod: 'Public Inquiry Period',
      parties: 'Parties Involved',
      permitDetails: 'Permit Details',
      projectInfo: 'Project Information',
      propertyInfo: 'Property Information',
      transactionDetails: 'Transaction Details',
      workDescription: 'Work Description',
    },
    status: {
      active: 'Active',
      approved: 'Approved',
      inactive: 'Inactive',
      pending: 'Pending',
      rejected: 'Rejected',
    },
    subtitle: 'Timeline of events for {{address}}',
    timeline: {
      active: 'Active',
      buildingPermit: 'Building Permit',
      completed: 'Completed',
      days: 'days',
      expired: 'Expired',
      noEvents: 'No history events found',
      online: 'Online',
      pending: 'Pending',
      permitRequest: 'Permit Request',
      rentalListing: 'Rental Listing',
      saleListing: 'Sale Listing',
      transaction: 'Transaction',
    },
    title: 'History',
    transactionDetail: {
      fields: {
        city: 'City',
        legalType: 'Legal Type',
        numberOfBuyers: 'Number of Buyers',
        numberOfProperties: 'Number of Properties',
        numberOfSellers: 'Number of Sellers',
        officialId: 'Official ID',
        participant: 'Participant',
        participantType: 'Type',
        postalCode: 'Postal Code',
        property: 'Property',
        propertyNumber: 'Property Number',
        publicationDate: 'Publication Date',
        role: 'Role',
        share: 'Share',
        totalPrice: 'Total Price',
        totalSurface: 'Total Surface',
        transactionDate: 'Transaction Date',
        transactionId: 'Transaction ID',
        transactionType: 'Transaction Type',
      },
      sections: {
        participants: 'Participants',
        properties: 'Properties',
        summary: 'Summary',
        transactionInfo: 'Transaction Information',
      },
    },
  },
  landAnalysis: {
    buildingDetails: {
      actions: {
        analysis: 'Analysis',
        cancel: 'Cancel',
        edit: 'Edit',
        explore: 'Explore',
        noBuildingId: 'Building ID not available',
        noEgid: 'EGID not available for this building',
        regbl: 'GWR',
        save: 'Save',
      },
      card: {
        building: 'Building {{number}}',
        egid: 'EGID {{egid}}',
        floor: 'Floor',
        floors: 'Floors',
      },
      header: {
        scoreLabel: 'Legacy Score',
        scoreTooltip: 'Legacy building score based on construction and renovation years',
        subtitle: 'Comprehensive information about all buildings on {{address}}',
        title: 'Building Details',
      },
      legend: {
        estimatedValues: 'Estimated Values',
        fullCoverage: 'Full Coverage',
        garage: 'Garage',
        industrial: 'Industrial',
        offices: 'Offices',
        other: 'Other',
        partialCoverage: 'Partial Coverage',
        public: 'Public',
        residential: 'Residential',
        residentialMajority: 'Residential Majority',
        residentialMinority: 'Residential Minority',
        retail: 'Retail',
      },
      sections: {
        dimensions: {
          estFloorArea: 'Est. Floor Area',
          grossFloorArea: 'Gross Floor Area',
          groundArea: 'Ground Area',
          height: 'Height',
          title: 'Dimensions',
          volume: 'Volume',
        },
        energy: {
          mainHeating: 'Main Heating',
          secondaryHeating: 'Secondary Heating',
          solarPotential: 'Solar Potential',
          title: 'Energy',
          waterHeating: 'Water Heating',
        },
        propertyInfo: {
          classification: 'OFS Classification',
          officialNumber: 'Official Number',
          ofsCategory: 'OFS Category',
          title: 'Property Info',
          units: 'Units',
        },
        status: {
          compliance: 'Compliance',
          constructionStatus: 'Construction Status',
          lastRenovation: 'Last Renovation',
          protectionStatus: 'Protection Status',
          title: 'Status',
        },
      },
      states: {
        loading: 'Loading building details...',
        noData: 'No data available',
        unknownLocation: 'Unknown location',
      },
      summary: {
        buildingsNumber: 'Buildings number',
        protectedBuildings: 'Protected buildings',
        unitsNumber: 'Units number',
      },
      summaryBar: {
        other: 'other structures',
        plannedConstruction: 'planned/construction',
        protected: 'protected',
        registered: 'registered',
        total: 'total buildings',
        underground: 'underground',
      },
      units: {
        cubicMeters: 'm³',
        meters: 'm',
        notAvailable: 'N/A',
        squareMeters: 'm²',
      },
      values: {
        building: 'Building {{index}}',
        compliant: 'Compliant',
        good: 'Good',
        heritageProtected: 'Heritage protected',
        na: 'N/A',
        notClassified: 'Not classified',
        notProtected: 'Not protected',
        notSpecified: 'Not specified',
        projected: 'Projected',
        solarExcellent: 'Excellent',
        solarGood: 'Good',
        solarLow: 'Low',
        solarMedium: 'Medium',
      },
    },
    buildingsOverview: {
      aboveGroundVolume: 'Above-ground Volume',
      buildingCoverage: 'Building Coverage (IDC)',
      constructionYear: 'Construction Year',
      dimensions: 'Dimensions',
      general: 'General',
      maximumFloors: 'Maximum Floors',
      maximumHeight: 'Maximum Height',
      notAvailable: 'N/A',
      numberOfBuildings: 'Number of Buildings',
      title: 'Buildings Overview',
      totalFloorArea: 'Total Floor Area',
      totalGroundArea: 'Total Ground Area',
    },
    common: {
      no: 'No',
      notAvailable: 'N/A',
      yes: 'Yes',
    },
    filesPanel: {
      title: 'Files',
    },
    header: {
      addTags: 'Add tags',
      addToDeal: 'Add to Deal',
      buildingAnalysis: 'Building Analysis',
      built: 'Built',
      createNewBuildingAnalysis: 'Create New Building Analysis',
      createNewLandAnalysis: 'Create New Land Analysis',
      favorite: 'Favorite',
      files: 'Files',
      floors: 'floors',
      groupLandAnalysis: 'Group Land Analysis',
      landAnalysis: 'Land Analysis',
      newBuildingAnalysis: 'New Building Analysis',
      newLandAnalysis: 'New Land Analysis',
      notes: 'Notes',
      pdfReports: 'PDF Reports',
      share: 'Share',
      subtitle: 'Land parcel information',
      subtitleMultiplePlots: '{{count}} land parcels for {{address}}',
      subtitleSinglePlot: 'Land parcel details for {{address}}',
      subtitleWithAddress: 'Land information for {{address}}',
      tags: 'Tags',
      title: 'Land',
      units: 'units',
    },
    info: {
      area: 'Area',
      buildable: 'Buildable',
      buildingAreaPresent: 'Building Area Present',
      egridNumber: 'EGRID Number',
      officialArea: 'Official Area',
      plotNumber: 'Plot Number',
      propertyNature: 'Property nature',
      propertyNatureBF: 'BF – Land property',
      propertyNatureDDP: 'DDP – Distinct and permanent right',
      title: 'Land Information',
      type: 'Ownership Type',
    },
    links: {
      openLandAnalysis: 'Open Land Analysis',
      title: 'Quick Links',
      viewInExplore: 'View in Explore',
    },
    marketActivity: {
      activeListings: 'Active Listings',
      buildingPermits: 'Building Permits',
      recentActivity: 'Recent Activity',
      title: 'Market Activity',
      transactions: 'Transactions',
    },
    metrics: {
      buildings: {
        subtext: 'On this land',
        title: 'Buildings',
      },
      landArea: {
        subtext: 'Total area',
        title: 'Land Area',
      },
      underExploitedScore: {
        subtext: 'Development potential',
        title: 'Under-exploited',
        tooltip: {
          calculation: 'Based on current vs. allowed floor area ratio.',
          description: 'Measures how much of the buildable potential is currently used.',
          importance: 'Higher scores indicate more development opportunity.',
          source: 'Calculated from zoning regulations and current buildings.',
          title: 'Under-exploited Score',
        },
      },
      units: {
        subtext: 'Residential units',
        title: 'Units',
      },
    },
    owners: {
      lastChange: 'Last Change',
      names: 'Owner Names',
      number: 'Number of Owners',
      ownershipType: 'Ownership Type',
      title: 'Ownership',
    },
    ownership: {
      contact: 'Contact',
      lastChange: 'Last change:',
      noOwnerInfo: 'No owner information available',
      owners: 'Owners:',
      title: 'Ownership',
      unknown: 'Unknown',
      unknownOwner: 'Unknown Owner',
      viewProfile: 'View Profile',
    },
    propertyInformation: {
      addresses: 'Addresses',
      area: 'Area',
      bareLand: 'Bare Land',
      basicInformation: 'Basic Information',
      municipality: 'Municipality',
      no: 'No',
      notAvailable: 'N/A',
      plotNumber: 'Plot Number',
      privateLand: 'Private Land',
      propertyId: 'Property ID (EGRID)',
      publicLand: 'Public Land',
      title: 'Property Information',
      type: 'Type',
      unknown: 'Unknown',
      viewAllAddresses: 'View all {{count}} addresses',
      viewOnGeoPortal: 'View on Geo Portal',
      yes: 'Yes',
    },
    restrictions: {
      activeRestrictions: {
        one: '{{count}} Active Restriction',
        other: '{{count}} Active Restrictions',
      },
      affected: 'Affected',
      affectedTypes: 'Affected Types',
      noActiveRestrictions: 'No Active Restrictions',
      notAffected: 'Not Affected',
      notAvailable: 'Not Available',
      title: 'Restrictions (RDPPF)',
      typesChecked: '{{total}} types checked, {{affected}} affected',
      viewDetailedRestrictions: 'View detailed restrictions',
    },
    scoreOverview: {
      developmentScore: 'Development Score',
      legacyScore: 'Legacy Score',
      livabilityScore: 'Livability Score',
      underExploitedScore: 'Under-exploited Score',
    },
    sidebar: {
      items: {
        amenities: 'Amenities',
        buildingDetails: 'Building Details',
        buildingPermits: 'Building Permits',
        demographics: 'Demographics',
        electricity: 'Electricity',
        employment: 'Employment',
        feasibilityStudy: 'Feasibility Study',
        geoAnalysis: 'Geo Analysis',
        history: 'History',
        noiseAnalysis: 'Noise Analysis',
        purchaseListings: 'Purchase Listings',
        purchaseMarket: 'Purchase Market',
        rentalListings: 'Rental Listings',
        rentalMarket: 'Rental Market',
        restrictions: 'Restrictions',
        summary: 'Summary',
        sunlightStudy: 'Sunlight Study',
        taxes: 'Taxes',
        transactions: 'Transactions',
        transportAccess: 'Transport & Access',
        zoning: 'Zoning',
        zoningRules: 'Zoning Rules',
      },
      sections: {
        development: 'Development',
        environment: 'Environment',
        market: 'Market',
        overview: 'Overview',
        socialEconomic: 'Social & Economic',
      },
    },
    states: {
      empty: {
        description: 'No land information available for this property.',
        title: 'No Land Data',
      },
      error: {
        retry: 'Retry',
        title: 'Error Loading Data',
      },
      errorLoadingData: 'Error Loading Land Data',
      loading: 'Loading land data...',
      noDataAvailable: 'No land data available',
      notAvailable: 'N/A',
      retry: 'Retry',
    },
    summaryTab: {
      loading: 'Loading summary data...',
      noData: 'No data available',
      subtitle: 'Overview and key information for {{address}}',
      title: 'Property Summary',
      unknownLocation: 'Unknown location',
    },
    tagsPanel: {
      add: 'Add',
      adding: 'Adding...',
      addNewTag: 'Add New Tag',
      buildingTags: 'Building Tags',
      closePanel: 'Close panel',
      currentTags: 'Current Tags ({{count}})',
      emptyStateHint: 'Add tags above to organize and categorize this property',
      enterTagName: 'Enter tag name...',
      groupLandTags: 'Group Land Tags',
      landTags: 'Land Tags',
      loadingTags: 'Loading tags...',
      manageTags: 'Manage Tags',
      noTagsAssigned: 'No tags assigned',
      title: 'Tags',
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Additional Filters',
        advancedFilters: 'Advanced filters',
        allLocations: 'All locations',
        clearAll: 'Clear all',
        hideFilters: 'Hide filters',
        landArea: 'Land Area (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Other',
        legalTypePPE: 'PPE',
        numberOfBuyers: 'Number of Buyers',
        numberOfSellers: 'Number of Sellers',
        others: 'Others',
        participantAssociation: 'Association',
        participantCompany: 'Company',
        participantCooperative: 'Cooperative',
        participantFoundation: 'Foundation',
        participantIndividual: 'Individual',
        participantOther: 'Other',
        participantPublicEntity: 'Public entity',
        participants: 'Participants',
        participantType: 'Participant Type',
        propertyLegalType: 'Property Legal Type',
        radius: 'Radius',
        showFilters: 'Show filters',
        stepTransactionPrice: 'Step Transaction Price (CHF)',
        transactionDate: 'Transaction Date',
        transactionType: 'Transaction Type',
        typeAreaPrice: 'Type, Area & Price',
        unitApartment: 'Apartment',
        unitCommercial: 'Commercial',
        unitHouse: 'House',
        unitLand: 'Land',
        unitOther: 'Other',
        unitParking: 'Parking',
        unitType: 'Unit Type',
      },
      subtitle: 'Explore transaction history around the plot and save the ones you are interested in for this analysis.',
      tabs: {
        aroundPlot: 'Transactions around the plot',
        saved: 'Saved Transactions',
      },
      title: 'Transactions',
    },
    units: {
      percent: '%',
      score: '/100',
      squareMeters: 'm²',
    },
    zoneAssignment: {
      buildable: 'Buildable',
      nonBuildable: 'Non-buildable',
      title: 'Zone Assignment',
      unknownZone: 'Unknown Zone',
    },
    zones: {
      adopted: 'Adopted',
      buildingArea: 'Building Area',
      cos: 'BCC',
      coverageArea: 'Coverage',
      cus: 'FAC',
      defaultName: 'Zone {{number}}',
      ibus: 'GFAR',
      planTypeAdoption: 'Plan Type',
      title: 'Zoning',
      zoneName: 'Zone Name',
    },
  },
  listings: {
    aiFilter: {
      description: "Describe the property you're looking for, and I'll help you find it.",
      errors: {
        processingFailed: 'An error occurred while processing your request',
      },
      examplePrompts: {
        '0': 'Show me apartments for rent in Zurich under 3000 CHF',
        '1': 'Find houses for sale in Geneva with 4+ rooms',
      },
      placeholder: "e.g., '2-bedroom apartment for rent in Lausanne under 2500 CHF'",
      processing: 'Processing...',
      recentSearches: 'Recent Searches',
      search: 'Search',
      title: 'Listing Filter Assistant',
    },
    common: {
      active: 'Active',
      addressNotAvailable: 'Address not available',
      allLocations: 'All locations',
      built: 'built',
      days: 'days',
      distance: 'Distance',
      expired: 'Expired',
      km: 'km',
      m: 'm',
      na: 'N/A',
      perSqm: '/ m²',
      priceOnRequest: 'Price on request',
      propertyImage: 'Property image',
      propertyListing: 'Property Listing',
      radius: 'Radius',
      rooms: 'rooms',
      sqm: 'm²',
      to: 'to',
      unknown: 'Unknown',
    },
    dates: {
      daysAgo: '{{count}} days ago',
      listed: 'Listed',
      monthsAgo: '{{count}} months ago',
      today: 'Today',
      weeksAgo: '{{count}} weeks ago',
      yearsAgo: '{{count}} years ago',
      yesterday: 'Yesterday',
    },
    detail: {
      agents: {
        unknownAgent: 'Unknown Agent',
      },
      buttons: {
        addToFavorites: 'Add to favorites',
        estimate: 'Estimate',
        findAddress: 'Find Address',
        findExactAddress: 'Find the exact address',
        goToAnalysis: 'Go to Analysis',
        goToEstimate: 'Go to Estimate',
        goToExplore: 'Go to Explore',
        viewInLandAnalysis: 'View in Land Analysis',
        viewOnExplore: 'View on Explore',
      },
      error: 'Error',
      fallbacks: {
        addressNotSpecified: 'Address not specified',
        day: 'day',
        days: 'days',
        house: 'House',
        immediately: 'Immediately',
        listedOnPlatform: 'Listed on this platform',
        noAdditionalImages: 'No additional images available',
        noDescriptionAvailable: 'No description available',
        property: 'Property',
        propertyId: 'Property ID',
        propertyImage: 'Property Image',
      },
      labels: {
        agency: 'Agency',
        available: 'Available',
        bathrooms: 'Bathrooms',
        buildingYear: 'Building Year',
        category: 'Category',
        constructionYear: 'Construction Year',
        floor: 'Floor',
        id: 'ID',
        landSurface: 'Land Surface',
        listedOn: 'Listed on',
        mandateType: 'Mandate Type',
        newConstruction: 'New Construction',
        onlineFor: 'Online for',
        published: 'Published',
        status: 'Status',
        type: 'Type',
      },
      loading: 'Loading listing details...',
      metrics: {
        bathrooms: 'Bathrooms',
        buildYear: 'Build Year',
        landArea: 'Land Area',
        livingArea: 'Living Area',
        price: 'Price',
        rooms: 'Rooms',
      },
      sections: {
        description: 'Description',
        features: 'Features & Amenities',
        listedOnPortals: 'Listed on Portals',
        listingInformation: 'Listing Information',
        propertyAgents: 'Property Agents',
        propertyDetails: 'Property Details',
        propertyGallery: 'Property Gallery',
      },
      status: {
        active: 'Active',
        expired: 'Expired',
      },
      vendorTypes: {
        private: 'Private',
        professional: 'Professional',
        unknown: 'Unknown',
      },
    },
    detailPanel: {
      columns: {
        change: 'Change',
        date: 'Date',
        price: 'Price',
        pricePerSqm: 'Price/m²',
      },
      empty: {
        noDescription: 'No description available',
        noFeatures: 'No features listed',
        noPriceHistory: 'No price history available',
      },
      labels: {
        address: 'Address',
        availability: 'Availability',
        daysOnMarket: 'Days on market',
        description: 'Description',
        features: 'Features',
        floor: 'Floor',
        listingDate: 'Listing date',
        livingArea: 'Living area',
        price: 'Price',
        pricePerSqm: 'Price per m²',
        propertyDetails: 'Property Details',
        propertyListing: 'Property Listing',
        propertyType: 'Property type',
        rooms: 'Rooms',
        status: 'Status',
        usableArea: 'Usable area',
        viewOriginal: 'View original listing',
        yearBuilt: 'Year built',
      },
      tabs: {
        details: 'Details',
        location: 'Location',
        overview: 'Overview',
        priceHistory: 'Price History',
      },
    },
    distanceOptions: {
      '1km': '1km',
      '2km': '2km',
      '500m': '500m',
      '5km': '5km',
    },
    filter: {
      activeFilter: 'active filter',
      activeFilters: 'active filters',
      additionalFilters: 'Additional Filters',
      advancedFilters: 'Advanced filters',
      allLocations: 'All locations',
      clearAll: 'Clear all',
      customPriceRange: 'Custom Price Range (CHF)',
      floorLevel: 'Floor Level',
      from: 'From',
      hideFilters: 'Hide filters',
      listingDate: 'Listing Date',
      livingArea: 'Living Area (m²)',
      max: 'Max',
      min: 'Min',
      priceSizeRooms: 'Price, Size & Rooms',
      propertyType: 'Property Type',
      propertyTypes: {
        apartment: 'Apartment',
        commercial: 'Commercial',
        garageParking: 'Garage/Parking',
        house: 'House',
        other: 'Other',
        plot: 'Plot',
        residential: 'Residential',
      },
      radius: 'Radius',
      rooms: 'Rooms',
      roomsLabel: 'rooms',
      showFilters: 'Show filters',
      to: 'To',
      yearBuilt: 'Year Built',
    },
    filters: {
      actions: {
        activeFilters: 'Active filters',
        apply: 'Apply',
        clearAll: 'Clear all',
        clearAllFilters: 'Clear all filters',
        closeFilters: 'Close filters',
        lessFilters: 'Less filters',
        loadSavedFilters: 'Load saved filters',
        moreFilters: 'More filters',
        openFilters: 'Open filters',
        saveCurrentFilters: 'Save current filters',
      },
      ai: {
        textSearchError: 'Failed to process your request. Please try again.',
        voiceSearchError: 'Failed to process your voice request. Please try again.',
      },
      fields: {
        area: 'Area',
        floor: 'Floor',
        from: 'From',
        listingDate: 'Listing Date',
        listingDuration: 'Listing Duration',
        mandateType: 'Mandate Type',
        max: 'Max',
        min: 'Min',
        price: 'Price',
        pricePerSqm: 'Price per m²',
        status: 'Status',
        to: 'To',
        typeOfProperty: 'Type of Property',
        vendorType: 'Vendor Type',
        yearOfConstruction: 'Year of Construction',
      },
      loading: 'Loading filters...',
      mandateTypes: {
        exclusive: 'Exclusive',
        simple: 'Simple',
        unknown: 'Unknown',
      },
      placeholders: {
        enterValue: 'Enter value',
        from: 'From',
        max: 'Max',
        min: 'Min',
        searchLocation: 'Search location...',
        selectOption: 'Select option',
        to: 'To',
      },
      propertyTypes: {
        apartment: 'Apartment',
        commercial: 'Commercial',
        garageParking: 'Garage/Parking',
        house: 'House',
        other: 'Other',
        plot: 'Plot',
      },
      quickFilters: {
        listed: 'Listed',
        propertyCategory: 'Property Category',
      },
      saved: {
        appliedFilter: 'Applied filter: {{name}}',
        failedToSave: 'Failed to save filter',
        savedFilter: 'Saved filter: {{name}}',
        savedOn: 'Saved on {{date}}',
      },
      sections: {
        brokerInfo: 'Broker Info',
        buildingYear: 'Building Year',
        dateRange: 'Date Range',
        floor: 'Floor',
        landArea: 'Land Area',
        livingArea: 'Living Area',
        location: 'Location',
        locationDate: 'Location & Date',
        mandateType: 'Mandate Type',
        portals: 'Portals',
        price: 'Price',
        priceRange: 'Price Range',
        propertyCharacteristics: 'Property Characteristics',
        propertyType: 'Property Type',
        rooms: 'Rooms',
        status: 'Status',
        vendorType: 'Vendor Type',
      },
      title: 'Listing Filters',
      validation: {
        invalidRange: 'Invalid range',
        requiredField: 'Required field',
      },
      vendorTypes: {
        private: 'Private',
        professional: 'Professional',
        unknown: 'Unknown',
      },
    },
    list: {
      columns: {
        area: 'Area',
        date: 'Date',
        duration: 'Duration',
        image: 'Image',
        location: 'Location',
        mandateType: 'Mandate Type',
        portals: 'Portals',
        price: 'Price',
        property: 'Property',
        rooms: 'Rooms',
        status: 'Status',
        vendor: 'Vendor',
        year: 'Year',
      },
      duration: {
        day: 'day',
        days: 'days',
      },
      export: {
        filename: 'listings_export',
        toExcel: 'Export to Excel',
        toPdf: 'Export to PDF',
      },
      fallbacks: {
        dash: '—',
        noData: 'No data',
        noImage: 'No image',
        unknown: 'Unknown',
      },
      mandate: {
        exclusive: 'Exclusive',
        shared: 'Shared',
        unknown: 'Unknown',
      },
      status: {
        active: 'Active',
        expired: 'Expired',
      },
      vendor: {
        individual: 'Individual',
        pro: 'Professional',
        unknown: 'Unknown',
      },
    },
    map: {
      errorLoadingMapData: 'Error loading map data',
      loading: 'Loading...',
      loadingMapData: 'Loading map data...',
      tooltip: {
        area: 'Area',
        forRent: 'For Rent',
        forSale: 'For Sale',
        listingAlt: 'Listing',
        location: 'Location',
        noImageAvailable: 'No image available',
        priceOnRequest: 'Price on request',
        propertyId: 'Property ID',
        rooms: 'rooms',
      },
    },
    priceRanges: {
      '1MTo2M': '1M - 2M',
      '500kTo1M': '500k - 1M',
      over2M: '> 2M',
      under500k: '< 500k',
    },
    print: {
      about: {
        realTimeData: 'This report provides real-time market analytics based on listings aggregated from major Swiss real estate portals.',
      },
      contact: {
        email: 'Email',
        forQuestions: 'For questions about this report, please contact:',
        popetyContact: 'Popety.io | info@popety.io | www.popety.io',
        title: 'Contact Information',
        website: 'Website',
        yourContact: 'Your Contact',
      },
      cover: {
        aboutThisReport: 'About This Report',
        analyticsFooter: 'Real Estate Market Analytics Platform',
        appliedFilters: 'Applied Filters',
        createdOnPopety: 'Created on Popety.io - Real Estate Market Analytics Platform',
        dealType: 'Deal Type',
        generated: 'Generated',
        generatedOn: 'Generated on',
        listingDate: 'Listing Date',
        listingsList: 'Listings List',
        listingsSelectedOn: 'Listings selected on',
        location: 'Location',
        priceRange: 'Price Range',
        propertyType: 'Property Type',
        realEstateMarketReport: 'Real Estate Market Report',
        rentalListingsReport: 'Rental Listings Statistical Report',
        rentals: 'Rentals',
        sales: 'Sales',
        salesListingsReport: 'Sales Listings Statistical Report',
        switzerland: 'Switzerland',
        timePeriod: 'Time Period',
      },
      dataSource: {
        collectionPeriod: 'Data collection period: Continuous, with regular updates',
        description: 'This report aggregates data from the following sources:',
        includesOutlierFiltering: 'Data sources: Official real estate listings and market transactions. Analysis includes outlier filtering for accuracy.',
        lastRefresh: 'Last data refresh: Real-time at the moment of report generation',
        popetyAnalytics: 'Popety.io proprietary analytics platform',
        publicListings: 'Public real estate listings and market data',
        statisticalAnalysis: 'Statistical analysis performed by Popety.io algorithms',
        swissPortals: 'Major Swiss real estate portals including Homegate, ImmoScout24, and others',
        title: 'Data Sources',
      },
      details: {
        built: 'Built',
        listingOf: 'Listing {{current}} of {{total}}',
        noImageAvailable: 'No Image Available',
        propertyListing: 'Property Listing',
        unknownAddress: 'Unknown Address',
      },
      disclaimer: {
        accuracyOfInformation: {
          content: 'The information contained in this report is provided for general informational purposes only. While we strive to keep the information up to date and accurate, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the report or the information, products, services, or related graphics contained in the report for any purpose.',
          title: 'Accuracy of Information',
        },
        copyrightNotice: {
          content: '© {{year}} Popety.io. All rights reserved. This report and its contents are protected by copyright and other intellectual property rights. Unauthorized reproduction, distribution, or use of this report is strictly prohibited.',
          title: 'Copyright Notice',
        },
        dataPrivacy: {
          content: 'We respect your privacy and are committed to protecting your personal data. This report may contain aggregated and anonymized market data collected from publicly available sources.',
          title: 'Data Privacy',
        },
        noInvestmentAdvice: {
          content: 'This report does not constitute investment, legal, tax, or other professional advice. You should not rely on this report as the sole basis for making investment decisions. Always seek the advice of qualified professionals before making any investment decisions.',
          title: 'No Investment Advice',
        },
        title: 'Disclaimer & Legal Notice',
      },
      format: {
        details: 'Details',
        fullPage: 'Full page per listing',
        summary: 'Summary',
        tableView: 'Table view, multiple per page',
      },
      modal: {
        cancel: 'Cancel',
        close: 'Close',
        downloadPdf: 'Download PDF',
        exportListingsToPdf: 'Export Listings to PDF',
        failedToGeneratePdf: 'Failed to generate PDF. Please try again.',
        fullMarketReport: 'Full Market Report',
        generatePdf: 'Generate PDF',
        generatingPdf: 'Generating PDF...',
        listing: 'listing',
        listings: 'listings',
        pageOf: 'Page {{current}} of {{total}}',
        pagesTotal: 'pages total',
        preview: 'Preview',
        previewAndDownload: 'Preview and download a comprehensive market report with all sections',
        priceEvolution: 'Price Evolution',
        rentEvolution: 'Rent Evolution',
        resetZoom: 'Reset zoom',
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
      },
      progress: {
        addingContent: 'Adding content',
        addingPageNumbers: 'Adding page numbers and final touches',
        addingTitleAndBranding: 'Adding title, company info, and branding',
        convertingCharts: 'Converting charts to high-quality images',
        creatingCoverPage: 'Creating cover page',
        exportingCharts: 'Exporting charts',
        finalizingPdf: 'Finalizing PDF',
        generatingPdfReport: 'Generating PDF Report',
        generatingSections: 'Generating sections, insights, and data',
        initializingPdf: 'Initializing PDF',
        pleaseWait: 'Please wait while we create your comprehensive market analysis',
        settingUpDocument: 'Setting up document structure and styles',
      },
      sections: {
        tableOfContents: 'Table of Contents',
      },
      summary: {
        area: '{{value}} m²',
        builtYear: 'Built {{year}}',
        id: 'ID',
        pageOfListings: 'Page {{page}} of {{total}} • Listings {{start}}-{{end}}',
        rooms: '{{count}} rooms',
        type: 'Type',
      },
    },
    propertyTypes: {
      apartment: 'Apartment',
      commercial: 'Commercial',
      house: 'House',
      parking: 'Parking',
      plot: 'Plot',
    },
    roomOptions: {
      '1room': '1 room',
      '2rooms': '2 rooms',
      '3rooms': '3 rooms',
      '4rooms': '4 rooms',
      '5plusRooms': '5+ rooms',
    },
    saved: {
      addressNotAvailable: 'Address not available',
      allSaved: 'All saved',
      averagePrice: 'Average Price',
      avgLivingArea: 'Avg Living Area',
      avgPricePerSqm: 'Avg Price/m²',
      avgRooms: 'Avg Rooms',
      empty: 'No saved listings yet',
      emptyDescription: 'Save listings from the "Listings around the plot" tab to compare them later',
      emptyTitle: 'No saved listings yet',
      listings: 'Listings',
      livingArea: 'Living area',
      loading: 'Loading saved listings...',
      perListing: 'Per listing',
      perListing2: 'Per listing',
      perSqm: '/m²',
      priceOnRequest: 'Price on request',
      priceRangeLabel: 'Price Range',
      propertyImage: 'Property image',
      propertyListing: 'Property listing',
      removeFromSaved: 'Remove from saved',
      saveListing: 'Save listing',
      sqm: 'm²',
      to: 'to',
      totalSaved: 'Total Saved',
      totalValue: 'Total Value',
    },
    sections: {
      purchaseSubtitleBuilding: 'View purchase listings around this building',
      purchaseSubtitleLand: 'View purchase listings around this land',
      purchaseTitle: 'Purchase Listings',
      rentSubtitleBuilding: 'View rental listings around this building',
      rentSubtitleLand: 'View rental listings around this land',
      rentTitle: 'Rent Listings',
    },
    stats: {
      actions: {
        showLess: 'Show less',
        showMore: 'Show more',
      },
      charts: {
        byPropertyType: 'by Property Type',
        distributionByQuantiles: 'Distribution by Quantiles',
        distributionByRooms: 'Distribution by Rooms',
        geographicVolumeDistribution: 'Geographic Volume Distribution',
        portalMarketShareEvolution: 'Portal Market Share Evolution',
        pricePerSquareMeter: 'Price per Square Meter',
        rankingsByPrice: 'Rankings by Price',
        rankingsByRent: 'Rankings by Rent',
        rentPerSquareMeter: 'Rent per Square Meter',
      },
      dataSource: {
        description: 'Data aggregated from major Swiss real estate portals',
        disclaimer: 'Disclaimer',
        title: 'Data Sources',
      },
      defaults: {
        allProperties: 'All Properties',
        allSwitzerland: 'All Switzerland',
      },
      descriptions: {
        agencyAnalysis: 'Evaluate the performance and market share of different real estate agencies to identify market leaders.',
        agencyAnalysisRental: 'Evaluate the performance and market share of different rental agencies.',
        cityAnalysis: 'Analyzing price density patterns across major cities to understand market variations and identify opportunities.',
        cityAnalysisRental: 'Analyzing rent density patterns across major cities to understand rental market variations.',
        newVsResale: 'Compare pricing trends and market dynamics between newly constructed properties and resale properties.',
        newVsResaleRental: 'Compare rental rates between newly constructed properties and older properties.',
        portalAnalysis: 'Assess the effectiveness and reach of different real estate listing portals for property marketing.',
        portalAnalysisRental: 'Assess the effectiveness of different rental listing portals for property marketing.',
        priceEvolution: 'Track the evolution of property prices over time to identify market trends and patterns in the real estate market.',
        priceGeography: 'Visualize property prices across different geographical areas to identify high-value and affordable regions.',
        priceM2Evolution: 'Analyze the evolution of property prices per square meter to understand value trends across different property sizes.',
        priceM2PerRoom: 'Explore how price per square meter varies with room count to identify the most efficient property configurations.',
        pricePerRoom: 'Analyze how property prices vary based on the number of rooms to understand pricing patterns by property size.',
        rentEvolution: 'Monitor rental price trends over time to understand the dynamics of the rental market.',
        rentGeography: 'Visualize rental prices across different areas to identify premium and affordable rental locations.',
        rentM2Evolution: 'Track rental prices per square meter to analyze value trends in the rental market.',
        rentM2PerRoom: 'Explore how rent per square meter varies with room count to identify the most efficient rental configurations.',
      },
      footer: {
        dataSources: 'Homegate, ImmoScout24, Newhome, Acheter-Louer',
        dataSourcesLabel: 'Data Sources:',
        description: 'This statistical report is generated based on real-time data collected from Swiss real estate portals. The data is continuously updated and analyzed to provide accurate market insights.',
        title: 'About This Report',
      },
      interface: {
        chartPlaceholder: 'Chart placeholder for',
        downloadFullReport: 'Download Full Report',
        hideSection: 'Hide section',
        showSection: 'Show section',
        sources: 'Sources:',
        sourcesList: 'Swiss real estate portals • Popety.io',
      },
      kpi: {
        keyInsights: 'Key Insights',
        keyMetrics: 'Key Metrics',
        oneYearGrowth: '1 Year Growth',
      },
      periods: {
        allAvailable: 'All available data',
        fullHistory: 'Full history',
        last12Months: 'Last 12 months',
        since2022: 'Since 2022',
        sinceJanuary2022: 'Since January 2022',
      },
      sections: {
        agencyAnalysis: 'Agency Analysis',
        cityAnalysis: 'City Analysis',
        marketShare: 'Market Share',
        newVsResale: 'New Construction vs Resale',
        portalAnalysis: 'Portal Analysis',
        priceDistribution: 'Price Distribution',
        priceEvolution: 'Price Evolution',
        priceGeography: 'Price Geography',
        priceM2Evolution: 'Price/m² Evolution',
        priceM2PerRoom: 'Price/m² per Room',
        pricePerRoom: 'Price per Room',
        rentDistribution: 'Rent Distribution',
        rentEvolution: 'Rent Evolution',
        rentGeography: 'Rent Geography',
        rentM2Evolution: 'Rent/m² Evolution',
        rentM2PerRoom: 'Rent/m² per Room',
      },
      table: {
        city: 'City',
        listings: 'Listings',
        medianChfM2: 'Median CHF/m²',
        percentile25: '25th Percentile',
        percentile75: '75th Percentile',
        stdDeviation: 'Std Deviation',
      },
    },
    statusOptions: {
      all: 'All',
    },
    tabs: {
      aroundPlot: 'Listings around the plot',
      saved: 'Saved Listings',
    },
    views: {
      list: 'List',
      map: 'Map',
      stats: 'Stats',
    },
  },
  market: {
    common: {
      currency: {
        chf: 'CHF',
        chfPerM2: 'CHF/m²',
      },
      errors: {
        loadingData: 'Error loading data. Please try again later.',
      },
      filters: {
        advancedFilters: 'Advanced Filters',
        city: 'Municipality',
        district: 'District',
        hideFilters: 'Hide Filters',
        location: 'Location',
        postalCode: 'Postal Code',
        propertyType: 'Property Type',
      },
      month: 'month',
      na: 'N/A',
      placeholder: {
        chartPlaceholder: 'Chart placeholder for {{section}}',
      },
      propertyTypes: {
        apartment: 'Apartment',
        commercial: 'Commercial',
        house: 'House',
        houseApartment: 'House & Apt',
        plot: 'Plot',
      },
      year: 'year',
    },
    distribution: {
      charts: {
        area: 'Area Distribution',
        constructionYear: 'Construction Year',
        price: 'Price Distribution',
        priceM2: 'Price/m² Distribution',
        rent: 'Rent Distribution',
        rentM2: 'Rent/m² Distribution',
        rooms: 'Rooms Distribution',
        timeOnMarket: 'Time on Market',
      },
      empty: {
        description: 'There is no distribution data available for the current selection.',
        title: 'No Data Available',
      },
      insights: {
        areaRange: 'Area Overview',
        areaRangeDesc: 'Average area is {{avg}} m² with a median of {{median}} m².',
        mostCommonRooms: 'Most Common Configuration',
        mostCommonRoomsDesc: 'Properties with {{rooms}} rooms represent {{percentage}}% of listings in this area.',
        priceRange: 'Price Overview',
        priceRangeDesc: 'Average price is {{avg}} CHF with a median of {{median}} CHF.',
        rentRange: 'Rent Overview',
      },
      kpis: {
        medianArea: 'Median Area',
        medianPrice: 'Median Price',
        medianRent: 'Median Rent',
        medianRooms: 'Median Rooms',
        totalListings: 'Total Listings',
      },
      states: {
        loading: 'Loading distribution data...',
      },
      stats: {
        avg: 'Avg',
        median: 'Median',
        total: 'Total',
      },
      units: {
        days: 'days',
        rooms: 'rooms',
        year: 'year',
      },
    },
    distributionView: {
      combined: 'Combined',
      listings: 'listings',
      perMonth: '/month',
      perYear: '/year',
      separate: 'By property type',
    },
    purchase: {
      header: {
        subtitle: 'Analyze market trends and patterns for property purchases in the selected area',
        title: 'Purchase Market Analysis',
      },
      sections: {
        distribution: {
          description: 'Explore market composition across rooms, price ranges, areas, construction years, and time on market to understand local market characteristics.',
          title: 'Market Distribution',
        },
        newVsResale: {
          description: 'Compare pricing trends and market dynamics between newly constructed properties and resale properties.',
          title: 'New Construction vs Resale',
        },
        priceEvolution: {
          description: 'Track the evolution of property prices over time to identify market trends and patterns in the real estate market.',
          title: 'Price Evolution',
        },
        priceM2Evolution: {
          description: 'Analyze the evolution of property prices per square meter to understand value trends across different property sizes.',
          title: 'Price/m² Evolution',
        },
        priceM2PerRoom: {
          description: 'Explore how price per square meter varies with room count to identify the most efficient property configurations.',
          title: 'Price/m² per Room',
        },
        pricePerRoom: {
          description: 'Analyze how property prices vary based on the number of rooms to understand pricing patterns by property size.',
          title: 'Price per Room',
        },
      },
    },
    readOnly: {
      purchaseDescription: 'Purchase market analysis with price evolution, property comparisons, and market trends is available in the full application. This public view shows a summary of the property estimate.',
      rentalDescription: 'Rental market analysis with price evolution, property comparisons, and market trends is available in the full application. This public view shows a summary of the property estimate.',
      title: 'Market Analysis',
    },
    rental: {
      header: {
        subtitle: 'Analyze rental market trends and patterns for properties in the selected area',
        title: 'Rental Market Analysis',
      },
      sections: {
        availability: {
          description: 'Monitor rental market availability, vacancy rates, and turnover patterns to understand supply and demand dynamics.',
          title: 'Rental Availability & Turnover',
        },
        distribution: {
          description: 'Explore rental market composition across rooms, rent ranges, areas, construction years, and time on market to understand local market characteristics.',
          title: 'Market Distribution',
        },
        priceEvolution: {
          description: 'Track the evolution of rental prices over time to identify market trends and patterns in the rental real estate market.',
          title: 'Rental Price Evolution',
        },
        priceM2Evolution: {
          description: 'Analyze the evolution of rental prices per square meter to understand value trends across different property sizes.',
          title: 'Rental Price/m² Evolution',
        },
        priceM2PerRoom: {
          description: 'Explore how rental price per square meter varies with room count to identify the most efficient rental configurations.',
          title: 'Rental Price/m² per Room',
        },
        pricePerRoom: {
          description: 'Analyze how rental prices vary based on the number of rooms to understand pricing patterns by property size.',
          title: 'Rental Price per Room',
        },
      },
      summary: {
        marketVolume: {
          subtitle: 'Active listings (12 months)',
          title: 'Market Volume',
        },
        medianRent: {
          subtitle: 'Per {{period}}',
          title: 'Median Rent',
        },
        medianRentM2: {
          subtitle: 'Per {{period}}',
          title: 'Median Rent/m²',
        },
      },
    },
    shared: {
      average: 'Average',
      avgPrice: 'Avg Price',
      keyInsights: 'Key Insights',
      listings: 'listings',
      marketShare: 'Market Share',
      median: 'Median',
      noData: 'No Data Available',
      totalListings: 'Total Listings',
    },
    summary: {
      marketVolume: {
        subtitle: 'Active listings (12 months)',
        title: 'Market Volume',
      },
      medianPrice: {
        subtitle: 'All property types',
        title: 'Median Price',
      },
      medianPriceM2: {
        subtitle: 'All property types',
        title: 'Median Price/m²',
      },
    },
  },
  noise: {
    dataSources: {
      federal: 'Swiss Federal Office for the Environment',
      geneva: 'État de Genève - DALE',
      sitg: 'SITG',
    },
    descriptions: {
      day: 'Maximum noise level during the day',
      night: 'Maximum noise level at night',
    },
    periods: {
      day: 'DAY',
      night: 'NIGHT',
    },
    scale: {
      examples: {
        breathing: 'Breathing, rustling leaves',
        conversation: 'Normal conversation',
        lawnmower: 'Lawnmower, ambulance',
        sleepInterference: 'Sleep interference begins',
        traffic: 'Vacuum, city traffic',
        whispering: 'Whispering, refrigerator',
      },
      indicators: {
        day: 'Day: {{value}} dB',
        night: 'Night: {{value}} dB',
      },
      levels: {
        harmful: 'Harmful',
        loud: 'Loud',
        moderate: 'Moderate',
        quiet: 'Quiet',
        silent: 'Silent',
        veryLoud: 'Very loud',
      },
      ranges: {
        '0-20': '0-20 dB',
        '30-40': '30-40 dB',
        '40+': '40+ dB',
        '50-60': '50-60 dB',
        '70-80': '70-80 dB',
        '90-100': '90-100 dB',
      },
      title: 'Decibel Scale Reference',
    },
    sources: {
      railway: 'Railway',
      roadTraffic: 'Road traffic',
    },
    states: {
      error: 'Error loading noise data',
      errorDescription: 'Unable to load noise analysis data. Please try again later.',
      loading: 'Loading noise data...',
      noData: 'No noise data available',
      noDataDescription: 'Noise analysis data is not available for this location.',
    },
    subtitle: 'Noise and nuisance levels estimated at this address',
    title: 'Noise Analysis',
    unit: 'dB',
  },
  property: {
    analysis_types: {
      building_analysis: {
        description: 'Comprehensive building analysis including units, market data, amenities, and environmental factors.',
        title: 'Building Analysis',
      },
      land_analysis: {
        description: 'Detailed land analysis with zoning rules, development potential, and market insights.',
        title: 'Land Analysis',
      },
      property_estimate: {
        description: 'Property valuation and market estimate with comparable analysis.',
        title: 'Property Estimate',
      },
    },
    available_analysis: 'Available Analysis',
    available_sections: 'Available sections:',
    loading: 'Loading property data...',
    loading_failed: 'Failed to load property data',
    title: 'Property Overview',
    view_analysis: 'View Analysis',
  },
  restrictions: {
    affected: 'Affected',
    affectedTypes: 'Affected Types',
    categories: {
      affecting: 'Restrictions Affecting the Plot',
      notAffecting: 'Restrictions Not Affecting the Plot',
    },
    error: 'Failed to load region restrictions',
    heritage: {
      buildingUnderProtection: 'Building under heritage protection',
      heritageProtection: 'Heritage Protection',
      protectedBuilding: 'Protected Building',
      protectedObjects: 'Protected Objects',
    },
    instances: {
      instanceNumber: 'Instance {{number}}',
      multiple: '{{count}} instances',
      single: '1 instance',
    },
    labels: {
      additionalInformation: 'Additional Information',
      additionalText: 'Additional Information',
      affectedArea: 'Affected Area',
      area: 'Area',
      class: 'Class',
      classification: 'Classification',
      content: 'Content',
      heritageDatabase: 'Heritage Database',
      integrationDate: 'Integration Date',
      registryNumber: 'Registry Number',
      servitudeClass: 'Servitude Type',
      servitudeRegistryNumber: 'Servitude Registry No.',
      status: 'Status',
      type: 'Type',
      validity: 'Validity',
      viewDocumentation: 'View Documentation',
      viewInSipatrimoine: 'View in SIPATRIMOINE',
    },
    legalNotice: {
      disclaimer: 'The information above is not exhaustive. Please consult the RDPPF and contact the planning department of the commune concerned for further information.',
      rdppfOfficialReport: 'RDPPF Official Report',
      sources: 'Sources:',
      sourcesList: 'SITG • RDPPF • SIPATRIMOINE • État de Genève - DALE',
    },
    loading: 'Loading restrictions data...',
    messages: {
      coverage: 'Coverage: {{percent}}%',
      notApplicable: 'This restriction does not apply to the current parcel.',
    },
    metrics: {
      affectingPlot: 'Affecting Plot',
      notAffecting: 'Not Affecting',
      typesAnalyzed: 'Types Analyzed',
    },
    noData: 'No data available',
    notAffected: 'Not Affected',
    notAvailable: 'Not Available',
    restrictionTypes: {
      archaeologicalZone: 'Archaeological Protection Zone',
      buildingRight: 'Distinct and Permanent Right (DDP)',
      builtSitesProtectedZone: 'Built Heritage Protection Zone',
      dangerZone: 'Danger Zone',
      forestLimitZone: 'Forest Limit Zone',
      forestZone: 'Forest Zone',
      heritageInventory: 'Heritage Inventory',
      mandatoryPlanningZone: 'Mandatory Planning Zone (ZPP)',
      natureProtectionZone: 'Nature Protection Zone',
      noiseSensibilityLevel: 'Noise Sensitivity Level',
      noiseSensitivityLevel: 'Noise Sensitivity Level',
      noMaxCosZone: 'Zone without maximum BCC',
      notYetDefinedSpecialZone: 'Special Zone Not Yet Defined',
      otherZone: 'Other Zone',
      pollutedZone: 'Polluted Zone',
      protectedBuilding: 'Protected Building',
      protectedObjects: 'Protected Objects',
      protectionZone: 'Protection Zone',
      reservedZone: 'Reserved Zone',
      servitude: 'Easement',
      underwaterProtectedZone: 'Underwater Protected Zone',
      watercourseLimitZone: 'Watercourse Limit Zone',
    },
    status: {
      active: 'Active',
      clear: 'Clear',
      inactive: 'Inactive',
      protected: 'Protected',
      valid: 'Valid',
    },
    subtitle: 'Legal and development restrictions analysis for {{address}}',
    title: 'Restrictions (RDPPF)',
  },
  sunlight: {
    common: {
      blueHour: 'Blue Hour',
      daylight: 'daylight',
      goldenHour: 'Golden Hour',
      hours: 'hours',
      location: 'Location',
      ofDaylight: 'of daylight',
      solarNoon: 'Solar Noon',
    },
    dataSources: {
      label: 'Sources:',
      list: 'MétéoSuisse • Office fédéral de météorologie • Solar calculation algorithms',
    },
    header: {
      subtitle: 'Comprehensive solar exposure data for {{latitude}}°, {{longitude}}°',
      title: 'Sunlight Study',
    },
    legalNotice: {
      text: 'These are theoretical sunlight hours based on astronomical calculations. Actual sunlight exposure may vary significantly due to local topography, surrounding buildings, trees, and other obstructions. We recommend checking the interactive map for detailed shadow analysis and real-world sunlight conditions throughout the day and year.',
    },
    overview: {
      annualAverage: {
        longestDay: 'Longest Day',
        shortestDay: 'Shortest Day',
        subtitle: 'average daylight per day',
        title: 'Annual Average',
        totalAnnual: 'Total Annual',
      },
      lightQuality: {
        evening: {
          title: 'Evening Light Quality',
        },
        morning: {
          title: 'Morning Light Quality',
        },
      },
      solarEnergy: {
        efficiencyPotential: 'efficiency potential',
        optimalAngle: 'Optimal Angle',
        peakHoursDay: 'Peak Hours/Day',
        title: 'Solar Energy',
        yearlyAverage: 'Yearly Average',
      },
      todaySunlight: {
        title: "Today's Sunlight",
      },
    },
    seasonal: {
      average: {
        title: 'Annual Average',
      },
      duration: 'Duration',
      summer: {
        title: 'Summer Solstice',
      },
      sunrise: 'Sunrise',
      sunset: 'Sunset',
      title: 'Seasonal Daylight Comparison',
      winter: {
        title: 'Winter Solstice',
      },
    },
    seasons: {
      analysis: {
        daylightDuration: 'Daylight Duration',
        energyEfficiency: 'Energy Efficiency',
        high: 'High',
        limited: 'Limited',
        low: 'Low',
        medium: 'Medium',
        moderate: 'Moderate',
        optimal: 'Optimal',
        propertyImpact: 'Property Impact',
        sunriseTime: 'Sunrise Time',
        sunsetTime: 'Sunset Time',
        title: '{{season}} Analysis',
        vsAnnualAverage: 'vs Annual Average',
      },
      autumn: {
        equinox: 'Autumn Equinox',
        name: 'Autumn',
      },
      spring: {
        equinox: 'Spring Equinox',
        name: 'Spring',
      },
      summer: {
        name: 'Summer',
        solstice: 'Summer Solstice',
      },
      winter: {
        name: 'Winter',
        solstice: 'Winter Solstice',
      },
    },
    section: {
      subtitle: 'Estimated sunshine hours and daylight analysis for this location',
      title: 'Sunlight Study',
    },
    solar: {
      energySavings: {
        annualProduction: {
          label: 'Annual Production',
          tooltip: {
            calculation: 'Peak Sun Hours × 5 kWp × 20% panel efficiency',
            importance: 'Critical for calculating return on investment and determining optimal system size for your energy needs',
            limitations: 'Theoretical calculation only. Does not consider actual roof space availability, panel orientation, shading from nearby structures, snow coverage, panel degradation over time, or inverter/battery system losses.',
            shortDescription: 'Estimated yearly energy production per kWp of installed solar capacity',
            source: 'Solar irradiance calculations based on astronomical data',
            title: 'Annual Production',
          },
        },
        co2Reduction: {
          label: 'CO2 Reduction',
          tooltip: {
            calculation: 'Annual Production × 0.4 kg CO2/kWh ÷ 1000 (based on average Swiss grid emission factors)',
            importance: 'Quantifies the environmental benefit of solar installation for carbon footprint reduction goals',
            limitations: 'Based on average Swiss grid emissions. Actual CO2 savings depend on your current energy source, time-of-use consumption patterns, and grid composition changes over time.',
            shortDescription: 'Estimated annual carbon dioxide emissions reduction from solar energy',
            source: 'Swiss grid emission factors - Federal Office for the Environment FOEN',
            title: 'CO2 Reduction',
          },
          unit: 'tons/year',
        },
        estimated: 'Estimated',
        propertyValue: {
          label: 'Property Value Impact',
          tooltip: {
            calculation: 'Based on Swiss real estate market studies showing typical 3-5% value increase',
            categories: {
              buyerPreferences: {
                description: 'Environmental consciousness and energy efficiency priorities',
                label: 'Buyer preferences',
              },
              locationFactors: {
                description: 'Regional market preferences and energy costs',
                label: 'Location factors',
              },
              marketTrends: {
                description: 'Current real estate and energy market conditions',
                label: 'Market trends',
              },
              systemCondition: {
                description: 'Age, performance, and maintenance status',
                label: 'System condition',
              },
            },
            importance: 'Potential additional financial benefit beyond energy savings',
            limitations: 'Market study averages only. Actual property value impact varies significantly and is not guaranteed. Professional real estate appraisal recommended for accurate assessment.',
            shortDescription: 'Estimated increase in property value from solar installation',
            source: 'Swiss real estate market studies',
            title: 'Property Value Impact',
          },
          value: '+3-5%',
        },
        roiPeriod: {
          label: 'ROI Period',
          tooltip: {
            calculation: 'Based on Swiss market averages for CHF 15,000-25,000 residential systems',
            categories: {
              electricityPrices: {
                description: 'Current and projected energy rates',
                label: 'Electricity prices',
              },
              feedInTariffs: {
                description: 'Payment for excess energy sold to grid',
                label: 'Feed-in tariffs',
              },
              installationCosts: {
                description: 'System price, permits, and setup',
                label: 'Installation costs',
              },
              maintenanceCosts: {
                description: 'Cleaning, repairs, and component replacement',
                label: 'Maintenance costs',
              },
              subsidies: {
                description: 'Government and local incentives',
                label: 'Subsidies',
              },
            },
            importance: 'Critical financial metric for investment decision making',
            limitations: 'Generic market estimate. Actual ROI requires professional financial assessment considering specific system configuration, local incentives, and individual energy consumption patterns.',
            shortDescription: 'Estimated time to recover initial solar system investment',
            source: 'Swiss solar market financial studies',
            title: 'ROI Period',
          },
          value: '7-10 years',
        },
        selfSufficiency: {
          label: 'Self-Sufficiency',
          tooltip: {
            calculation: 'Generic residential estimate based on typical installation patterns',
            categories: {
              batteryCapacity: {
                description: 'Energy storage for nighttime and cloudy days',
                label: 'Battery capacity',
              },
              consumptionPatterns: {
                description: 'Daily and seasonal energy usage habits',
                label: 'Consumption patterns',
              },
              electricVehicle: {
                description: 'Additional energy requirements',
                label: 'Electric vehicle charging',
              },
              heatPumpUsage: {
                description: 'High winter electricity demand',
                label: 'Heat pump usage',
              },
              seasonalVariations: {
                description: 'Summer excess vs winter deficit',
                label: 'Seasonal variations',
              },
            },
            importance: 'Key metric for energy independence and grid reliance reduction',
            limitations: 'Generic estimate only. Actual self-sufficiency varies significantly based on individual circumstances and requires detailed consumption analysis.',
            shortDescription: 'Estimated percentage of energy needs met by solar production',
            source: 'Swiss solar industry statistical averages',
            title: 'Self-Sufficiency',
          },
          value: '60-80%',
        },
        title: 'Energy Savings Potential',
      },
      monthlyGeneration: {
        perDay: 'h/day',
        quarterAverage: '{{quarter}} Average',
        title: 'Monthly Solar Generation Potential',
      },
      panelInstallation: {
        efficiencyRating: {
          label: 'Efficiency Rating',
          tooltip: {
            calculation: '(Average Peak Hours ÷ 6.5h) × 100 - where 6.5h represents optimal equatorial conditions',
            importance: 'Indicates how suitable your location is for solar energy compared to ideal conditions',
            limitations: 'Based purely on latitude calculations. Does not account for real cloud cover, weather patterns, air quality, or local climate conditions that significantly impact actual efficiency.',
            shortDescription: 'Solar efficiency rating based on geographic location (100% = equatorial optimum)',
            source: 'Solar irradiance calculations based on astronomical data',
            title: 'Efficiency Rating',
          },
        },
        highPotential: 'High Potential',
        monthlyAverage: {
          label: 'Monthly Average',
          tooltip: {
            calculation: 'Based on astronomical calculations using sun position data throughout the year',
            importance: 'Provides insight into seasonal solar energy production variations for planning purposes',
            limitations: 'Theoretical calculation only. Does not consider local climate patterns, actual weather conditions, or site-specific shading from buildings, trees, or terrain.',
            shortDescription: 'Average daily peak sun hours calculated over a typical month',
            source: 'Solar irradiance calculations based on astronomical data',
            title: 'Monthly Average',
          },
        },
        optimalPanelAngle: {
          label: 'Optimal Panel Angle',
          tooltip: {
            calculation: 'Formula: Latitude ({{latitude}}°) × 0.9 + 29° for year-round performance',
            importance: 'Proper panel angle maximizes energy production by optimizing sun exposure throughout the year',
            limitations: 'Does not consider local topography, actual roof orientation, structural limitations, or seasonal adjustment options. Professional site assessment recommended for optimal results.',
            shortDescription: 'The theoretical ideal tilt angle for solar panels based on your location',
            source: 'Astronomical calculations based on geographical coordinates',
            title: 'Optimal Panel Angle',
          },
        },
        peakSunHours: {
          label: 'Peak Sun Hours/Day',
          tooltip: {
            calculation: 'Theoretical clear-sky peak sun hours at 1000 W/m² intensity, calculated from latitude and seasonal sun angles',
            importance: 'Peak sun hours directly correlate to solar energy production potential and help estimate system performance',
            limitations: 'Based on theoretical clear-sky conditions only. Does not account for cloud cover, fog, air pollution, shadows from buildings or trees, or actual local weather patterns.',
            shortDescription: 'Daily hours of direct sunlight at optimal solar panel efficiency',
            source: 'Solar irradiance calculations based on astronomical data',
            title: 'Peak Sun Hours/Day',
          },
        },
        title: 'Solar Panel Installation',
        yearlyTotal: {
          label: 'Yearly Total',
          tooltip: {
            calculation: 'Monthly Average × 365 days',
            importance: 'Helps estimate annual solar energy production potential for system sizing and cost-benefit analysis',
            limitations: 'This represents the theoretical upper limit under perfect clear-sky conditions. Real-world values are typically 30-50% lower due to weather patterns, seasonal variations, and atmospheric conditions.',
            shortDescription: 'Total peak sun hours expected throughout the entire year',
            source: 'Solar irradiance calculations based on astronomical data',
            title: 'Yearly Total',
          },
        },
      },
    },
    states: {
      error: 'Error loading sunlight data',
      errorDescription: 'Unable to load sunlight analysis data. Please try again later.',
      loading: 'Loading sunlight data...',
      noData: 'No sunlight data available',
      noDataDescription: 'Sunlight analysis data is not available for this location.',
    },
    sunPath: {
      dawn: 'Dawn',
      dusk: 'Dusk',
      noon: 'Noon',
    },
    tabs: {
      overview: 'Overview',
      seasonal: 'Seasonal',
      solar: 'Solar Potential',
      yearly: 'Yearly Analysis',
    },
    today: {
      badge: 'Near Summer Peak',
      dayDuration: 'Day Duration',
      sunrise: 'Sunrise',
      sunset: 'Sunset',
      title: 'Today - {{date}}',
    },
    yearly: {
      bestMonths: {
        averagePeak: 'Average Peak',
        excellent: 'Excellent',
        peakPeriod: 'May - August',
        peakSeason: 'Peak Season',
        qualityRating: 'Quality Rating',
        title: 'Best Months',
      },
      challengingMonths: {
        averageLow: 'Average Low',
        limited: 'Limited',
        lowPeriod: 'Nov - February',
        lowSeason: 'Low Season',
        title: 'Challenging Months',
      },
      chartTitle: 'Daylight Hours Throughout the Year',
      daylightHours: 'Daylight Hours',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      variation: {
        leastSunlight: 'Least Sunlight',
        maxVariation: 'Max Variation',
        mostSunlight: 'Most Sunlight',
        title: 'Variation Analysis',
      },
    },
  },
  taxes: {
    calculatorLink: {
      description: 'Use the official Swiss tax calculator to estimate taxes based on a specific situation.',
      title: 'Calculate a personalized tax',
    },
    charts: {
      noData: 'No data available',
      taxAmountEvolution: {
        axis: {
          amount: 'Tax Amount (CHF)',
        },
        subtitle: 'Historical tax amounts in CHF by profile',
        summary: {
          title: 'Changes ({{startYear}}-{{endYear}})',
        },
        title: 'Annual Tax Amount Evolution',
      },
      taxBurdenEvolution: {
        axis: {
          burden: 'Tax Burden (%)',
        },
        subtitle: 'Historical tax burden percentage by profile',
        summary: {
          avgChange: 'Average change',
          decreasing: 'Decreasing - taxes are going down',
          increasing: 'Increasing - taxes are going up',
          stable: 'Stable - taxes remain relatively constant',
          title: 'Trend Analysis ({{startYear}}-{{endYear}})',
          trend: 'Trend',
        },
        title: 'Tax Burden Evolution',
      },
      taxRateEvolution: {
        subtitle: 'Municipal and cantonal rate coefficients over time',
        summary: {
          title: 'Rate Changes ({{startYear}}-{{endYear}})',
        },
        title: 'Tax Rate Evolution',
      },
    },
    common: {
      downloadChart: 'Download chart',
    },
    comparison: {
      aboveCantonAvg: 'above canton average',
      aboveNationalAvg: 'above national average',
      belowCantonAvg: 'below canton average',
      belowNationalAvg: 'below national average',
      canton: 'Canton',
      profileFamily: 'Tax Burden (Family - {{income}} income)',
      profileMarried: 'Tax Burden (Married - {{income}} income)',
      profileSingle: 'Tax Burden (Single - {{income}} income)',
      switzerland: 'Switzerland',
      thisLocation: 'This location',
      title: 'Geographic Comparison',
    },
    efficiency: {
      high: 'High',
      low: 'Low',
      medium: 'Medium',
    },
    filters: {
      location: 'Location',
      year: 'Year',
    },
    insights: {
      highEfficiency: 'This location offers lower taxes than both the canton and national averages, making it an attractive choice for tax-conscious buyers.',
      lowEfficiency: 'Tax burden at this location is above both the canton and national averages. Consider this factor when evaluating the total cost of ownership.',
      mediumEfficiency: 'Tax levels at this location show mixed results when comparing canton and national averages. Taxes are favorable at one level but not both.',
      title: 'Tax Efficiency Rating',
    },
    metrics: {
      annualTax: {
        subtitle: 'Average total taxes',
        title: 'Annual Tax',
      },
      taxBurden: {
        subtitle: 'Average across profiles',
        title: 'Tax Burden',
      },
      taxFreedomDay: {
        subtitle: 'Average date',
        title: 'Tax Freedom Day',
      },
    },
    profileDetails: {
      annualTax: 'Annual Tax',
      profile: 'Profile',
      taxBurden: 'Tax Burden',
      taxFreedomDay: 'Tax Freedom Day',
      title: 'Profile Details',
    },
    profiles: {
      all: 'All Profiles',
      family: 'Family',
      married: 'Married',
      single: 'Single',
    },
    states: {
      error: 'Error loading tax data: {{error}}',
      fetchError: 'Failed to load tax data',
      loading: 'Loading tax data...',
      noData: 'Tax data is not available for this location.',
      noHistoricalData: 'No historical tax data available',
    },
    subtitle: 'Tax burden analysis for this location',
    tabs: {
      overview: 'Overview',
      trends: 'Historical Trends',
    },
    taxRates: {
      canton: 'Canton',
      cantonRate: 'Canton rate',
      churchChrist: 'Christ Catholic',
      churchNote: 'Church taxes (optional)',
      churchProtestant: 'Protestant',
      churchRoman: 'Roman Catholic',
      city: 'City',
      cityRank: 'City rank',
      cityRate: 'City rate',
      cityRateComparison: 'City rate among {{total}} cities in {{canton}}',
      inCanton: 'in {{canton}}',
      ofCities: 'of {{total}} cities',
      rateAxis: 'Rate (%)',
      subtitle: 'Applied multipliers on the base cantonal tax',
      title: 'Tax Rate Coefficients',
    },
    title: 'Taxes',
    tooltips: {
      annualTax: {
        calculation: "Sum of direct federal tax + cantonal income tax + municipal income tax. Profiles: Single = CHF 84'000 (Swiss median salary), Married = couple without children at CHF 168'000, Family = married couple with 2 children at CHF 168'000.",
        importance: 'Absolute CHF amount helps clients understand real cost differences between locations. A CHF 5,000 annual difference represents significant savings over property ownership duration.',
        limitations: "Does not include wealth tax, property taxes, or other indirect taxes. Based on standardized profiles (Single: CHF 84'000, Married/Family: CHF 168'000) without individual deductions.",
        shortDescription: 'Total taxes paid per year including federal, cantonal, and municipal taxes',
        source: 'Federal Tax Administration (FTA) - Annual tax burden statistics',
        title: 'Annual Tax',
      },
      taxBurden: {
        calculation: "Total annual tax / Gross annual income × 100. Profiles: Single = CHF 84'000 (Swiss median salary), Married = couple without children at CHF 168'000, Family = married couple with 2 children at CHF 168'000.",
        calculation_family: "Total annual tax / Gross annual income × 100. Based on a married couple with 2 children with a combined gross income of CHF 168'000.",
        calculation_married: "Total annual tax / Gross annual income × 100. Based on a married couple without children with a combined gross income of CHF 168'000.",
        calculation_single: "Total annual tax / Gross annual income × 100. Based on a single person with a gross income of CHF 84'000 (Swiss median salary).",
        importance: 'Direct impact on purchasing power and disposable income. Lower tax burden means more money available for mortgage payments and living expenses. Key factor for real estate investment decisions.',
        limitations: "Based on standardized income profiles (Single: CHF 84'000, Married/Family: CHF 168'000). Actual tax burden may vary based on individual circumstances, deductions, and wealth.",
        limitations_family: "Based on a standardized combined income of CHF 168'000 for a couple with 2 children. Actual tax burden may vary based on individual circumstances, deductions, and wealth.",
        limitations_married: "Based on a standardized combined income of CHF 168'000 for a couple without children. Actual tax burden may vary based on individual circumstances, deductions, and wealth.",
        limitations_single: "Based on a standardized income of CHF 84'000. Actual tax burden may vary based on individual circumstances, deductions, and wealth.",
        shortDescription: 'Percentage of gross income paid in taxes (federal, cantonal, municipal)',
        source: 'Federal Tax Administration (FTA) - Annual tax burden statistics',
        title: 'Tax Burden',
      },
      taxFreedomDay: {
        calculation: 'Tax burden × 365 days. If tax burden is 18.9%, Tax Freedom Day = Day 69 (March 10). Earlier date = lower taxes.',
        importance: "Intuitive way to communicate tax burden to clients. 'You work until March 10 to pay taxes' is more tangible than '18.9% tax burden'. Widely used metric in Switzerland.",
        limitations: 'Symbolic representation. Actual tax payments are spread throughout the year. Does not account for mandatory social contributions.',
        shortDescription: 'The day of the year when you stop working to pay taxes and start earning for yourself',
        source: 'Federal Tax Administration (FTA) - Tax Freedom Day publication',
        title: 'Tax Freedom Day',
      },
    },
  },
  transactions: {
    actions: {
      removeFromSaved: 'Remove from saved',
      saveTransaction: 'Save transaction',
    },
    aiFilter: {
      description: "Describe the transactions you're looking for, and I'll help you find them.",
      examplePrompts: {
        '0': 'Buy transaction these last 12 months over 5 million CHF',
        '1': 'Transactions with only one buyer',
      },
      placeholder: 'Show me buy transaction these last month',
      title: 'Transaction Filter Assistant',
    },
    columns: {
      address: 'Address',
      area: 'Area',
      buyers: 'Buyers',
      buyersCount: 'Buyers #',
      date: 'Date',
      ownershipType: 'Ownership Type',
      parcel: 'Parcel {{number}}',
      previousTransaction: 'Previous Transaction',
      price: 'Price',
      pricePerM2: 'Price/m²',
      reason: 'Reason',
      sellers: 'Sellers',
      sellersCount: 'Sellers #',
      transactionId: 'Transaction ID',
    },
    dataSources: {
      label: 'Sources:',
      list: 'Registre foncier • État de Genève • Extrait du registre des mutations',
    },
    detail: {
      backToList: 'Back to the list',
      description: 'Description',
      details: 'Details',
      landInfo: 'Information About the Land',
      multipleLotsWarning: 'This transaction involves several plots of land',
      parcel: 'Parcel',
      propertiesInvolved: 'Properties Involved',
      transaction: 'Transaction',
      transactionInfo: 'Transaction Information',
    },
    detailPanel: {
      initializingMap: 'Initializing map...',
      labels: {
        buyers: 'Buyers',
        capacity: 'Capacity',
        floors: 'Floors',
        land: 'Land',
        landArea: 'Land Area',
        language: 'Language',
        location: 'Location',
        officialId: 'Official ID',
        participants: 'Participants',
        previous: 'Previous',
        properties: 'Properties',
        property: 'Property {{index}}',
        publicationDate: 'Publication Date',
        region: 'Region',
        sellers: 'Sellers',
        share: 'Share',
        stepPrice: 'Step Price',
        surface: 'Surface',
        totalPrice: 'Total Price',
        totalSurface: 'Total Surface',
        transactionDate: 'Transaction Date',
        transactionId: 'Transaction ID',
        units: 'Units',
        unitsCount: 'Units ({{count}})',
      },
      legalTypes: {
        BF: 'B-F - Land parcel',
        COP: 'COP - Co-ownership',
        DDP: 'DDP - Permanent right',
        DP: 'DP - Public domain',
        PPE: 'PPE - Condominium',
      },
      loading: 'Loading transaction details...',
      loadingMap: 'Loading map...',
      locationsNotAvailable: 'Exact property locations not available',
      mapPopup: {
        land: 'Land: {{area}} m²',
        propertiesAtLocation: '{{count}} properties at this location',
        propertyNumber: 'Property {{index}}',
        surface: 'Surface: {{area}} m²',
      },
      mapTokenNotConfigured: 'Map token not configured',
      notFound: 'Transaction not found',
      participantTypes: {
        company: 'Company',
        estate: 'Estate',
        individual: 'Individual',
        nonProfit: 'Non-Profit',
        other: 'Other',
        publicBody: 'Public Body',
        unknown: 'Unknown',
      },
      removeFromSaved: 'Remove from saved',
      saveTransaction: 'Save transaction',
      sections: {
        participants: 'Participants',
        properties: 'Properties',
        propertiesCount: 'Properties ({{count}})',
        rawTransactionData: 'Raw Transaction Data',
        transactionDescription: 'Transaction Description',
        transactionDetails: 'Transaction Details',
      },
      title: 'Details',
      transactionNumber: 'Transaction #{{id}}',
      type: 'Transaction',
      unitTypes: {
        appartement: 'Apartment',
        balcon: 'Balcony',
        box: 'Storage box',
        cave: 'Cellar',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Private garage',
        singleFamily: 'Single-family home',
      },
    },
    empty: {
      message: 'Try adjusting your filters to see more results',
      title: 'No transactions found',
    },
    errors: {
      loadFailed: 'Failed to load transactions',
      tryAgain: 'Please try again later',
    },
    fields: {
      assignmentArea: 'Assignment area',
      buildingClassification: 'Building Type',
      buyers: 'Buyers',
      landInfo: 'Land information',
      livingArea: 'Living area',
      numberOfBuyers: 'Number of buyers',
      numberOfSellers: 'Number of sellers',
      numberOfUnits: 'Number of units',
      parcelNumber: 'Parcel number',
      parties: 'Parties',
      previousTransaction: 'Prev. transaction',
      price: 'Price',
      pricePerM2: 'Price per m²',
      propertyType: 'Property Type',
      publishedOn: 'Published on',
      reason: 'Reason',
      sellers: 'Sellers',
      transactionDate: 'Transaction date',
      transactionOn: 'Transaction on',
    },
    filter: {
      additionalFilters: 'Additional Filters',
      advancedFilters: 'Advanced filters',
      allLocations: 'All locations',
      clearAll: 'Clear all',
      hideFilters: 'Hide filters',
      landArea: 'Land Area (m²)',
      legalTypeBF: 'B-F',
      legalTypeCOP: 'COP',
      legalTypeDDP: 'DDP',
      legalTypeDP: 'DP',
      legalTypeOther: 'Other',
      legalTypePPE: 'PPE',
      numberOfBuyers: 'Number of Buyers',
      numberOfSellers: 'Number of Sellers',
      others: 'Others',
      participantAssociation: 'Association',
      participantCompany: 'Company',
      participantCooperative: 'Cooperative',
      participantFoundation: 'Foundation',
      participantIndividual: 'Individual',
      participantOther: 'Other',
      participantPublicEntity: 'Public entity',
      participants: 'Participants',
      participantType: 'Participant Type',
      propertyLegalType: 'Property Legal Type',
      radius: 'Radius',
      showFilters: 'Show filters',
      stepTransactionPrice: 'Transaction Price (CHF)',
      transactionDate: 'Transaction Date',
      transactionType: 'Transaction Type',
      typeAreaPrice: 'Type, Area & Price',
      unitApartment: 'Apartment',
      unitCommercial: 'Commercial',
      unitHouse: 'House',
      unitLand: 'Land',
      unitOther: 'Other',
      unitParking: 'Parking',
      unitType: 'Unit Type',
    },
    filterPanel: {
      appliedFilter: 'Applied filter: {{name}}',
      clearAllFilters: 'Clear all filters',
      closeFilters: 'Close filters',
      failedToSave: 'Failed to save filter',
      loadSavedFilters: 'Load saved filters',
      saveCurrentFilters: 'Save current filters',
      savedFilter: 'Saved filter: {{name}}',
      savedOn: 'Saved on {{date}}',
      title: 'Transactions Filters',
    },
    filters: {
      any: 'Any',
      apply: 'Apply',
      area: 'Living Area',
      areaQuickOptions: {
        '100to150': '100-150m²',
        '50to100': '50-100m²',
        over150: 'Over 150m²',
        under50: 'Under 50m²',
      },
      areaRange: 'Living Area (m²)',
      clear: 'Clear',
      clearAll: 'Clear all filters',
      labels: {
        buyers: 'Buyers',
        city: 'City',
        district: 'District',
        floors: 'Floors',
        landArea: 'Land Area',
        legalType: 'Legal Type',
        mapSearchLocation: 'Map Search Location',
        municipality: 'Municipality',
        npa: 'NPA (Postal Code)',
        numberOfBuyers: 'Number of Buyers',
        numberOfFloors: 'Number of Floors',
        numberOfProperties: 'Number of Properties',
        numberOfRooms: 'Number of Rooms',
        numberOfSellers: 'Number of Sellers',
        participantLegalForm: 'Participant Legal Form',
        participantName: 'Participant Name',
        participantType: 'Participant Type',
        propertyPrice: 'Property Price',
        publicationDate: 'Publication Date',
        reason: 'Reason',
        region: 'Region',
        rooms: 'Rooms',
        sellers: 'Sellers',
        stepPrice: 'Step Price',
        stepTransactionPrice: 'Step Transaction Price',
        surfaceArea: 'Surface Area',
        totalPrice: 'Total Price',
        totalSurfaceArea: 'Total Surface Area',
        totalTransactionPrice: 'Total Transaction Price',
        transactionDate: 'Transaction Date',
        unitArea: 'Unit Area',
        unitType: 'Unit Type',
      },
      legalTypes: {
        BF: 'B-F - Land parcel',
        COP: 'COP - Co-ownership',
        DDP: 'DDP - Permanent right',
        DP: 'DP - Public domain',
        PPE: 'PPE - Condominium',
      },
      lessFilters: 'Less filters',
      location: 'Location',
      locationOptions: {
        geneva1205: '1205 Genève',
        genevaCanton: 'Canton of Geneva',
        genevaCity: 'City of Geneva',
        within100m: 'Within 100m',
        within1km: 'Within 1km',
        within2km: 'Within 2km',
        within300m: 'Within 300m',
        within500m: 'Within 500m',
      },
      locationSections: {
        location: 'Location',
        radius: 'Radius from property',
      },
      max: 'MAX',
      min: 'MIN',
      moreFilters: 'More filters',
      participantTypes: {
        company: 'Company',
        estate: 'Estate',
        individual: 'Individual',
        nonProfit: 'Non-Profit',
        other: 'Other',
        others: 'Others',
        publicBody: 'Public Body',
      },
      placeholders: {
        enterCity: 'Enter city name...',
        enterDistrict: 'Enter district name...',
        enterLegalForm: 'Enter legal form...',
        enterMunicipality: 'Enter municipality name...',
        enterNpa: 'Enter NPA name...',
        enterRegion: 'Enter region name...',
        from: 'From',
        max: 'Max',
        min: 'Min',
        searchParticipants: 'Search participant names...',
        to: 'To',
      },
      price: 'Price (CHF)',
      priceQuickOptions: {
        '1MTo2M': '1M - 2M',
        '500kTo1M': '500k - 1M',
        over2M: 'Over 2M',
        under500k: 'Under 500k',
      },
      priceRange: 'Price Range (CHF)',
      propertyType: 'Property Type',
      propertyTypeOptions: {
        bienFonds: 'Land parcels',
        ppe: 'Condominium ownership',
      },
      reason: 'Transaction Type',
      reasonOptions: {
        achat: 'Purchase transactions',
        donation: 'Gift transfers',
        heritage: 'Inheritance transfers',
        vente: 'Sale transactions',
      },
      sections: {
        locationDate: 'Location & Date',
        participants: 'Participants',
        price: 'Price',
        properties: 'Properties',
        propertyLocation: 'Property Location',
        transactionDetails: 'Transaction Details',
        units: 'Units',
      },
      unitTypes: {
        apartment: 'Apartment',
        balcony: 'Balcony',
        cellar: 'Cellar',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Private garage',
        singleFamily: 'Single-family home',
        storageBox: 'Storage box',
      },
      year: 'Year',
      yearOptions: {
        all: 'All time',
        last10Years: 'Last 10 years',
        last2Years: 'Last 2 years',
        last5Years: 'Last 5 years',
        lastYear: 'Last year',
      },
    },
    placeholders: {
      searchBuyers: 'Search buyers...',
      searchSellers: 'Search sellers...',
    },
    print: {
      cover: {
        generatedOn: 'Generated on {{date}}',
        subtitle: 'Comprehensive Market Analysis',
        title: 'Transaction Statistics Report',
      },
      dataSource: {
        description: 'The transaction statistics presented in this report are derived from comprehensive real estate transaction records collected from official sources. The data includes all recorded property transactions within the selected geographic area and time period.',
        lastUpdated: 'Last updated: {{date}} | Data sources: Public registries, Government databases',
        title: 'About This Data',
      },
      disclaimer: {
        dataAccuracy: {
          description: 'While every effort has been made to ensure the accuracy of the information presented in this report, Popety.io cannot guarantee the completeness or accuracy of all data. The statistics and analyses are based on available data at the time of generation and may be subject to revision.',
          title: 'Data Accuracy',
        },
        dataSources: {
          description: 'This report is based on transaction data collected from various public and private sources, including:',
          items: {
            databases: 'Real estate market databases',
            records: 'Public transaction records',
            registries: 'Official real estate registries',
            statistical: 'Government statistical offices',
          },
          title: 'Data Sources',
        },
        footer: '© {{year}} Popety.io - All rights reserved | www.popety.io',
        intellectualProperty: {
          description: 'All content in this report, including but not limited to text, graphics, charts, and data visualizations, is the property of Popety.io and is protected by copyright laws. Reproduction or distribution without written permission is prohibited.',
          title: 'Intellectual Property',
        },
        title: 'Legal Disclaimer & Data Sources',
        usageLimitations: {
          description: 'This report is provided for informational purposes only and should not be considered as:',
          items: {
            complete: 'A complete representation of all market transactions',
            guarantee: 'A guarantee of future market performance',
            investment: 'Investment advice or recommendations',
            legal: 'Legal or financial counsel',
          },
          title: 'Usage Limitations',
        },
      },
    },
    propertyTypeBadges: {
      bienFonds: 'Bien-fonds (B-F)',
      commune: 'Communauté héréditaire',
      individuelle: 'Individuelle',
      ppe: 'Propriété par étage',
    },
    propertyTypes: {
      all: 'All properties',
      bienFonds: 'Bien-fonds (B-F)',
      commune: 'Communauté héréditaire',
      individuelle: 'Individuelle',
      ppe: 'PPE',
    },
    quickFilters: {
      buyers: 'Buyers',
      city: 'City',
      district: 'District',
      floors: 'Floors',
      landArea: 'Land Area',
      legalForm: 'Legal Form',
      legalType: 'Legal Type',
      municipality: 'Municipality',
      npa: 'NPA',
      participant: 'Participant',
      participantType: 'Participant Type',
      properties: 'Properties',
      propertyPrice: 'Property Price',
      publicationDate: 'Publication Date',
      reason: 'Reason',
      region: 'Region',
      rooms: 'Rooms',
      sellers: 'Sellers',
      stepPrice: 'Step Price',
      surfaceArea: 'Surface Area',
      totalPrice: 'Total Price',
      transactionDate: 'Transaction Date',
      unitArea: 'Unit Area',
      unitType: 'Unit Type',
    },
    resultsCount: '{{count}} transactions found {{location}} {{timeframe}}',
    sections: {
      parties: 'Parties',
      propertyDetails: 'Property Details',
      transactionInfo: 'Transaction Information',
    },
    sorting: {
      distance: 'Distance',
      priceHigh: 'Price: High to Low',
      priceLow: 'Price: Low to High',
      recent: 'Most recent',
      sortBy: 'Sort by:',
    },
    stats: {
      charts: {
        geographicDistribution: {
          activeCantons: 'Active Cantons',
          avg: 'Avg',
          avgTransactionPrice: 'Avg Transaction Price',
          noData: 'No data available',
          topCitiesByVolume: 'Top Cities by Transaction Volume',
          totalMarketVolume: 'Total Market Volume',
          totalTransactions: 'Total Transactions',
          transactions: 'transactions',
          transactionsByCanton: 'Transactions by Canton',
        },
        inheritanceAnalysis: {
          donation: 'Donation',
          flowAnalysis: 'Inheritance Flow Analysis',
          flowAnalysisSubtext: 'Wealth transfer from sellers to buyers through property types',
          heritage: 'Heritage',
          inheritanceOverTime: 'Inheritance Transactions Over Time',
          inheritanceOverTimeSubtext: 'Quarterly trends by transaction type',
          noData: 'No inheritance data available',
          partage: 'Partition',
          shareDistribution: 'Share Distribution Analysis',
          shareDistributionSubtext: 'Ownership share patterns in transfers',
          transactionCount: 'Transaction Count',
          transactions: 'transactions',
        },
        marketTiming: {
          activityCalendar: 'Market Activity Calendar',
          activityCalendarSubtext: 'Transaction volume by day',
          avgLagDays: 'Average Lag (days)',
          monthlyActivity: 'Monthly Transaction Activity',
          monthlyActivitySubtext: 'Transaction volume over time',
          noActivity: 'No activity',
          noData: 'No market timing data available',
          numberOfTransactions: 'Number of Transactions',
          publicationLag: 'Publication Lag Analysis',
          publicationLagSubtext: 'Average days between transaction and publication',
          totalTransactions: 'Total Transactions',
          transactions: 'Transactions',
        },
        participantDemographics: {
          buyersByGender: 'Buyers by Gender',
          companies: 'Companies',
          companyParticipants: 'Company Participants',
          female: 'Female',
          genderDistributionOverTime: 'Buyers Gender Distribution Over Time',
          genderParity: '50% Gender Parity',
          individualParticipants: 'Individual Participants',
          individuals: 'Individuals',
          male: 'Male',
          noData: 'No data available',
          participantTypesByLegalForm: 'Participant Types by Legal Form',
          personVsCompany: 'Person vs Company Participants',
          sellersByGender: 'Sellers by Gender',
          totalBuyers: 'Total Buyers',
          totalSellers: 'Total Sellers',
        },
        priceDynamics: {
          avgTransactionPrice: 'Average Transaction Price',
          mom: 'MoM',
          noData: 'No data available',
          priceByPropertyType: 'Price by Property Type',
          priceDistribution: 'Price Distribution',
          priceVelocityIndex: 'Price Velocity Index',
          totalMarketVolume: 'Total Market Volume',
          yearlyMarketVolume: 'Yearly Market Volume',
          yoy: 'YoY',
        },
        propertyCharacteristics: {
          avgPrice: 'Average Price',
          avgSurfaceArea: 'Average Surface Area (m²)',
          avgSurfaceAreaM2: 'Average Surface Area (m²)',
          complexityIndex: 'Building Complexity Index',
          complexityIndexSubtext: 'Price and Area by Number of Floors',
          noData: 'No property characteristics data available',
          numberOfFloors: 'Number of Floors',
          performanceMatrix: 'Property Type Performance Matrix',
          performanceMatrixSubtext: 'Average Surface Area vs Average Price',
          transactions: 'Transactions',
        },
        seasonalPatterns: {
          averageTransactionCount: 'Average Transaction Count',
          month: 'Month',
          monthlyActivity: 'Monthly Transaction Activity',
          monthlyActivitySubtext: 'Volume and value trends by month',
          noData: 'No seasonal pattern data available',
          quarterlyComparison: 'Quarterly Comparison',
          quarterlyComparisonSubtext: 'Transaction volume by quarter',
          seasonalPatterns: 'Seasonal Patterns',
          seasonalPatternsSubtext: 'Average activity by month across all years',
          totalValue: 'Total Value',
          transactionCount: 'Transaction Count',
          transactions: 'Transactions',
        },
        transactionTypes: {
          averageValue: 'Average Value',
          distributionTitle: 'Distribution by Transaction Type',
          dominantType: 'Dominant Type',
          totalTransactions: 'Total Transactions',
          totalVolume: 'Total Volume',
          trendsTitle: 'Temporal Evolution',
        },
        unitComposition: {
          averageArea: 'Average Area',
          noData: 'No unit composition data available',
          numberOfRooms: 'Number of Rooms',
          numberOfUnits: 'Number of Units',
          room: 'Room',
          roomDistribution: 'Room Distribution',
          roomDistributionSubtext: 'Number of Units by Room Count',
          rooms: 'Rooms',
          units: 'units',
          unitTypeComposition: 'Unit Type Composition',
          unitTypeCompositionSubtext: 'Size represents unit count, color represents average area',
        },
      },
      description: 'Transaction statistics and analytics will be available here soon.',
      errors: {
        loadFailed: 'Failed to load statistics',
        loginRequired: 'Please log in to view transaction statistics',
        noData: 'No data available for the selected criteria',
        noTransactionData: 'No transaction data available',
        retryError: 'Failed to load statistics. Please try again.',
      },
      indicators: {
        allProperties: 'All Properties',
        allSwitzerland: 'All Switzerland',
        location: 'Location',
        type: 'Type',
      },
      periods: {
        all: 'Full history',
        last12Months: 'Last 12 months',
        since2022: 'Since January 2022',
      },
      sections: {
        geographicDistribution: {
          description: 'Explore transaction patterns across different regions and municipalities.',
          title: 'Geographic Distribution',
        },
        inheritanceAnalysis: {
          description: 'Analyze heritage, donation, and wealth transfer patterns including flow analysis and ownership shares.',
          title: 'Inheritance & Wealth Transfer',
        },
        marketTiming: {
          description: 'Analyze publication lag, market activity patterns, and transaction velocity over time.',
          title: 'Market Timing & Velocity',
        },
        participantDemographics: {
          description: 'Understand buyer and seller profiles, demographics, and transaction patterns.',
          title: 'Participant Demographics',
        },
        priceDynamics: {
          description: 'Track key pricing metrics including average transaction prices, price per square meter, and market volume trends.',
          title: 'Price Dynamics',
        },
        propertyCharacteristics: {
          description: 'Analyze property types, building complexity, unit distribution, and physical characteristics.',
          title: 'Property Characteristics',
        },
        seasonalPatterns: {
          description: 'Explore seasonal trends, monthly activity patterns, and quarterly comparisons over time.',
          title: 'Seasonal & Temporal Patterns',
        },
        transactionTypes: {
          description: 'Analyze the distribution of different transaction types to understand market dynamics and patterns.',
          title: 'Transaction Types',
        },
        unitComposition: {
          description: 'Explore unit types, room distribution, and floor-level analysis of residential properties.',
          title: 'Unit Composition',
        },
      },
    },
    subtitle: 'Historic real estate transactions found in the neighborhood',
    title: 'Transactions',
    tooltip: {
      additionalProperties: '(+{{count}} properties)',
      area: 'Area',
      buyersSellers: '{{buyers}} buyers / {{sellers}} sellers',
      date: 'Date',
      parcel: 'Parcel {{code}} {{city}}',
      parties: 'Parties',
      price: 'Price',
      pricePerM2: 'Price/m²',
      properties: '{{count}} properties',
      property: '1 property',
      transactionNumber: 'Transaction #{{id}}',
      type: 'Type',
      unknownLocation: 'Unknown location',
    },
    transactionTypes: {
      achat: 'Achat',
      all: 'All types',
      donation: 'Donation',
      exchange: 'Exchange',
      heritage: 'Héritage',
      vente: 'Vente',
    },
  },
  transport: {
    emptyStates: {
      noBuilding: 'No building data available',
      noEstimate: 'No building data available for transport & access analysis',
      noLand: 'No land data available',
    },
    evCharging: {
      charger: {
        plural: 'chargers',
        singular: 'charger',
      },
      chargingTypes: {
        fast: 'Fast Charging',
        medium: 'Medium Charging',
        standard: 'Standard Charging',
      },
      metrics: {
        fastCharging: {
          title: 'Fast Charging',
        },
        freeAccess: {
          title: 'Free Access',
        },
        nearestStation: {
          title: 'Nearest Station',
        },
        totalStations5km: {
          title: 'Total Stations (5km)',
        },
      },
      more: '+{{count}} more',
      nearbyStations: 'Nearby Charging Stations',
      overview: 'EV Charging Overview',
      plugTypes: {
        ccsCombo2: 'CCS Combo 2 Plug (Cable Attached)',
        chademo: 'CHAdeMO',
        schuko: 'Schuko',
        type1Connector: 'Type 1 Connector (Cable Attached)',
        type1Outlet: 'Type 1 Outlet',
        type2Connector: 'Type 2 Connector (Cable Attached)',
        type2Outlet: 'Type 2 Outlet',
        unknown: 'Unknown',
      },
      unknownOperator: 'Unknown Operator',
    },
    header: {
      scoreLabel: 'PT score',
      scoreTooltip: 'Overall transport accessibility score based on public transport, road access, and active mobility options',
      subtitle: 'Comprehensive analysis of transportation infrastructure and accessibility',
      title: 'Transport & Access',
    },
    overview: {
      class: 'Class',
      keyMetrics: 'Key Metrics',
      metrics: {
        cyclingRoutes: {
          subtext: 'Within 2km radius',
          title: 'Cycling Routes',
        },
        evCharging: {
          title: 'EV Charging',
        },
        highwayAccess: {
          title: 'Highway Access',
        },
        mainRoad: {
          title: 'Main Road',
        },
        nearestBusStop: {
          title: 'Nearest Bus Stop',
        },
        nearestTrainStation: {
          title: 'Nearest Train Station',
        },
        ptQualityClass: {
          title: 'PT Quality Class',
        },
        stopsWithin500m: {
          subtext: 'Public transport stops',
          title: 'Stops Within 500m',
        },
      },
    },
    publicTransport: {
      everyMinutes_one: 'every minute',
      everyMinutes_other: 'every {{minutes}} min',
      metrics: {
        busStops: {
          title: 'Bus Stops',
        },
        qualityClass: {
          none: 'No quality class',
          title: 'Quality Class',
        },
        stopsUnder500m: {
          title: 'Stops < 500m',
        },
        totalStops1km: {
          title: 'Total Stops (1km)',
        },
        trainStations: {
          title: 'Train Stations',
        },
        tramStops: {
          title: 'Tram Stops',
        },
      },
      nearbyStops: 'Nearby Stops',
      noStopsFound: 'No public transport stops found within 1.5km',
      overview: 'Public Transport Overview',
      stopTypes: {
        bus: 'Bus',
        other: 'Other',
        train: 'Train',
        tram: 'Tram',
      },
      unknownOperator: 'Unknown Operator',
      unknownStop: 'Unknown Stop',
    },
    scores: {
      activeMobility: {
        description: 'Evaluates walking, cycling infrastructure, and e-mobility options (EV charging stations, bike-sharing) around the property.',
        title: 'Active Mobility',
        tooltip: {
          shortDescription: 'Active Mobility accessibility score',
        },
      },
      common: {
        calculation: 'Weighted average of multiple factors',
        importance: 'Higher scores indicate better accessibility',
        outOf100: '/ 100',
        source: 'Swiss Geo Admin & Mapbox APIs',
      },
      details: {
        cycling: 'Cycling',
        diversity: 'Diversity',
        eMobility: 'E-Mobility',
        frequency: 'Frequency',
        highwayAccess: 'Highway Access',
        mainRoadDistance: 'Main Road Distance',
        proximity: 'Proximity',
      },
      publicTransport: {
        title: 'Public Transport',
        tooltip: {
          shortDescription: 'Public Transport accessibility score',
        },
      },
      qualityClassDescriptions: {
        A: 'Very good public transport connection',
        B: 'Good public transport connection',
        C: 'Moderate public transport connection',
        D: 'Basic public transport connection',
        E: 'Limited public transport connection',
        F: 'Poor or no public transport connection',
        unknown: 'No data available',
      },
      qualityClassLabels: {
        A: 'Excellent',
        B: 'Good',
        C: 'Moderate',
        D: 'Basic',
        E: 'Limited',
        F: 'Poor',
        unknown: 'Unknown',
      },
      roadAccess: {
        title: 'Road Access',
        tooltip: {
          shortDescription: 'Road Access accessibility score',
        },
      },
      scoreLabels: {
        basic: 'Basic',
        excellent: 'Excellent',
        good: 'Good',
        limited: 'Limited',
        moderate: 'Moderate',
        poor: 'Poor',
        unknown: 'Unknown',
      },
    },
    states: {
      error: 'Failed to load transport data. Please try again.',
      loading: 'Loading transport data...',
      noData: 'No transport data available',
    },
    tabs: {
      evCharging: 'EV Charging',
      overview: 'Overview',
      publicTransport: 'Public Transport',
    },
    units: {
      kilometers: 'km',
      kw: 'kW',
      meters: 'm',
      na: 'N/A',
    },
  },
  valuations: {
    chart: {
      estimated_value: 'Estimated Value',
      final_value: 'Final Value',
      hide_from_chart: 'Hide from chart',
      range: 'Range',
      show_in_chart: 'Show in chart',
      value: 'Value',
      value_range: 'Value Range',
      variance: 'Variance',
    },
    confidence: {
      high: 'High',
      high_confidence: 'High Confidence',
      low: 'Low',
      low_confidence: 'Low Confidence',
      medium: 'Medium',
      medium_confidence: 'Medium Confidence',
    },
    fields: {
      automated_valuation: 'Automated Valuation',
      average_estimate: 'Average Estimate',
      avm: 'AVM',
      building_year: 'Building Year',
      confidence_level: 'Confidence Level',
      confidence_score: 'Confidence Score',
      conservative: 'Conservative',
      conservative_estimate: 'Conservative Estimate',
      currency: 'Currency',
      data_range: 'Data Range',
      deal_type: 'Deal Type',
      listings_count: 'Listings Count',
      living_area: 'Living Area',
      market_value_type: 'Market Value Type',
      method: 'Method',
      model_version: 'Model Version',
      number_of_rooms: 'Number of Rooms',
      optimistic: 'Optimistic',
      optimistic_estimate: 'Optimistic Estimate',
      price_per_sqm: 'Price per m²',
      property_type: 'Property Type',
      scenario: 'Scenario',
      status: 'Status',
      value_before_correction: 'Value Before Correction',
    },
    loading: 'Loading valuations...',
    no_data: 'No valuation data available',
    no_valuations: 'No valuations available',
    providers: {
      manual: {
        name: 'Custom Valuation',
      },
      popety_io: {
        description: "Automated valuation based on Popety.io's proprietary algorithm analyzing property characteristics, recent market transactions, and location-specific factors.",
        name: 'Popety.io Valuation',
      },
      pricehubble: {
        description: 'Automated valuation using PriceHubble AVM method based on machine learning algorithms and comprehensive market data.',
        name: 'PriceHubble Valuation',
      },
      wuest_partner: {
        conservative_description: 'Conservative automated valuation using Wüest Partner methodology.',
        description: 'Automated valuation using Wüest Partner methodology with market range from conservative to optimistic scenarios.',
        name: 'Wüest Partner Valuation',
        optimistic_description: 'Optimistic automated valuation using Wüest Partner methodology.',
      },
    },
  },
  zoning: {
    buildable: 'Buildable',
    cancel: 'Cancel',
    developingArea: 'Developing Area',
    documents: {
      clearSearchAriaLabel: 'Clear search',
      documentTypes: {
        map: 'Map',
        rule: 'Regulation',
      },
      important: 'Important',
      loading: 'Loading documents...',
      modalTitle: 'Zone Documents',
      noDocuments: 'No documents available',
      noDocumentSelected: 'No Document Selected',
      noPreviewAvailable: 'No Preview Available',
      noPreviewHint: 'This document does not have a PDF preview URL available',
      searchAriaLabel: 'Search documents',
      searchPlaceholder: 'Search documents...',
      selectDocumentHint: 'Select a document from the list to view its contents',
      sourceLabels: {
        country: 'Federal',
        lup: 'Communal Plan',
        lupa: 'Local Plan',
        lupc: 'Cantonal Plan',
        lupo: 'Overlay Plan',
        region: 'Cantonal',
      },
      sourceTitles: {
        country: 'Federal Documents (Switzerland)',
        lup: 'Communal Plan Documents',
        lupa: 'Local Plan Documents',
        lupc: 'Cantonal Plan Documents',
        lupo: 'Overlay Plan Documents',
        region: 'Cantonal Documents',
      },
      title: 'Documents',
      view: 'View',
    },
    edit: 'Edit',
    header: {
      abrogated: 'Abrogated',
      adopted: 'Adopted',
      buildingArea: 'Building Area',
      constructionArrangement: 'Construction Arrangement',
      constructionArrangementValues: {
        C: 'Contiguous',
        'C / NC': 'Contiguous / Non-contiguous',
        NC: 'Non-contiguous',
      },
      nonBuildingArea: 'Non-Building Area',
      plotCoverage: 'of plot',
      purpose: 'Purpose',
    },
    legalNotice: {
      blackText: 'Black text indicates exact values directly extracted from the PGA or the land register.',
      blueText: 'Blue text indicates estimated values calculated by PROPETY.IO algorithms.',
      disclaimer: 'While we strive to provide the most accurate data possible, all information should be independently verified. Please consult the official documents and contact the planning department of the commune concerned for official confirmation.',
      greenText: 'Green text indicates values modified by you.',
      title: 'Data Sources:',
    },
    legend: {
      agreement: {
        conflict: 'Sources in conflict',
        conflictNote: '(strikethrough = non-retained value)',
        identical: 'Identical sources',
        title: 'Source Agreement',
        unique: 'Unique source',
      },
      authorizedValues: {
        clickForDetails: 'Click for details',
        notAvailable: 'Not available',
        title: 'Authorized Values',
      },
      difference: {
        exceeded: 'Exceeded',
        remaining: 'Remaining potential',
        title: 'Difference',
      },
      sources: {
        algorithm: 'Algorithmic estimate',
        geoportal: 'Official geoportal',
        manual: 'Manually replaced',
        regulation: 'Extracted from regulation',
        title: 'Data Sources',
        userEdit: 'Replaced by user',
      },
      title: 'Legend',
    },
    messages: {
      error: 'Failed to load zoning data',
      loading: 'Loading zoning data...',
      noData: 'No zoning data available for this land',
      noZonesForType: 'No zones found for this type',
      sectionDescription: 'Zoning regulations and development potential for this land parcel',
    },
    metricLabels: {
      altitude: 'Altitude',
      atticFloors: 'Attic Floors',
      bigSetback: 'Big Setback',
      buildingDepth: 'Building Depth',
      commercialRatio: 'Commercial Ratio',
      constructionArrangement: 'Construction Arrangement',
      cos: 'Building Coverage Coefficient (BCC)',
      cus: 'Floor Area Coefficient (FAC)',
      density: 'Density',
      distanceLimit: 'Distance Limit',
      greenRatio: 'Green Ratio',
      heightWithoutRoof: 'Height w/o Roof',
      ibus: 'Gross Floor Area Ratio (GFAR)',
      im: 'Building Volume Ratio (BVR)',
      ios: 'Building Coverage Ratio (BCR)',
      ius: 'Floor Area Ratio (FAR)',
      livingRatio: 'Living Ratio',
      mainFloors: 'Main Floors',
      maxLength: 'Max Length',
      noiseSensitivityLevel: 'Noise Sensitivity Level',
      numberOfUnits: 'Number of Units',
      officeRatio: 'Office Ratio',
      openSpaceRatio: 'Open Space Ratio',
      roofHeight: 'Roof Height',
      roofSlope: 'Roof Slope',
      smallSetback: 'Small Setback',
      totalFloors: 'Total Floors',
      totalHeight: 'Total Height',
      undergroundFloors: 'Underground Floors',
      vbr: 'Reference Building Volume (RBV)',
    },
    metrics: {
      authorised: 'Authorised',
      current: 'Current',
      determiningBuiltArea: 'Determining built area (DBA)',
      determiningBuiltAreaInfo: 'Determining built area',
      determiningFloorArea: 'Determining floor area (DFA)',
      determiningFloorAreaInfo: 'Determining floor area',
      determiningSurfaceArea: 'Determining land area (DLA)',
      difference: 'Difference',
      landOccupationIndex: 'Building coverage ratio (BCR)',
      landOccupationIndexInfo: 'Building coverage ratio',
      landUseIndex: 'Floor area ratio (FAR)',
      landUseIndexInfo: 'Floor area ratio',
    },
    metricsTable: {
      confirmReset: 'Are you sure you want to reset all values to defaults? This action cannot be undone.',
      derivedSurfaces: {
        builtArea: 'Built area (BA)',
        builtAreaDesc: 'Built area',
        builtVolume: 'Reference building volume (RBV)',
        builtVolumeDesc: 'Reference building volume',
        determiningBuiltArea: 'Determining built area (DBA)',
        determiningBuiltAreaDesc: 'Determining built area',
        determiningFloorArea: 'Determining floor area (DFA)',
        determiningFloorAreaDesc: 'Determining floor area',
        floorArea: 'Floor area (FA)',
        floorAreaDesc: 'Floor area',
        grossUsefulFloorArea: 'Gross usable floor area (GUFA)',
        grossUsefulFloorAreaDesc: 'Gross usable floor area',
      },
      editAuthorizedValues: 'Edit Authorized Values',
      groups: {
        environmental: 'ENVIRONMENTAL',
        floors: 'FLOORS',
        heights: 'HEIGHTS',
        other: 'OTHER',
        setbacks: 'SETBACKS & DIMENSIONS',
        usageRatios: 'USAGE RATIOS',
      },
      headers: {
        authorized: 'Authorized',
        current: 'Current',
        difference: 'Difference',
        indices: 'Indices',
      },
      noneOption: 'None (hide this metric)',
      resetToDefault: 'Reset to Default',
      saveChanges: 'Save Changes',
      title: 'Zoning Metrics',
      unitLabels: {
        floors: 'floors',
        units: 'units',
      },
    },
    metricsTitle: 'Surfaces & Indices',
    parameters: {
      limitDistances: 'Limit distances',
      maxFloor: 'Max Floor',
      maxHeight: 'Max Height',
      noiseSensibilityLevel: 'Noise sensibility level',
    },
    planDetails: {
      affectationName: 'Affectation Name',
      part: 'Part',
      planName: 'Plan Name',
      planType: 'Plan Type',
    },
    progressBar: {
      authorized: 'Authorized',
      available: 'Available',
      currentSituation: 'Current situation',
      remainingPotential: 'Remaining Potential',
      used: 'Used',
      utilization: 'Utilization',
    },
    purpose: 'Purpose',
    save: 'Save',
    sourceLabels: {
      estimate: 'Estimated',
      geoportal: 'Geoportal',
      llm: 'AI Generated',
      manual: 'Manual',
      old: 'Legacy',
    },
    specialPlans: 'Special plan(s)',
    status: {
      current: 'Current',
      future: 'Future',
      past: 'Past',
    },
    subtitle: 'Current zoning regulations and development potential for',
    title: 'Zoning & Rules',
    underExploited: 'Under-Exploited',
    underExploitedInfo: 'Calculation based on an informed floor area ratio',
    underExploitedScore: 'Under exploited score',
    unknownZone: 'Unknown zone',
    viewDocuments: 'View documents',
    zoneDescriptions: {
      cantonal: 'Cantonal zoning regulations (PAC, Kantonaler Nutzungsplan) set by regional authorities. These rules take absolute precedence over all municipal plans and define overarching development constraints such as protected areas, regional infrastructure corridors, and cantonal interests.',
      general: 'Municipal base zoning (PGA, PAL, BZO, Nutzungszonenplan) that establishes the fundamental land use category for this parcel, defining whether it is designated for residential, commercial, industrial, agricultural use, or is a non-building zone.',
      local: 'Detailed neighborhood development plans (PQ, PLQ, Quartierplan, Gestaltungsplan) that specify precise construction requirements including building placement, dimensions, access, and design guidelines for specific districts within the municipality.',
      partial: 'Special overlay zones (PPA, Sondernutzungsplan, GFAR zones) that apply additional restrictions or modifications on top of base zoning. These can include heritage protection, modified density ratios, environmental constraints, or specific development requirements.',
    },
    zonePriorityLabels: {
      cantonal: 'Cantonal Authority - Overrides All',
      general: 'Base Zoning - Fundamental Land Use',
      local: 'Detailed Planning - Neighborhood Rules',
      partial: 'Special Zones - Additional Restrictions',
    },
    zoneTypes: {
      cantonal: 'Cantonal',
      general: 'Communal',
      local: 'Local',
      partial: 'Partial',
    },
  },
}
